var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/tslib/tslib.js"(exports, module) {
    var __extends2;
    var __assign2;
    var __rest2;
    var __decorate2;
    var __param2;
    var __metadata2;
    var __awaiter2;
    var __generator2;
    var __exportStar2;
    var __values2;
    var __read2;
    var __spread2;
    var __spreadArrays2;
    var __spreadArray2;
    var __await2;
    var __asyncGenerator2;
    var __asyncDelegator2;
    var __asyncValues2;
    var __makeTemplateObject2;
    var __importStar2;
    var __importDefault2;
    var __classPrivateFieldGet2;
    var __classPrivateFieldSet2;
    var __classPrivateFieldIn2;
    var __createBinding2;
    (function(factory) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
      } else {
        factory(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v4) {
          return exports2[id] = previous ? previous(id, v4) : v4;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d9, b3) {
        d9.__proto__ = b3;
      } || function(d9, b3) {
        for (var p5 in b3)
          if (Object.prototype.hasOwnProperty.call(b3, p5))
            d9[p5] = b3[p5];
      };
      __extends2 = function(d9, b3) {
        if (typeof b3 !== "function" && b3 !== null)
          throw new TypeError("Class extends value " + String(b3) + " is not a constructor or null");
        extendStatics(d9, b3);
        function __() {
          this.constructor = d9;
        }
        d9.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
      };
      __assign2 = Object.assign || function(t18) {
        for (var s8, i6 = 1, n7 = arguments.length; i6 < n7; i6++) {
          s8 = arguments[i6];
          for (var p5 in s8)
            if (Object.prototype.hasOwnProperty.call(s8, p5))
              t18[p5] = s8[p5];
        }
        return t18;
      };
      __rest2 = function(s8, e16) {
        var t18 = {};
        for (var p5 in s8)
          if (Object.prototype.hasOwnProperty.call(s8, p5) && e16.indexOf(p5) < 0)
            t18[p5] = s8[p5];
        if (s8 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i6 = 0, p5 = Object.getOwnPropertySymbols(s8); i6 < p5.length; i6++) {
            if (e16.indexOf(p5[i6]) < 0 && Object.prototype.propertyIsEnumerable.call(s8, p5[i6]))
              t18[p5[i6]] = s8[p5[i6]];
          }
        return t18;
      };
      __decorate2 = function(decorators, target, key, desc) {
        var c8 = arguments.length, r18 = c8 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d9;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r18 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i6 = decorators.length - 1; i6 >= 0; i6--)
            if (d9 = decorators[i6])
              r18 = (c8 < 3 ? d9(r18) : c8 > 3 ? d9(target, key, r18) : d9(target, key)) || r18;
        return c8 > 3 && r18 && Object.defineProperty(target, key, r18), r18;
      };
      __param2 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata2 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter2 = function(thisArg, _arguments, P3, generator) {
        function adopt(value) {
          return value instanceof P3 ? value : new P3(function(resolve) {
            resolve(value);
          });
        }
        return new (P3 || (P3 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e16) {
              reject(e16);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e16) {
              reject(e16);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator2 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t18[0] & 1)
            throw t18[1];
          return t18[1];
        }, trys: [], ops: [] }, f7, y2, t18, g3;
        return g3 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g3[Symbol.iterator] = function() {
          return this;
        }), g3;
        function verb(n7) {
          return function(v4) {
            return step([n7, v4]);
          };
        }
        function step(op) {
          if (f7)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f7 = 1, y2 && (t18 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t18 = y2["return"]) && t18.call(y2), 0) : y2.next) && !(t18 = t18.call(y2, op[1])).done)
                return t18;
              if (y2 = 0, t18)
                op = [op[0] & 2, t18.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t18 = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t18 = _.trys, t18 = t18.length > 0 && t18[t18.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t18 || op[1] > t18[0] && op[1] < t18[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t18[1]) {
                    _.label = t18[1];
                    t18 = op;
                    break;
                  }
                  if (t18 && _.label < t18[2]) {
                    _.label = t18[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t18[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e16) {
              op = [6, e16];
              y2 = 0;
            } finally {
              f7 = t18 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar2 = function(m5, o17) {
        for (var p5 in m5)
          if (p5 !== "default" && !Object.prototype.hasOwnProperty.call(o17, p5))
            __createBinding2(o17, m5, p5);
      };
      __createBinding2 = Object.create ? function(o17, m5, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        var desc = Object.getOwnPropertyDescriptor(m5, k2);
        if (!desc || ("get" in desc ? !m5.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m5[k2];
          } };
        }
        Object.defineProperty(o17, k22, desc);
      } : function(o17, m5, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o17[k22] = m5[k2];
      };
      __values2 = function(o17) {
        var s8 = typeof Symbol === "function" && Symbol.iterator, m5 = s8 && o17[s8], i6 = 0;
        if (m5)
          return m5.call(o17);
        if (o17 && typeof o17.length === "number")
          return {
            next: function() {
              if (o17 && i6 >= o17.length)
                o17 = void 0;
              return { value: o17 && o17[i6++], done: !o17 };
            }
          };
        throw new TypeError(s8 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read2 = function(o17, n7) {
        var m5 = typeof Symbol === "function" && o17[Symbol.iterator];
        if (!m5)
          return o17;
        var i6 = m5.call(o17), r18, ar = [], e16;
        try {
          while ((n7 === void 0 || n7-- > 0) && !(r18 = i6.next()).done)
            ar.push(r18.value);
        } catch (error) {
          e16 = { error };
        } finally {
          try {
            if (r18 && !r18.done && (m5 = i6["return"]))
              m5.call(i6);
          } finally {
            if (e16)
              throw e16.error;
          }
        }
        return ar;
      };
      __spread2 = function() {
        for (var ar = [], i6 = 0; i6 < arguments.length; i6++)
          ar = ar.concat(__read2(arguments[i6]));
        return ar;
      };
      __spreadArrays2 = function() {
        for (var s8 = 0, i6 = 0, il = arguments.length; i6 < il; i6++)
          s8 += arguments[i6].length;
        for (var r18 = Array(s8), k2 = 0, i6 = 0; i6 < il; i6++)
          for (var a5 = arguments[i6], j = 0, jl = a5.length; j < jl; j++, k2++)
            r18[k2] = a5[j];
        return r18;
      };
      __spreadArray2 = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i6 = 0, l8 = from.length, ar; i6 < l8; i6++) {
            if (ar || !(i6 in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i6);
              ar[i6] = from[i6];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await2 = function(v4) {
        return this instanceof __await2 ? (this.v = v4, this) : new __await2(v4);
      };
      __asyncGenerator2 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g3 = generator.apply(thisArg, _arguments || []), i6, q = [];
        return i6 = {}, verb("next"), verb("throw"), verb("return"), i6[Symbol.asyncIterator] = function() {
          return this;
        }, i6;
        function verb(n7) {
          if (g3[n7])
            i6[n7] = function(v4) {
              return new Promise(function(a5, b3) {
                q.push([n7, v4, a5, b3]) > 1 || resume(n7, v4);
              });
            };
        }
        function resume(n7, v4) {
          try {
            step(g3[n7](v4));
          } catch (e16) {
            settle(q[0][3], e16);
          }
        }
        function step(r18) {
          r18.value instanceof __await2 ? Promise.resolve(r18.value.v).then(fulfill, reject) : settle(q[0][2], r18);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f7, v4) {
          if (f7(v4), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator2 = function(o17) {
        var i6, p5;
        return i6 = {}, verb("next"), verb("throw", function(e16) {
          throw e16;
        }), verb("return"), i6[Symbol.iterator] = function() {
          return this;
        }, i6;
        function verb(n7, f7) {
          i6[n7] = o17[n7] ? function(v4) {
            return (p5 = !p5) ? { value: __await2(o17[n7](v4)), done: n7 === "return" } : f7 ? f7(v4) : v4;
          } : f7;
        }
      };
      __asyncValues2 = function(o17) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m5 = o17[Symbol.asyncIterator], i6;
        return m5 ? m5.call(o17) : (o17 = typeof __values2 === "function" ? __values2(o17) : o17[Symbol.iterator](), i6 = {}, verb("next"), verb("throw"), verb("return"), i6[Symbol.asyncIterator] = function() {
          return this;
        }, i6);
        function verb(n7) {
          i6[n7] = o17[n7] && function(v4) {
            return new Promise(function(resolve, reject) {
              v4 = o17[n7](v4), settle(resolve, reject, v4.done, v4.value);
            });
          };
        }
        function settle(resolve, reject, d9, v4) {
          Promise.resolve(v4).then(function(v5) {
            resolve({ value: v5, done: d9 });
          }, reject);
        }
      };
      __makeTemplateObject2 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o17, v4) {
        Object.defineProperty(o17, "default", { enumerable: true, value: v4 });
      } : function(o17, v4) {
        o17["default"] = v4;
      };
      __importStar2 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (k2 !== "default" && Object.prototype.hasOwnProperty.call(mod, k2))
              __createBinding2(result, mod, k2);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault2 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f7) {
        if (kind === "a" && !f7)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f7 : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f7 : kind === "a" ? f7.call(receiver) : f7 ? f7.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f7) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f7)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f7 : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f7.call(receiver, value) : f7 ? f7.value = value : state.set(receiver, value), value;
      };
      __classPrivateFieldIn2 = function(state, receiver) {
        if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
      };
      exporter("__extends", __extends2);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate2);
      exporter("__param", __param2);
      exporter("__metadata", __metadata2);
      exporter("__awaiter", __awaiter2);
      exporter("__generator", __generator2);
      exporter("__exportStar", __exportStar2);
      exporter("__createBinding", __createBinding2);
      exporter("__values", __values2);
      exporter("__read", __read2);
      exporter("__spread", __spread2);
      exporter("__spreadArrays", __spreadArrays2);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await2);
      exporter("__asyncGenerator", __asyncGenerator2);
      exporter("__asyncDelegator", __asyncDelegator2);
      exporter("__asyncValues", __asyncValues2);
      exporter("__makeTemplateObject", __makeTemplateObject2);
      exporter("__importStar", __importStar2);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
    });
  }
});

// src/Banner.js
import React3 from "react";
import PropTypes2 from "prop-types";
import styled3 from "styled-components";

// src/Link.js
import React2 from "react";
import styled2 from "styled-components";
import { Link as RouterLink } from "react-router-dom";

// src/Icon.js
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// src/lib/easing.js
var createEasing = (delay) => (...properties) => properties.map((property) => `${property} ${delay}ms ease-in-out`).join(",");
var easing = createEasing(200);

// src/lib/register-icons.js
import { dom, library } from "@fortawesome/fontawesome-svg-core-legacy";
import { faAndroid } from "@fortawesome/free-brands-svg-icons-legacy/faAndroid";
import { faAngular } from "@fortawesome/free-brands-svg-icons-legacy/faAngular";
import { faApple } from "@fortawesome/free-brands-svg-icons-legacy/faApple";
import { faCcVisa } from "@fortawesome/free-brands-svg-icons-legacy/faCcVisa";
import { faCcMastercard } from "@fortawesome/free-brands-svg-icons-legacy/faCcMastercard";
import { faCcStripe } from "@fortawesome/free-brands-svg-icons-legacy/faCcStripe";
import { faEmber } from "@fortawesome/free-brands-svg-icons-legacy/faEmber";
import { faPhp } from "@fortawesome/free-brands-svg-icons-legacy/faPhp";
import { faPython } from "@fortawesome/free-brands-svg-icons-legacy/faPython";
import { faReact } from "@fortawesome/free-brands-svg-icons-legacy/faReact";
import { faVuejs } from "@fortawesome/free-brands-svg-icons-legacy/faVuejs";
import { faStripe } from "@fortawesome/free-brands-svg-icons-legacy/faStripe";
import { faAdjust } from "@fortawesome/free-solid-svg-icons-legacy/faAdjust";
import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons-legacy/faAngleDoubleDown";
import { faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons-legacy/faAngleDoubleUp";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons-legacy/faAngleDown";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons-legacy/faAngleRight";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons-legacy/faAngleUp";
import { faArchive } from "@fortawesome/free-solid-svg-icons-legacy/faArchive";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons-legacy/faArrowDown";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons-legacy/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons-legacy/faArrowRight";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons-legacy/faArrowUp";
import { faArrowsAltH } from "@fortawesome/free-solid-svg-icons-legacy/faArrowsAltH";
import { faArrowsAltV } from "@fortawesome/free-solid-svg-icons-legacy/faArrowsAltV";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons-legacy/faAsterisk";
import { faBan } from "@fortawesome/free-solid-svg-icons-legacy/faBan";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons-legacy/faBookOpen";
import { faBullseye } from "@fortawesome/free-solid-svg-icons-legacy/faBullseye";
import { faCalculator } from "@fortawesome/free-solid-svg-icons-legacy/faCalculator";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons-legacy/faCalendarAlt";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons-legacy/faCameraRetro";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons-legacy/faCaretDown";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons-legacy/faCaretUp";
import { faChartBar } from "@fortawesome/free-solid-svg-icons-legacy/faChartBar";
import { faChartLine } from "@fortawesome/free-solid-svg-icons-legacy/faChartLine";
import { faCheck } from "@fortawesome/free-solid-svg-icons-legacy/faCheck";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons-legacy/faCheckCircle";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons-legacy/faCheckSquare";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons-legacy/faChevronDown";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons-legacy/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons-legacy/faChevronRight";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons-legacy/faChevronUp";
import { faCircle } from "@fortawesome/free-solid-svg-icons-legacy/faCircle";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons-legacy/faCircleNotch";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons-legacy/faClipboardCheck";
import { faClock } from "@fortawesome/free-solid-svg-icons-legacy/faClock";
import { faClone } from "@fortawesome/free-solid-svg-icons-legacy/faClone";
import { faCode } from "@fortawesome/free-solid-svg-icons-legacy/faCode";
import { faCog } from "@fortawesome/free-solid-svg-icons-legacy/faCog";
import { faColumns } from "@fortawesome/free-solid-svg-icons-legacy/faColumns";
import { faComment } from "@fortawesome/free-solid-svg-icons-legacy/faComment";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons-legacy/faCommentAlt";
import { faCopy } from "@fortawesome/free-solid-svg-icons-legacy/faCopy";
import { faDesktop } from "@fortawesome/free-solid-svg-icons-legacy/faDesktop";
import { faDownload } from "@fortawesome/free-solid-svg-icons-legacy/faDownload";
import { faEdit } from "@fortawesome/free-solid-svg-icons-legacy/faEdit";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons-legacy/faEllipsisH";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons-legacy/faEnvelope";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons-legacy/faExchangeAlt";
import { faExclamation } from "@fortawesome/free-solid-svg-icons-legacy/faExclamation";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons-legacy/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons-legacy/faExclamationTriangle";
import { faExpand } from "@fortawesome/free-solid-svg-icons-legacy/faExpand";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons-legacy/faExternalLinkAlt";
import { faEye } from "@fortawesome/free-solid-svg-icons-legacy/faEye";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons-legacy/faFileAlt";
import { faFileExport } from "@fortawesome/free-solid-svg-icons-legacy/faFileExport";
import { faFlag } from "@fortawesome/free-solid-svg-icons-legacy/faFlag";
import { faFlask } from "@fortawesome/free-solid-svg-icons-legacy/faFlask";
import { faFont } from "@fortawesome/free-solid-svg-icons-legacy/faFont";
import { faGem } from "@fortawesome/free-solid-svg-icons-legacy/faGem";
import { faGlobe } from "@fortawesome/free-solid-svg-icons-legacy/faGlobe";
import { faGripVertical } from "@fortawesome/pro-solid-svg-icons/faGripVertical";
import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons/faGripDotsVertical";
import { faHistory } from "@fortawesome/free-solid-svg-icons-legacy/faHistory";
import { faImage } from "@fortawesome/free-solid-svg-icons-legacy/faImage";
import { faInfo } from "@fortawesome/free-solid-svg-icons-legacy/faInfo";
import { faInfoCircle as faInfoCircle2 } from "@fortawesome/free-solid-svg-icons-legacy/faInfoCircle";
import { faKey } from "@fortawesome/free-solid-svg-icons-legacy/faKey";
import { faLevelDownAlt } from "@fortawesome/free-solid-svg-icons-legacy/faLevelDownAlt";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons-legacy/faLightbulb";
import { faList } from "@fortawesome/free-solid-svg-icons-legacy/faList";
import { faLock } from "@fortawesome/free-solid-svg-icons-legacy/faLock";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons-legacy/faLongArrowAltRight";
import { faMagic } from "@fortawesome/free-solid-svg-icons-legacy/faMagic";
import { faMap } from "@fortawesome/free-solid-svg-icons-legacy/faMap";
import { faMinus } from "@fortawesome/free-solid-svg-icons-legacy/faMinus";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons-legacy/faMinusCircle";
import { faPalette } from "@fortawesome/free-solid-svg-icons-legacy/faPalette";
import { faPen } from "@fortawesome/free-solid-svg-icons-legacy/faPen";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons-legacy/faPencilAlt";
import { faPlus } from "@fortawesome/free-solid-svg-icons-legacy/faPlus";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons-legacy/faPlusCircle";
import { faPrint } from "@fortawesome/free-solid-svg-icons-legacy/faPrint";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons-legacy/faQuestionCircle";
import { faRocket } from "@fortawesome/free-solid-svg-icons-legacy/faRocket";
import { faSearch } from "@fortawesome/free-solid-svg-icons-legacy/faSearch";
import { faShare } from "@fortawesome/free-solid-svg-icons-legacy/faShare";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons-legacy/faSignOutAlt";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons-legacy/faSlidersH";
import { faSort } from "@fortawesome/free-solid-svg-icons-legacy/faSort";
import { faStar } from "@fortawesome/free-solid-svg-icons-legacy/faStar";
import { faTag } from "@fortawesome/free-solid-svg-icons-legacy/faTag";
import { faTh } from "@fortawesome/free-solid-svg-icons-legacy/faTh";
import { faThLarge } from "@fortawesome/free-solid-svg-icons-legacy/faThLarge";
import { faThList } from "@fortawesome/free-solid-svg-icons-legacy/faThList";
import { faThumbtack } from "@fortawesome/free-solid-svg-icons-legacy/faThumbtack";
import { faTimes } from "@fortawesome/free-solid-svg-icons-legacy/faTimes";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons-legacy/faTimesCircle";
import { faTrash } from "@fortawesome/free-solid-svg-icons-legacy/faTrash";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons-legacy/faTrashAlt";
import { faUnlink } from "@fortawesome/free-solid-svg-icons-legacy/faUnlink";
import { faUpload } from "@fortawesome/free-solid-svg-icons-legacy/faUpload";
import { faUser } from "@fortawesome/free-solid-svg-icons-legacy/faUser";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons-legacy/faUserCircle";
import { faUsers } from "@fortawesome/free-solid-svg-icons-legacy/faUsers";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons-legacy/faMapMarker";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons-legacy/faMapMarkerAlt";
import { faMobile } from "@fortawesome/free-solid-svg-icons-legacy/faMobile";
import { faArrowsTurnToDots } from "@fortawesome/free-solid-svg-icons/faArrowsTurnToDots";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons-legacy/faStar";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons-legacy/faCircle";
import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons-legacy/faProjectDiagram";

// ../../node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var faCircleInfo = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faInfoCircle = faCircleInfo;

// src/lib/register-icons.js
var registered = [
  faAndroid,
  faAngular,
  faApple,
  faEmber,
  faPhp,
  faPython,
  faReact,
  faVuejs,
  faAdjust,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsAltH,
  faArrowsAltV,
  faAsterisk,
  faBan,
  faBookOpen,
  faBullseye,
  faCalculator,
  faCalendarAlt,
  faCameraRetro,
  faCaretDown,
  faCaretUp,
  faCcVisa,
  faCcMastercard,
  faCcStripe,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClipboardCheck,
  faClock,
  faClone,
  faCode,
  faCog,
  faColumns,
  faComment,
  faCommentAlt,
  faCopy,
  faDesktop,
  faDownload,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faFileAlt,
  faFileExport,
  faEye,
  faFlag,
  faFlask,
  faFont,
  faGem,
  faGlobe,
  faGripVertical,
  faHistory,
  faImage,
  faInfo,
  faInfoCircle2,
  faInfoCircle,
  faKey,
  faLevelDownAlt,
  faLightbulb,
  faList,
  faLock,
  faLongArrowAltRight,
  faMagic,
  faMap,
  faMapMarker,
  faMapMarkerAlt,
  faMinus,
  faMinusCircle,
  faMobile,
  faPalette,
  faPen,
  faPencilAlt,
  faPrint,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRocket,
  faSearch,
  faShare,
  faSignOutAlt,
  faSlidersH,
  faSort,
  faStar,
  faStripe,
  faTag,
  faTh,
  faThLarge,
  faThList,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUnlink,
  faUpload,
  faUser,
  faUserCircle,
  faUsers,
  faArrowsTurnToDots,
  farStar,
  farCircle,
  faProjectDiagram,
  faGripDotsVertical
];
library.add(...registered);
dom.watch();

// src/Icon.js
var Icon = styled(FontAwesomeIcon).attrs(() => ({
  focusable: false
}))`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
`;
Icon.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};
var Icon_default = Icon;
var Button = styled.button`
  align-items: center;
  background: none;
  border-radius: 6px;
  border: none;
  color: var(--icon);
  display: flex;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  transition: ${easing("color")};
  width: 24px;

  :hover {
    color: var(--icon-hover);
  }

  :focus {
    outline: 2px solid var(--input-focus);
    outline-offset: -2px;
  }

  ${Icon} {
    width: 100%;
  }
`;
var BaseIconButton = ({
  icon,
  label,
  onClick,
  type = "button",
  ...unhandledProps
}) => {
  return /* @__PURE__ */ React.createElement(Button, {
    "aria-label": label,
    onClick,
    type,
    ...unhandledProps
  }, /* @__PURE__ */ React.createElement(Icon, {
    icon
  }));
};
BaseIconButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string
};
var IconButton = styled(BaseIconButton)``;
var IconWithinCButton = styled(Icon)`
  margin-right: 10px;
  ${({ gray }) => gray && `color: var(--icon)`}
`;

// src/Link.js
var theme = `
  --link-active-color: var(--deep-work);
  --link-color: var(--blurple);
  --link-focus-outline-color: var(--blues-cues);
  --link-font-weight: var(--bold);
  --link-hover-color: var(--deep-work);
  --link-text-decoration: underline;
  --link-visited-color: var(--link-active-color);
`;
var UILink = styled2.a`
  ${theme}

  color: var(--link-color);
  cursor: pointer;
  font-size: inherit;
  font-weight: var(--link-font-weight);
  line-height: 1.5;
  text-decoration: none;

  > ${Icon_default} {
    margin-left: 8px;
    margin-right: 4px;
  }

  &:hover {
    color: var(--link-hover-color);
    text-decoration: var(--link-text-decoration);
  }

  &:focus-visible {
    border-radius: 6px;
    box-shadow: 0 0 0 2px var(--link-focus-outline-color);
    outline: none;
  }

  &:active {
    color: var(--link-active-color);
    text-decoration: var(--link-text-decoration);
  }

  &:visited {
    color: var(--link-visited-color);

    > ${Icon_default} {
      color: var(--link-visited-color);
    }
  }
`;
var Link = styled2(UILink).attrs(({ to }) => ({
  as: to ? RouterLink : "a"
}))``;
var ExternalLink = styled2(UILink).attrs(
  ({ children, icon = true }) => ({
    rel: "noopener noreferrer",
    target: "_blank",
    children: /* @__PURE__ */ React2.createElement(React2.Fragment, null, children, icon && /* @__PURE__ */ React2.createElement(Icon_default, {
      icon: "external-link-alt"
    }))
  })
)``;
var ButtonLink = styled2(UILink).attrs(({ as }) => ({
  as: as || "button"
}))`
  background: none;
  border: none;
  ${({ disabled }) => disabled && `
  pointer-events: none;
  color: var(--foreground-button-secondary-disabled);
  `}
`;
var Link_default = Link;

// src/Banner.js
var Wrapper = styled3.div`
  background: var(--banner-info-gradient);
  color: var(--banner-content);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 12px 16px;
  font-weight: var(--bold);

  > ${IconButton} {
    color: var(--banner-content);
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${UILink} {
    color: inherit;
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;
var BodyWrapper = styled3.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
var Body = styled3.span``;
function BaseBanner({ children, className, onDismiss, ...unhandledProps }) {
  return /* @__PURE__ */ React3.createElement(Wrapper, {
    className,
    ...unhandledProps
  }, /* @__PURE__ */ React3.createElement(BodyWrapper, null, /* @__PURE__ */ React3.createElement(Body, null, children)), onDismiss && /* @__PURE__ */ React3.createElement(IconButton, {
    icon: "times",
    label: "Dismiss banner",
    onClick: onDismiss
  }));
}
BaseBanner.propTypes = {
  children: PropTypes2.node,
  className: PropTypes2.string,
  onDismiss: PropTypes2.func
};
BaseBanner.displayName = "Banner";
var Banner = styled3(BaseBanner)``;
var Banner_default = Banner;
var NegativeBanner = styled3(Banner).attrs(() => ({
  role: "alert",
  "aria-live": "polite"
}))`
  background: var(--banner-negative-gradient);
`;
var BannerGroup = styled3.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2000;
`;

// src/Button.js
import React4, { forwardRef } from "react";
import styled4, { css } from "styled-components";
import PropTypes3 from "prop-types";
var theme2 = `
  --button-background: initial;
  --button-border-color: transparent;
  --button-color: var(--white);
`;
var UIButton = styled4.button`
  ${theme2}

  align-items: center;
  background: var(--button-background);
  border-radius: 6px;
  border: 1px solid var(--button-border-color);
  color: var(--button-color);
  display: flex;
  flex-shrink: 0;
  font-size: var(--regular);
  font-weight: var(--semi-bold);
  height: 40px;
  justify-content: center;
  line-height: 1.5;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  transition: ${easing("background", "box-shadow", "color")};

  &:hover:not([disabled]) {
    box-shadow: var(--button-elevation);
  }

  &[disabled] {
    background: var(--disabled);
    border-color: transparent;
    box-shadow: none;
    color: var(--white);
    transition: background 0ms;
  }

  > ${Icon_default} {
    color: inherit;
    font-size: var(--regular);
    margin-right: 8px;
  }

  /**
   * Style overrides for links forwarded as buttons
   */
  &${UILink} {
    --link-color: var(--button-color);
    --link-hover-color: inherit;
    --link-text-decoration: none;
    --link-visited-color: var(--button-color);

    > ${Icon_default} {
      margin-right: 0;
    }
  }
`;
var Primary = styled4(UIButton)`
  --button-background: var(--primary-grad);
`;
var Secondary = styled4(UIButton)`
  --button-background: var(--white);
  --button-color: var(--oh-hi-dark);
  --button-border-color: var(--sharkbait-ooh-la-la);
`;
var Positive = styled4(UIButton)`
  --button-background: var(--safety-grad);
`;
var Negative = styled4(UIButton)`
  --button-background: var(--danger-grad);
`;
var UnstyledButton = forwardRef(
  ({ kind, type = "button", ...unhandledProps }, ref) => {
    switch (kind) {
      case "secondary":
        return /* @__PURE__ */ React4.createElement(Secondary, {
          ref,
          type,
          ...unhandledProps
        });
      case "negative":
        return /* @__PURE__ */ React4.createElement(Negative, {
          ref,
          type,
          ...unhandledProps
        });
      case "positive":
        return /* @__PURE__ */ React4.createElement(Positive, {
          ref,
          type,
          ...unhandledProps
        });
      case "primary":
      default:
        return /* @__PURE__ */ React4.createElement(Primary, {
          ref,
          type,
          ...unhandledProps
        });
    }
  }
);
UnstyledButton.propTypes = {
  kind: PropTypes3.oneOf(["primary", "secondary", "positive", "negative"]),
  type: PropTypes3.string
};
var Button2 = styled4(UnstyledButton)``;
var Button_default = Button2;
var SquareButton = styled4(Button2).attrs(({ icon }) => ({
  children: /* @__PURE__ */ React4.createElement(Icon_default, {
    icon
  })
}))`
  padding: 8px;
  width: 40px;
  height: 40px;

  ${Icon_default} {
    margin-right: 0;

    ${({ kind }) => kind === "secondary" && `
      color: var(--icon);
    `}
  }
`;
var sharedFocusStyles = css`
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid var(--pleather);
`;
var SplitButton = styled4.div`
  display: flex;
  width: fit-content;
  position: relative;
  background: var(--primary-grad);
  border-radius: 8px;
  min-width: fit-content;
  ${(props) => props.kind === "positive" && "background: var(--safety-grad);"}
  ${(props) => props.disabled && `background: var(--disabled);
    ${Button2} {
      pointer-events: none;
      cursor: not-allowed;
      :hover {
        box-shadow: none;
      }
    }
    `}

  ${Button2} {
    border: none;
    border-radius: 0;
    outline: none;
    background: none;
    position: relative;
  }

  ${Button2}:first-of-type {
    :focus-visible {
      :before {
        ${sharedFocusStyles}
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
    }
  }

  ${Button2}:not(:first-of-type) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    padding: 18px 11px;

    ${Icon_default} {
      margin: 0;
      font-size: var(--xx-small);
    }
    :focus-visible {
      :before {
        ${sharedFocusStyles}
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }
`;
SplitButton.displayName = "SplitButton";
var ButtonGroup = styled4.div`
  align-items: stretch;
  display: flex;

  > ${Button2}, > ${SplitButton} {
    margin-right: 12px;
  }

  ${({ right }) => right && `
      flex-direction: row-reverse;

      > ${Button2}, > ${SplitButton} {
        margin-left: 12px;
        margin-right: 0;
      }
    `}
`;

// src/Caption.js
import PropTypes4 from "prop-types";
import styled5 from "styled-components";
var Caption = styled5.span`
  color: var(--text-secondary);
  font-size: var(--x-small);
  font-weight: ${({ bold }) => bold ? "var(--semi-bold)" : "var(--normal)"};
  letter-spacing: 0;
  line-height: 1.5em;
`;
Caption.propTypes = {
  bold: PropTypes4.bool
};
var Caption_default = Caption;
var ErrorMsg = styled5(Caption)`
  color: var(--danger-dark);
`;
var SuccessMsg = styled5(Caption)`
  color: var(--bulbasaur);
`;
var WarningMsg = styled5(Caption)`
  color: var(--warn-dark);
`;

// src/Card.js
import React5 from "react";
import PropTypes5 from "prop-types";
import styled6 from "styled-components";
var LIST = "list";
var GRID = "grid";
var ACTIVE = "active";
var INACTIVE = "inactive";
var SELECTED = "selected";
var Image = styled6.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 12px 24px;
`;
var Wrapper2 = styled6.div`
  --card-status-size: 7px;
  --card-grid-radius: 12px;
  --card-list-radius: 6px;
  --card-grid-radius-with-status: var(--card-status-size)
    var(--card-status-size) var(--card-grid-radius) var(--card-grid-radius);

  background-color: var(--white);
  box-shadow: var(--level-1);
  display: flex;
  transition: ${easing("box-shadow")};

  ${({ onClick }) => onClick && `
      cursor: pointer;

      :hover {
        box-shadow: var(--level-2);
      }
  `}

  ${({ $kind, $status }) => {
  switch ($kind) {
    case GRID:
      return `
          border-radius: ${$status ? `var(--card-grid-radius-with-status)` : `var(--card-grid-radius)`};
          flex-direction: column;

          ${Image} {
            background-color: var(--myst);
          }
        `;
    case LIST:
    default:
      return `
          border-radius: var(--card-list-radius);

          & + & {
            margin-top: 16px;
          }

          ${Image} {
            background-color: var(--light-gray);
          }
        `;
  }
}}

  &::before {
    content: '';
    flex-shrink: 0;
  }

  ${({ $kind, $status, $hasImage }) => {
  switch (true) {
    case ($kind === LIST && $status === ACTIVE):
      return `
          &::before {
            background: linear-gradient(0deg, var(--merfolk));
            border-radius: var(--card-list-radius) 0 0 var(--card-list-radius);
            height: auto;
            width: var(--card-status-size);
          }
        `;
    case ($kind === LIST && $status === INACTIVE):
      return `border-left: var(--card-status-size) solid var(--status-inactive);`;
    case ($kind === LIST && $status === SELECTED):
      return `
          &::before {
            background: linear-gradient(0deg, var(--blurple-haze));
            border-radius: var(--card-list-radius) 0 0 var(--card-list-radius);
            height: auto;
            width: var(--card-status-size);
          }
        `;
    case ($kind === LIST && !$status && $hasImage):
      return `border-left: var(--card-status-size) solid var(--light-gray)`;
    case ($kind === GRID && $status === ACTIVE):
      return `
          &::before {
            background: linear-gradient(90deg, var(--merfolk));
            border-radius: var(--card-status-size) var(--card-status-size) 0 0;
            height: var(--card-status-size);
            width: auto;
          }
        `;
    case ($kind === GRID && $status === INACTIVE):
      return `border-top: var(--card-status-size) solid var(--status-inactive);`;
    case ($kind === GRID && $status === SELECTED):
      return `
          &::before {
            background: linear-gradient(90deg, var(--blurple-haze));
            border-radius: var(--card-status-size) var(--card-status-size) 0 0;
            height: var(--card-status-size);
            width: auto;
          }
        `;
    case ($kind === GRID && !$status && $hasImage):
      return `border-top: var(--card-status-size) solid var(--myst)`;
    default:
      return ``;
  }
}}
`;
var Content = styled6.div`
  height: 100%;
  min-height: 0;
  min-width: 0;
  padding: 16px 24px;
  width: 100%;
`;
var Card = ({
  children,
  className,
  image,
  kind = LIST,
  onClick,
  status,
  ...unhandledProps
}) => /* @__PURE__ */ React5.createElement(Wrapper2, {
  className,
  onClick,
  $kind: kind,
  $status: status,
  $hasImage: !!image,
  ...unhandledProps
}, image && /* @__PURE__ */ React5.createElement(Image, null, image), /* @__PURE__ */ React5.createElement(Content, null, children));
Card.propTypes = {
  children: PropTypes5.node,
  className: PropTypes5.string,
  image: PropTypes5.node,
  kind: PropTypes5.oneOf([LIST, GRID]),
  onClick: PropTypes5.func,
  status: PropTypes5.oneOf([ACTIVE, INACTIVE, SELECTED])
};
var Card_default = styled6(Card)``;

// src/Carousel.js
import React6, { useEffect, useLayoutEffect, useState, useRef } from "react";
import debounce from "lodash.debounce";
import styled7 from "styled-components";
import PropTypes6 from "prop-types";
var CarouselWrapper = styled7.div`
  min-height: 120px;
  min-width: 200px;
  padding: 16px 32px;
  position: relative;
  width: 100%;
`;
var Navigation = styled7.div`
  align-items: center;
  background: none;
  border: none;
  bottom: 0;
  display: flex;
  position: absolute;
  top: 0;
  bottom: 32px;
  width: 118px;
  z-index: 1;
`;
var Left = styled7(Navigation)`
  justify-content: flex-start;
  left: 0;
  padding-left: 15px;
  ${({ $active }) => !$active && `background:  linear-gradient(90deg, var(--white) 3%, transparent 97%);`}
`;
var Right = styled7(Navigation)`
  justify-content: flex-end;
  padding-right: 15px;
  right: 0;
  ${({ $active }) => !$active && `background: linear-gradient(270deg,var(--white) 3%, transparent 97%);`}
`;
var Arrow = styled7.button`
  align-items: center;
  background-color: var(--white);
  border-radius: 50%;
  border: 1px solid var(--noreaster);
  box-shadow: var(--level-2);
  color: var(--blurple);
  display: flex;
  font-size: var(--medium-large);
  height: 40px;
  justify-content: center;
  width: 40px;
  ${({ disabled }) => disabled && "display: none;"}
`;
var Body2 = styled7.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;
var Wrapper3 = styled7.div`
  display: flex;
  height: 100%;
  justify-content: flex-start;
  overflow-x: auto;
  padding: 16px 0;
  position: relative;
  width: 100%;
`;
var Item = styled7.div`
  display: flex;
  overflow: hidden;
`;
var ITEM_GAP = 24;
var SCROLL_INCREMENT = 200;
var ONE_FRAME = 16;
var Carousel = ({ items, className }) => {
  const [currentPosition, setCurrentPosition] = useState(0);
  const [previousActive, setPreviousActive] = useState(false);
  const [nextActive, setNextActive] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const [wrapperWidth, setWrapperWidth] = useState();
  const wrapper = useRef();
  const body = useRef();
  useEffect(() => {
    const handler = debounce(() => {
      var _a;
      wrapper.current.scrollLeft = 0;
      setWrapperWidth((_a = wrapper.current) == null ? void 0 : _a.offsetWidth);
    }, ONE_FRAME);
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);
  useLayoutEffect(() => {
    const { offsetWidth, scrollWidth } = wrapper.current;
    setPreviousActive(currentPosition <= 0);
    setNextActive(scrollWidth - currentPosition - offsetWidth <= ITEM_GAP / 2);
    setWrapperWidth(scrollWidth);
  }, [wrapperWidth, currentPosition, items]);
  useLayoutEffect(() => {
    const { parentElement, offsetWidth } = body.current;
    const bodyWidth = items.length * SCROLL_INCREMENT;
    const parentWidth = parentElement == null ? void 0 : parentElement.offsetWidth;
    setShowArrow(parentWidth <= offsetWidth || parentWidth <= bodyWidth);
  }, [wrapperWidth, currentPosition, items]);
  const previous = () => {
    wrapper.current.scrollLeft = wrapper.current.scrollLeft - SCROLL_INCREMENT - ITEM_GAP;
    setCurrentPosition(wrapper.current.scrollLeft);
  };
  const next = () => {
    wrapper.current.scrollLeft = wrapper.current.scrollLeft + SCROLL_INCREMENT + ITEM_GAP;
    setCurrentPosition(wrapper.current.scrollLeft);
  };
  const onScroll = (e16) => {
    setCurrentPosition(e16.target.scrollLeft);
  };
  return /* @__PURE__ */ React6.createElement(CarouselWrapper, {
    className
  }, showArrow && /* @__PURE__ */ React6.createElement(Left, {
    $active: previousActive
  }, /* @__PURE__ */ React6.createElement(Arrow, {
    disabled: previousActive,
    onClick: previous,
    role: "button",
    "aria-label": "previous"
  }, /* @__PURE__ */ React6.createElement(Icon_default, {
    icon: "chevron-left"
  }))), /* @__PURE__ */ React6.createElement(Wrapper3, {
    ref: wrapper,
    onScroll
  }, /* @__PURE__ */ React6.createElement(Body2, {
    ref: body
  }, items.map((slide) => {
    return /* @__PURE__ */ React6.createElement(Item, {
      key: slide.title,
      title: slide.title,
      tabIndex: "0"
    }, slide.element);
  }))), showArrow && /* @__PURE__ */ React6.createElement(Right, {
    $active: nextActive
  }, /* @__PURE__ */ React6.createElement(Arrow, {
    disabled: nextActive,
    onClick: next,
    role: "button",
    "aria-label": "next"
  }, /* @__PURE__ */ React6.createElement(Icon_default, {
    icon: "chevron-right"
  }))));
};
var ItemShape = {
  title: PropTypes6.string,
  element: PropTypes6.element
};
Carousel.propTypes = {
  items: PropTypes6.arrayOf(PropTypes6.shape(ItemShape)),
  className: PropTypes6.string
};
Carousel.displayName = "Carousel";
var Carousel_default = styled7(Carousel)``;

// src/Checkbox.js
import React7, { useState as useState2, useEffect as useEffect2 } from "react";
import { Indicator, Root } from "@radix-ui/react-checkbox-legacy";
import PropTypes7 from "prop-types";
import styled8 from "styled-components";
var CheckboxIndicator = styled8(Indicator).attrs({
  as: Icon_default,
  icon: "check"
})`
  color: transparent;
`;
var Label = styled8.label`
  font-weight: var(--semi-bold);
  color: var(--checkbox-color);
  cursor: pointer;
`;
var StarIcon = styled8(Icon_default)`
  font-size: 16px;
`;
var CheckboxWrapper = styled8(Root)`
  transition: ${easing("background-color", "border-color", "box-shadow")};
  align-items: center;
  background-color: white;
  border-radius: 4px;
  border: 2px solid var(--checkbox);
  box-shadow: none;
  color: white;
  display: flex;
  flex-shrink: 0;
  font-size: var(--xx-small);
  height: 16px;
  justify-content: center;
  position: relative;
  text-align: center;
  width: 16px;
  cursor: pointer;
  outline: none;

  &:hover {
    border-color: var(--checkbox-hover);
  }

  &:focus {
    border-color: var(--checkbox-hover);
    background: var(--checkbox-unselected-focus-bg);
    box-shadow: 0 0 0 5px var(--checkbox-unselected-focus-bg);
  }

  &[aria-checked='true'] {
    background: var(--checkbox-checked);
    border-color: var(--checkbox-checked);
    &:focus {
      background: var(--checkbox-checked-hover);
      box-shadow: 0 0 0 5px var(--checkbox-selected-focus-bg);
      border-color: var(--checkbox-checked-hover);
    }
    &:hover {
      background: var(--checkbox-checked-hover);
    }
    ${CheckboxIndicator} {
      color: white;
    }
  }

  &[aria-invalid='true'] {
    border-color: var(--danger-dark);
    color: var(--danger-dark);

    & + ${Label} {
      color: var(--danger-dark);
    }

    &:hover,
    &:focus-within {
      border-color: var(--checkbox-hover);
      background: transparent;
      box-shadow: none;
    }
  }

  &[aria-checked='true'][aria-invalid='true'] {
    background: transparent;
    box-shadow: none;
    border-color: var(--danger-dark);

    &:focus {
      background: transparent;
      box-shadow: none;
    }
    &:hover {
      border-color: var(--checkbox-hover);
      background: transparent;
    }

    ${CheckboxIndicator} {
      color: var(--danger-dark);
    }
  }

  &[disabled] {
    cursor: default;
    border-color: var(--checkbox-disabled);
    color: var(--checkbox-disabled);

    & + ${Label} {
      cursor: default;
      color: var(--checkbox-disabled);
    }
  }

  &[disabled][aria-checked='true'] {
    background: var(--checkbox-disabled);
    border-color: var(--checkbox-disabled);
    color: var(--checkbox-disabled);
  }
`;
var StarWrapper = styled8(Root)`
  border: none;
  background: transparent;
  color: var(--checkbox-star-color);
  &[aria-checked='true'] {
    ${StarIcon} {
      color: var(--checkbox-star-checked-color);
    }
  }
`;
var Wrapper4 = styled8.div`
  align-items: center;
  display: flex;

  position: relative;
  gap: 8px;

  ${({ $isStar }) => $isStar && "width: fit-content"}
`;
var CheckboxGroup = styled8.div`
  ${Wrapper4} {
    min-height: 40px;
    padding: 12px 24px;

    &:hover {
      background-color: var(--checkbox-group-hover);
      border-radius: 6px;
    }
  }
`;
var StarCheckbox = styled8(
  ({
    children,
    label,
    onChange,
    id = `checkbox-id-${Math.random() * 1e5}`,
    defaultChecked,
    checked,
    className,
    ...unhandledProps
  }) => {
    const [isChecked, setChecked] = useState2(defaultChecked || checked);
    const handleClick = () => {
      setChecked((currentChecked) => {
        onChange == null ? void 0 : onChange(!currentChecked);
        return !currentChecked;
      });
    };
    useEffect2(() => {
      setChecked(defaultChecked || checked);
    }, [defaultChecked, checked]);
    return /* @__PURE__ */ React7.createElement(Wrapper4, {
      className,
      $isStar: true
    }, /* @__PURE__ */ React7.createElement(StarWrapper, {
      id,
      checked: isChecked,
      ...unhandledProps,
      onClick: handleClick
    }, /* @__PURE__ */ React7.createElement(StarIcon, {
      $checked: isChecked,
      icon: isChecked ? "star" : ["far", "star"]
    })), (children || label) && /* @__PURE__ */ React7.createElement(Label, {
      htmlFor: id
    }, children || label));
  }
)``;
StarCheckbox.propTypes = {
  children: PropTypes7.node,
  label: PropTypes7.string,
  id: PropTypes7.string,
  onChange: PropTypes7.func,
  checked: PropTypes7.bool,
  defaultChecked: PropTypes7.bool,
  className: PropTypes7.string
};
StarCheckbox.displayName = "StarCheckbox";
var Checkbox = React7.forwardRef(
  ({
    children,
    label,
    onChange,
    id = `checkbox-id-${Math.random() * 1e5}`,
    error,
    className,
    title,
    ...unhandledProps
  }, ref) => {
    return /* @__PURE__ */ React7.createElement(Wrapper4, {
      className,
      title
    }, /* @__PURE__ */ React7.createElement(CheckboxWrapper, {
      id,
      onCheckedChange: onChange,
      "aria-invalid": error,
      ref,
      ...unhandledProps
    }, /* @__PURE__ */ React7.createElement(CheckboxIndicator, null)), (children || label) && /* @__PURE__ */ React7.createElement(Label, {
      htmlFor: id
    }, children || label));
  }
);
Checkbox.propTypes = {
  children: PropTypes7.node,
  label: PropTypes7.string,
  id: PropTypes7.string,
  onChange: PropTypes7.func,
  error: PropTypes7.bool,
  className: PropTypes7.string,
  title: PropTypes7.string
};
Checkbox.displayName = "Checkbox";
var Checkbox_default = styled8(Checkbox)``;

// src/CheckboxSelect.js
import React9 from "react";
import styled11 from "styled-components";
import { components as Base } from "react-select";

// src/Select.js
import React8, { useEffect as useEffect3, useMemo, useState as useState3 } from "react";
import PropTypes8 from "prop-types";
import styled10, { css as css2 } from "styled-components";
import BaseSelect, { components } from "react-select";
import BaseCreatable from "react-select/creatable";

// src/Label.js
import styled9 from "styled-components";
var Label_default = styled9.label`
  display: flex;
  flex-direction: column;
  font-size: var(--regular);
  font-weight: var(--semi-bold);
  gap: 6px;
  justify-content: space-between;
  position: relative;
  color: var(--pleather);

  & + && {
    margin-top: 16px;
  }
`;

// src/Select.js
var shapes = {
  OPTION: PropTypes8.shape({
    label: PropTypes8.node,
    value: PropTypes8.any,
    icon: PropTypes8.oneOfType([
      PropTypes8.string,
      PropTypes8.arrayOf(PropTypes8.string)
    ])
  })
};
var extend = (overrides, styles = {}) => Object.entries(overrides).reduce((acc, [key, value]) => {
  acc[key] = (provided, state) => ({
    ...provided,
    ...typeof value === "function" ? value(state) : value,
    ...styles[key]
  });
  return acc;
}, {});
var base = {
  clearIndicator: {
    alignItems: "center",
    color: "var(--dropdown-inactive)",
    display: "flex",
    height: "16px",
    marginRight: "8px",
    padding: "0px",
    transition: "color 200ms ease-in-out",
    width: "16px",
    ":hover": {
      color: "var(--dropdown-active)"
    }
  },
  container: {
    fontSize: "var(--regular)",
    maxWidth: "400px",
    minWidth: "256px"
  },
  control: ({ isDisabled, isFocused, selectProps: { error } }) => ({
    background: "var(--dropdown-bg)",
    borderColor: "var(--dropdown-inactive)",
    borderRadius: "6px",
    boxShadow: "none",
    cursor: "pointer",
    minHeight: "40px",
    transition: "border-color 200ms ease-in-out",
    ":hover": {
      borderColor: "var(--dropdown-active)"
    },
    ...isFocused && {
      borderColor: "var(--dropdown-active)",
      ":hover": {
        borderColor: "var(--dropdown-active)"
      }
    },
    ...isDisabled && {
      background: "var(--dropdown-disabled)",
      borderColor: "var(--dropdown-disabled)",
      color: "var(--dropdown-disabled-text)",
      ":hover": {
        borderColor: "var(--dropdown-disabled)"
      }
    },
    ...error && {
      borderColor: "var(--danger-dark)",
      ":hover": {
        borderColor: "var(--danger-dark)"
      }
    }
  }),
  dropdownIndicator: ({ isDisabled, selectProps: { menuIsOpen } }) => ({
    alignItems: "center",
    color: "var(--dropdown-inactive)",
    display: "flex",
    height: "14px",
    marginRight: "12px",
    padding: "0px",
    width: "14px",
    ":hover": {
      color: "var(--dropdown-inactive)"
    },
    ...isDisabled && {
      color: "var(--dropdown-disabled-text)"
    },
    ...menuIsOpen && {
      transform: "rotate(-180deg)"
    }
  }),
  indicatorSeparator: {
    display: "none"
  },
  input: {
    color: "var(--dropdown-text)"
  },
  menu: {
    borderRadius: "6px",
    boxShadow: "var(--dropdown-menu-shadow)",
    color: "var(--dropdown-text)",
    marginTop: "6px",
    padding: "8px"
  },
  menuPortal: {
    zIndex: 99999
  },
  multiValue: {
    borderRadius: "4px",
    background: "var(--dropdown-option-bg)"
  },
  multiValueRemove: {
    color: "var(--dropdown-inactive)",
    ":hover": {
      color: "var(--dropdown-active)"
    }
  },
  option: ({ isFocused, isSelected }) => ({
    borderRadius: "6px",
    cursor: "pointer",
    ...isFocused && {
      background: "var(--dropdown-option-bg)"
    },
    ...isSelected && {
      background: "none",
      color: "var(--dropdown-option-selected)",
      fontWeight: "var(--bold)",
      ":hover": {
        background: "var(--dropdown-option-bg)"
      }
    }
  }),
  placeholder: {
    color: "var(--dropdown-placeholder)"
  },
  singleValue: {
    color: "var(--dropdown-text)"
  }
};
var borderless = {
  control: ({ hasValue, isFocused }) => ({
    background: "var(--dropdown-bg)",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "background 200ms ease-in-out",
    ":hover": {
      background: "var(--dropdown-disabled)"
    },
    ...(isFocused || hasValue) && {
      background: "var(--dropdown-disabled)"
    }
  }),
  dropdownIndicator: {
    display: "none"
  }
};
var maxMenuHeight = 300;
var BaseIcon = styled10(Icon_default)`
  color: var(--dropdown-icon);
  font-size: var(--regular);
`;
var Prefix = styled10(BaseIcon)`
  margin-left: 12px;
`;
function Control({ children, ...unhandledProps }) {
  const {
    selectProps: { icon }
  } = unhandledProps;
  return /* @__PURE__ */ React8.createElement(components.Control, {
    ...unhandledProps
  }, icon && /* @__PURE__ */ React8.createElement(Prefix, {
    icon
  }), children);
}
var OptionLabel = styled10.div`
  color: var(--dropdown-text);
  font-weight: var(--bold);
  font-size: var(--regular);
`;
var Description = styled10.div`
  color: var(--dropdown-text);
  font-size: var(--regular);
  font-weight: var(--normal);
`;
var IconBox = styled10.div`
  width: 22px;
  margin-right: 2px;
  text-align: center;
  display: inline-block;
`;
var OptionIcon = styled10(({ isSelected, ...unhandledProps }) => /* @__PURE__ */ React8.createElement(BaseIcon, {
  ...unhandledProps
}))`
  margin-right: 6px;
  ${({ isSelected }) => isSelected && css2`
      color: var(--dropdown-option-selected);
    `}
`;
var OptionWrapper = styled10.div`
  ${({ isSelected }) => isSelected && `
     color: var(--dropdown-option-selected);
     font-weight: bold;

     ${OptionLabel} {
      color: var(--dropdown-option-selected);
      font-weight: bold;
     }

     ${Description} {
      font-weight: var(--normal);
     }
    `}

  ${({ $isDisabled }) => $isDisabled && `
     ':hover': {
      borderColor: 'var(--dropdown-disabled)',
     },
     color: var(--dropdown-disabled-text);
     font-weight: bold;

     ${OptionLabel} {
      color: var(--dropdown-disabled-text);
      font-weight: bold;
     }

     ${Description} {
      font-weight: var(--normal);
      color: var(--dropdown-disabled-text);
     }
    `}
`;
function Option({
  children,
  data,
  innerProps,
  isSelected,
  isDisabled,
  ...unhandledProps
}) {
  const { label, description, icon } = data;
  const child = description ? /* @__PURE__ */ React8.createElement(OptionWrapper, {
    isSelected,
    $isDisabled: isDisabled
  }, /* @__PURE__ */ React8.createElement(OptionLabel, null, label), /* @__PURE__ */ React8.createElement(Description, null, description)) : /* @__PURE__ */ React8.createElement(React8.Fragment, null, icon && /* @__PURE__ */ React8.createElement(IconBox, null, /* @__PURE__ */ React8.createElement(OptionIcon, {
    isSelected,
    icon
  })), typeof label === "string" ? /* @__PURE__ */ React8.createElement("span", {
    title: label
  }, children) : children);
  return /* @__PURE__ */ React8.createElement(components.Option, {
    ...unhandledProps,
    data,
    innerProps: {
      ...innerProps,
      role: "option"
    },
    isSelected,
    isDisabled
  }, child);
}
function ClearIndicator({ innerProps, ...unhandledProps }) {
  return /* @__PURE__ */ React8.createElement(components.ClearIndicator, {
    ...unhandledProps,
    innerProps: {
      ...innerProps,
      "aria-label": "Clear options"
    }
  });
}
function MultiValueRemove({ innerProps, ...unhandledProps }) {
  return /* @__PURE__ */ React8.createElement(components.MultiValueRemove, {
    ...unhandledProps,
    innerProps: {
      ...innerProps,
      "aria-label": "Clear option"
    }
  });
}
function createSelect(Component) {
  const isCreatable = Component === BaseCreatable;
  const Base2 = ({
    components: replacements,
    icon,
    inputValue: initialInputValue,
    isMulti,
    kind = "default",
    onChange,
    onInputChange,
    options: initialOptions,
    portal = false,
    styles,
    value: initialValue,
    ...unhandledProps
  }) => {
    const [options, setOptions] = useState3(initialOptions);
    const [value, setValue] = useState3(initialValue);
    const [inputValue, setInputValue] = useState3(initialInputValue);
    useEffect3(() => {
      setOptions(initialOptions);
    }, [initialOptions]);
    useEffect3(() => {
      setValue(initialValue);
    }, [initialValue]);
    useEffect3(() => {
      setInputValue(initialInputValue);
    }, [initialInputValue]);
    const handleBlur = () => {
      const label = (inputValue == null ? void 0 : inputValue.trim()) || "";
      const exists = options.find((option2) => option2.label === label);
      if (!label) {
        return;
      }
      const option = exists || { label, value: label };
      if (isMulti) {
        setValue([...value || [], option]);
      } else {
        setValue(option);
      }
      setInputValue("");
      onChange == null ? void 0 : onChange(option);
    };
    const handleInputChange = (textInput, { action }) => {
      if (action === "input-change") {
        setInputValue(textInput);
      }
      if (action === "input-blur" && isCreatable) {
        handleBlur();
      }
      onInputChange == null ? void 0 : onInputChange(textInput, { action });
    };
    const handleChange = (selected, ...rest) => {
      setValue(selected);
      setInputValue("");
      onChange == null ? void 0 : onChange(selected, ...rest);
    };
    const combinedStyles = useMemo(() => {
      const baseStyles = {
        ...base,
        ...kind === "borderless" ? borderless : {}
      };
      return extend(baseStyles, styles);
    }, [styles, kind]);
    return /* @__PURE__ */ React8.createElement(Component, {
      components: {
        ClearIndicator,
        Control,
        MultiValueRemove,
        Option,
        ...replacements
      },
      icon: (value == null ? void 0 : value.icon) || icon,
      menuPortalTarget: portal && document.querySelector("#portal-root"),
      menuPosition: portal ? "fixed" : "absolute",
      styles: combinedStyles,
      inputValue,
      isMulti,
      onChange: handleChange,
      onInputChange: handleInputChange,
      options,
      value,
      maxMenuHeight,
      ...unhandledProps
    });
  };
  Base2.propTypes = {
    components: PropTypes8.objectOf(PropTypes8.elementType),
    error: PropTypes8.bool,
    icon: PropTypes8.oneOfType([
      PropTypes8.string,
      PropTypes8.arrayOf(PropTypes8.string)
    ]),
    kind: PropTypes8.oneOf(["default", "borderless"]),
    portal: PropTypes8.bool,
    styles: PropTypes8.objectOf(
      PropTypes8.oneOfType([PropTypes8.object, PropTypes8.func])
    ),
    inputValue: PropTypes8.string,
    isMulti: PropTypes8.bool,
    onChange: PropTypes8.func,
    onInputChange: PropTypes8.func,
    options: PropTypes8.arrayOf(shapes.OPTION),
    value: PropTypes8.oneOfType([
      PropTypes8.arrayOf(shapes.OPTION),
      shapes.OPTION
    ])
  };
  return styled10(Base2)``;
}
var Select = createSelect(BaseSelect);
var Creatable = createSelect(BaseCreatable);
var SelectLabel = styled10(Label_default)`
  > ${Select}, > ${Creatable} {
    margin-top: 6px;
  }

  & + && {
    margin-top: 16px;
  }
`;

// src/CheckboxSelect.js
var Toggle = styled11(Checkbox_default)`
  align-items: center;
  display: flex;
`;
var Label2 = styled11.span`
  color: var(--dropdown-text);
  font-weight: var(--normal);
`;
function CheckboxOption({ children, getValue, ...unhandledProps }) {
  const { data } = unhandledProps;
  const value = getValue();
  const checked = value.includes(data);
  return /* @__PURE__ */ React9.createElement(Option, {
    ...unhandledProps
  }, /* @__PURE__ */ React9.createElement(Toggle, {
    checked
  }, /* @__PURE__ */ React9.createElement(Label2, null, children)));
}
var Selected = styled11.span`
  color: var(--dropdown-text);
`;
var Remaining = styled11.span`
  color: var(--dropdown-text);
  margin-left: 4px;
`;
function CheckboxValueContainer({ children, getValue, ...unhandledProps }) {
  const [, input] = children;
  const value = getValue();
  const count = value.length;
  return /* @__PURE__ */ React9.createElement(Base.ValueContainer, {
    ...unhandledProps
  }, count === 0 && children, count > 0 && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(Selected, null, value[0].label), count > 1 && /* @__PURE__ */ React9.createElement(Remaining, null, "+", count - 1), input));
}
function CheckboxSelect({ components: components2, ...unhandledProps }) {
  return /* @__PURE__ */ React9.createElement(Select, {
    ...unhandledProps,
    blurInputOnSelect: false,
    closeMenuOnSelect: false,
    components: {
      ...components2,
      ClearIndicator,
      Control,
      MultiValueRemove,
      Option: CheckboxOption,
      ValueContainer: CheckboxValueContainer
    },
    hideSelectedOptions: false,
    isClearable: true,
    isMulti: true,
    isSearchable: false
  });
}
var CheckboxSelect_default = styled11(CheckboxSelect)``;

// src/ClickToCopy.js
import React11, { useEffect as useEffect4, useRef as useRef2, useState as useState4 } from "react";
import PropTypes10 from "prop-types";
import styled13 from "styled-components";

// src/lib/Fade.js
import React10 from "react";
import PropTypes9 from "prop-types";
import styled12 from "styled-components";
import { CSSTransition } from "react-transition-group";
var translate = ({ direction, distance }) => ({
  top: `translate3d(0, -${distance}px, 0)`,
  right: `translate3d(${distance}px, 0, 0)`,
  bottom: `translate3d(0, ${distance}px, 0)`,
  left: `translate3d(-${distance}px, 0, 0)`,
  center: "translate3d(0, 0, 0)"
})[direction];
var Container = styled12.div`
  opacity: 0;
  transition-property: opacity, transform;
  transition-timing-function: ease-in-out;
  transition-duration: ${({ timeout }) => timeout}ms;
  transition-delay: ${({ delay }) => delay}ms;

  &.fade-appear,
  &.fade-enter,
  &.fade-exit,
  &.fade-exit-active,
  &.fade-exit-done {
    opacity: 0;
    transform: ${translate};
  }

  &.fade-appear-active,
  &.fade-appear-done,
  &.fade-enter-active,
  &.fade-enter-done {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
var Fade = ({
  children,
  delay = 0,
  distance = 8,
  from = "center",
  timeout = 200,
  visible = false,
  ...unhandledProps
}) => /* @__PURE__ */ React10.createElement(CSSTransition, {
  appear: true,
  classNames: "fade",
  in: visible,
  mountOnEnter: true,
  timeout: delay + timeout,
  unmountOnExit: true,
  ...unhandledProps
}, /* @__PURE__ */ React10.createElement(Container, {
  delay,
  distance,
  timeout,
  direction: from
}, children));
Fade.propTypes = {
  ...CSSTransition.propTypes,
  children: PropTypes9.node,
  delay: PropTypes9.number,
  distance: PropTypes9.number,
  from: PropTypes9.oneOf(["top", "right", "bottom", "left", "center"]),
  timeout: PropTypes9.number,
  visible: PropTypes9.bool
};
var Fade_default = Fade;

// src/ClickToCopy.js
var copyText = (node, withoutHighlight = true) => {
  const range = document.createRange();
  range.selectNodeContents(node);
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);
  document.execCommand("copy");
  if (withoutHighlight) {
    window.getSelection().removeAllRanges();
  }
};
var Wrapper5 = styled13.div`
  position: relative;
`;
var InputWrapper = styled13.div`
  background-color: var(--white);
  border-radius: 6px;
  border: 1px solid var(--text-secondary);
  display: flex;
  position: relative;
`;
var CopyIcon = styled13(Icon_default)`
  color: var(--primary);
  font-size: 12px;
  margin-left: 6px;
`;
var CopyButton = styled13(IconButton)`
  background-color: var(--primary-x-light);
  border-radius: 4px;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-size: var(--x-small);
  height: 32px;
  margin: 3px;
  width: 32px;

  &:focus,
  &:hover {
    background-color: var(--primary-light);
    box-shadow: none;
    color: var(--primary-dark);
  }

  &:focus-visible {
    outline: auto;
  }
`;
var Text = styled13.span`
  color: var(--text-primary);
  flex: 1;
  font-size: var(--regular);
  font-weight: var(--normal);
  padding: 10px 14px;
  word-break: break-word;
`;
var TextWrapper = styled13.span`
  width: 0;
  height: 0;
  opacity: 0;
  white-space: nowrap;
  cursor: default;
`;
var TextKind = styled13.span`
  cursor: pointer;
  word-break: break-word;

  ${({ $icon }) => $icon && `
    display: flex;
    align-items: center;
  `}
`;
var FadeWrapper = styled13(Fade_default)`
  position: absolute;
  right: 0;
  top: -40px;
`;
var Toast = styled13.span`
  background-color: var(--copy-alert-bg);
  border-radius: 6px;
  color: var(--white);
  display: block;
  font-size: var(--regular);
  padding: 8px 12px;
  width: ${({ iconOnly }) => iconOnly ? "150px" : "auto"};
`;
var IconOnly = styled13.div`
  display: flex;
  width: '20px';
  height: '20px';

  cursor: pointer;
  ${TextWrapper} {
    pointer-events: none;
  }
`;
var ClickToCopy = ({ children, onCopy, iconOnly = false, fade = 2e3 }) => {
  const [visible, setVisible] = useState4(false);
  useEffect4(() => {
    if (!visible) {
      return;
    }
    const timer = setTimeout(() => {
      setVisible(false);
    }, fade);
    return () => {
      clearTimeout(timer);
    };
  }, [fade, visible]);
  const handleCopy = (node, withoutHighlight) => {
    copyText(node, withoutHighlight);
    setVisible(true);
    if (onCopy) {
      onCopy();
    }
  };
  return /* @__PURE__ */ React11.createElement(Wrapper5, null, /* @__PURE__ */ React11.createElement(FadeWrapper, {
    visible
  }, /* @__PURE__ */ React11.createElement(Toast, {
    iconOnly,
    role: "alert"
  }, "Copied to clipboard")), children(handleCopy));
};
ClickToCopy.propTypes = {
  fade: PropTypes10.number,
  onCopy: PropTypes10.func,
  children: PropTypes10.func,
  iconOnly: PropTypes10.bool
};
var BaseTextClickToCopy = ({
  text,
  icon,
  title,
  iconOnly = false,
  ...unhandledProps
}) => {
  const textRef = useRef2(null);
  return /* @__PURE__ */ React11.createElement(ClickToCopy, {
    iconOnly: true,
    ...unhandledProps
  }, (handleCopy) => /* @__PURE__ */ React11.createElement(TextKind, {
    onClick: () => {
      handleCopy(textRef.current, false);
    },
    ref: textRef,
    $icon: icon
  }, iconOnly ? /* @__PURE__ */ React11.createElement(IconOnly, {
    title
  }, /* @__PURE__ */ React11.createElement(TextWrapper, null, text), /* @__PURE__ */ React11.createElement(CopyIcon, {
    icon: "copy"
  })) : /* @__PURE__ */ React11.createElement(React11.Fragment, null, text, " ", icon && /* @__PURE__ */ React11.createElement(CopyIcon, {
    title,
    icon: "copy"
  }))));
};
BaseTextClickToCopy.propTypes = {
  ...ClickToCopy.propTypes,
  text: PropTypes10.string.isRequired,
  icon: PropTypes10.bool,
  iconOnly: PropTypes10.bool,
  title: PropTypes10.string
};
var TextClickToCopy = styled13(BaseTextClickToCopy)``;
var BaseInputClickToCopy = ({ text, ...unhandledProps }) => {
  const textRef = useRef2(null);
  return /* @__PURE__ */ React11.createElement(ClickToCopy, {
    ...unhandledProps
  }, (handleCopy) => /* @__PURE__ */ React11.createElement(InputWrapper, null, /* @__PURE__ */ React11.createElement(Text, {
    ref: textRef
  }, text), /* @__PURE__ */ React11.createElement(CopyButton, {
    icon: "copy",
    onClick: () => {
      handleCopy(textRef.current);
    },
    label: "Copy text",
    title: "Copy"
  })));
};
BaseInputClickToCopy.propTypes = {
  ...ClickToCopy.propTypes,
  text: PropTypes10.string.isRequired
};
var InputClickToCopy = styled13(BaseInputClickToCopy)``;

// src/DateInput.js
import React13, { useEffect as useEffect6, useMemo as useMemo3, useRef as useRef5, useState as useState7 } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import PropTypes12 from "prop-types";
import styled15 from "styled-components";
import DayPickerInput from "react-day-picker-legacy/DayPickerInput";

// src/lib/Portal.js
import { useEffect as useEffect5, useMemo as useMemo2, useRef as useRef3 } from "react";
import { createPortal } from "react-dom";
var Portal = ({ children, timeout = 0 }) => {
  const $portal = document.querySelector("#portal-root");
  const removalTimer = useRef3(null);
  const $el = useMemo2(() => {
    return document.createElement("div");
  }, []);
  useEffect5(() => {
    if (removalTimer.current) {
      clearTimeout(removalTimer.current);
      removalTimer.current = null;
    }
    if ($portal) {
      $portal.append($el);
    }
    return () => {
      if (timeout > 0) {
        removalTimer.current = setTimeout(() => {
          $el.remove();
        }, timeout);
      } else {
        $el.remove();
      }
    };
  }, [$el, $portal, timeout]);
  return createPortal(children, $el);
};
var Portal_default = Portal;

// src/lib/date.js
import moment from "moment";
moment.suppressDeprecationWarnings = true;
var fromNow = (date, omitSuffix = false) => {
  return moment(date).fromNow(omitSuffix);
};
var calendar = (date) => {
  return moment(date).calendar();
};
var format = (date, tokens) => {
  return moment(date).format(tokens);
};
var isAfter = (date, compare) => {
  return moment(date).isAfter(moment(compare));
};
var isBefore = (date, compare) => {
  return moment(date).isBefore(moment(compare));
};
var startOf = (date, unit) => {
  return moment(date).startOf(unit).toDate();
};
var endOf = (date, unit) => {
  return moment(date).endOf(unit).toDate();
};
var add = (date, value, unit) => {
  return moment(date).add(value, unit).toDate();
};
var subtract = (date, value, unit) => {
  return moment(date).subtract(value, unit).toDate();
};
var diff = (start, end, unit) => {
  return moment(end).diff(moment(start), unit, true);
};
var parse = (value) => {
  const date = moment(value);
  return date.isValid(date) ? date.toDate() : null;
};
var utc = (date) => {
  return moment(date).utc();
};

// src/lib/date-range.js
import { useState as useState5 } from "react";
import { LocaleUtils } from "react-day-picker-legacy";
var DATE_FORMAT = "MMM D, YYYY";
var RANGE_OPTIONS = [
  {
    label: "Last 7 days",
    value: 7
  },
  {
    label: "Last 30 days",
    value: 30
  },
  {
    label: "Last 60 days",
    value: 60
  },
  {
    label: "Last 90 days",
    value: 90
  },
  {
    label: "Current quarter",
    value: "current-quarter"
  },
  {
    label: "Previous quarter",
    value: "previous-quarter"
  },
  {
    label: "Custom",
    value: "custom"
  }
];
var FULL_RANGE_OPTIONS = RANGE_OPTIONS.filter(({ value }) => {
  return !["current-quarter", "previous-quarter"].includes(value);
});
var LIMITED_RANGE_OPTIONS = RANGE_OPTIONS.filter(({ value }) => {
  return [7, 30].includes(value);
});
var EARLIEST_YEAR = 2013;
var YEAR_OPTIONS = Array.from({
  length: new Date().getFullYear() - EARLIEST_YEAR + 1
}).map((_, index) => ({
  label: `${EARLIEST_YEAR + index}`,
  value: EARLIEST_YEAR + index
}));
var MONTH_OPTIONS = LocaleUtils.getMonths().map((month, index) => ({
  label: month,
  value: index
}));
var getEndOfToday = () => {
  return endOf(Date.now(), "day");
};
var getRecommendedFrequency = ({ start, end }, threshold = 90) => {
  const duration = diff(start, end, "days");
  return Math.ceil(duration) > threshold ? "month" : "day";
};
var validateDate = (value, future) => {
  if (value === "") {
    return true;
  }
  const date = parse(value);
  const valid = date != null;
  if (valid && future) {
    return true;
  }
  const endOfToday = getEndOfToday();
  return valid && isBefore(date, endOfToday);
};
var normalizeDates = ({ start, end }) => ({
  start: start && startOf(start, "day"),
  end: end && endOf(end, "day")
});
var sanitizeDates = (dates = {}, changed = "start") => {
  const { start, end } = dates;
  const other = changed === "start" ? "end" : "start";
  const invalid = changed === "start" ? dates[changed] > end : dates[changed] < start;
  const sanitized = {
    [changed]: dates[changed],
    [other]: invalid ? void 0 : dates[other]
  };
  return normalizeDates(sanitized);
};
var calculateDatesFor = (range, override) => {
  const overridden = override == null ? void 0 : override(range);
  if (overridden) {
    return overridden;
  }
  const parsed = Number.parseInt(range, 10);
  const tail = startOf(add(Date.now(), 1, "days"), "day");
  switch (true) {
    case (typeof parsed === "number" && !Number.isNaN(parsed)): {
      return {
        range,
        start: startOf(subtract(tail, parsed, "days"), "day"),
        end: getEndOfToday()
      };
    }
    case range === "current-quarter": {
      return {
        range,
        start: startOf(tail, "quarter"),
        end: getEndOfToday()
      };
    }
    case range === "previous-quarter": {
      const previous = subtract(tail, 1, "quarter");
      return {
        range,
        start: startOf(previous, "quarter"),
        end: endOf(previous, "quarter")
      };
    }
    case range === "custom":
    default:
      return { range, start: null, end: null };
  }
};
var useDateRange = (options = [], initial = {}, calculate) => {
  var _a;
  const { range } = initial;
  const normalized = !options.some(({ value: value2 }) => value2 === range) ? (_a = options[0]) == null ? void 0 : _a.value : range;
  const dates = range && normalized !== "custom" ? calculateDatesFor(normalized, calculate) : initial;
  const [value, setDateRange] = useState5(dates);
  return [value, setDateRange];
};

// src/Input.js
import React12 from "react";
import PropTypes11 from "prop-types";
import styled14 from "styled-components";
var InputWrapper2 = styled14.div`
  position: relative;
  width: fit-content;

  :focus,
  :focus-within {
    ${Icon_default} {
      color: var(--input-text);
    }
  }

  ${Icon_default} {
    top: 12px;
    left: 16px;
    position: absolute;
    height: 16px;
    width: 16px;
    color: var(--input-clear-icon-color);
  }
`;
var Input = styled14.input`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  height: 40px;
  outline: none;
  padding: 10px 14px;

  &::placeholder {
    color: var(--input);
  }

  &:focus {
    border: 1px solid;
    border-color: var(--input-focus);
  }

  &[readonly] {
    cursor: default;
  }

  &[disabled],
  &[readonly] {
    background-color: var(--input-disabled-bg);
    border: 1px solid var(--input-disabled-bg);
    color: var(--input-disabled);
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &[type='number'] {
    appearance: textfield;
  }

  &[type='search'] {
    min-width: 256px;
    padding-left: 44px;
    padding-right: 8px;

    ::-webkit-search-cancel-button {
      appearance: none;
      cursor: pointer;
      height: 16px;
      width: 16px;

      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%7e89a9'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>");
    }
  }

  ${({ error }) => error && `
      border-color: var(--danger-dark);
      color: var(--danger-dark);

      &:focus {
        border-color: var(--danger-dark);
      }
    `}
`;
var SearchInput = styled14(({ className, ...unhandledProps }) => {
  return /* @__PURE__ */ React12.createElement(InputWrapper2, {
    className
  }, /* @__PURE__ */ React12.createElement(Icon_default, {
    icon: "search"
  }), /* @__PURE__ */ React12.createElement(Input, {
    type: "search",
    ...unhandledProps
  }));
})``;
SearchInput.displayName = "SearchInput";
Input.propTypes = {
  error: PropTypes11.bool,
  name: PropTypes11.string,
  type: PropTypes11.string.isRequired
};
var Input_default = Input;

// src/hooks/use-position.js
import { useCallback, useLayoutEffect as useLayoutEffect2, useRef as useRef4, useState as useState6 } from "react";
import debounce2 from "lodash.debounce";
var getBoundingClientRect = ($element) => $element ? $element.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, height: 0, width: 0 };
var getPositions = ({ attachment, target }) => {
  return {
    right: {
      top: target.bottom,
      left: target.right - attachment.width
    },
    left: { top: target.bottom, left: target.left },
    top: {
      top: target.top - (target.height + 300),
      left: target.left
    },
    bottom: {
      top: target.bottom + 10,
      left: target.left
    }
  };
};
function usePosition({ placement, visible }) {
  const target = useRef4();
  const attachment = useRef4();
  const [position, setPosition] = useState6({});
  const reposition = useCallback(() => {
    const { current: $target } = target;
    const { current: $attachment } = attachment;
    const targetRect = getBoundingClientRect($target);
    const attachmentRect = getBoundingClientRect($attachment);
    const positions = getPositions({
      attachment: attachmentRect,
      target: targetRect
    });
    setPosition(positions[placement]);
  }, [placement]);
  useLayoutEffect2(() => {
    if (!visible) {
      return;
    }
    const handler = debounce2(reposition, 16, { leading: true });
    reposition();
    window.addEventListener("resize", handler);
    window.addEventListener("scroll", handler);
    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("scroll", handler);
    };
  }, [reposition, visible]);
  return [{ attachment, target }, position, reposition];
}

// src/DateInput.js
var PREV_ICON = renderToStaticMarkup(/* @__PURE__ */ React13.createElement(Icon_default, {
  icon: "chevron-left"
}));
var NEXT_ICON = renderToStaticMarkup(/* @__PURE__ */ React13.createElement(Icon_default, {
  icon: "chevron-right"
}));
var prefix = "DatePicker";
var classes = {
  wrapper: `${prefix}-wrapper`,
  month: `${prefix}-Month`,
  navButtonPrev: `${prefix}-NavButton ${prefix}-NavButton--prev`,
  navButtonNext: `${prefix}-NavButton ${prefix}-NavButton--next`,
  caption: `${prefix}-Caption`,
  weekdays: `${prefix}-Weekdays`,
  weekdaysRow: `${prefix}-WeekdaysRow`,
  weekday: `${prefix}-Weekday`,
  body: `${prefix}-Body`,
  week: `${prefix}-Week`,
  day: `${prefix}-Day`,
  today: "today",
  selected: "selected",
  disabled: "disabled",
  outside: "outside"
};
var Wrapper6 = styled15.div`
  /**
   * DayPickerInput
   */

  .DayPickerInput {
    display: inline-block;
    width: 100%;

    ${Input_default} {
      width: 100%;
    }
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    background-color: var(--white);
    border-radius: 6px;
    box-shadow: var(--level-3);
    color: var(--datepicker-color);
    left: 0;
    position: absolute;
    top: 10px;
    z-index: var(--z-index-300);
  }

  /**
   * DayPicker
   */

  .${prefix}-wrapper {
    user-select: none;
  }

  .${prefix}-Month {
    user-select: none;
  }

  .${prefix}-NavButton {
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;
    cursor: pointer;
    display: inline-block;
    height: var(--regular);
    opacity: 0.6;
    position: absolute;
    right: 28px;
    top: 30px;
    width: var(--regular);

    :hover {
      opacity: 0.4;
    }
  }

  .${prefix}-NavButton--prev {
    margin-right: 20px;
    background-image: url('data:image/svg+xml;utf8, ${PREV_ICON}');
  }

  .${prefix}-NavButton--next {
    background-image: url('data:image/svg+xml;utf8, ${NEXT_ICON}');
  }

  .${prefix}-Caption {
    background-color: var(--datepicker-header-bg);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 16px;
  }

  .${prefix}-Weekdays {
    background-color: var(--datepicker-header-bg);
    padding: 0 16px;
  }

  .${prefix}-WeekdaysRow {
    align-items: center;
    display: flex;
    justify-content: space-around;
  }

  .${prefix}-Weekday {
    align-items: center;
    color: var(--datepicker-weekday-color);
    display: flex;
    font-size: var(--x-small);
    font-weight: var(--bold);
    justify-content: center;
    padding: 8px;

    abbr[title] {
      border-bottom: none;
      text-decoration: none;
    }
  }

  .${prefix}-Body {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    padding: 16px;
  }

  .${prefix}-Week {
    display: contents;
  }

  .${prefix}-Day {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    font-size: var(--regular);
    height: 40px;
    justify-content: center;
    width: 40px;
  }

  /**
   * Modifiers
   */

  .disabled {
    background-color: var(--datepicker-disabled-bg);
    border-radius: 0;
    color: var(--datepicker-disabled-color);
    cursor: default;
  }

  .outside {
    color: var(--datepicker-outside-color);
  }

  .${prefix}-Day:not(.disabled) {
    :hover {
      background-color: var(--datepicker-hover);
      color: var(--datepicker-color);
      font-weight: var(--bold);
    }
  }

  .selected:not(.disabled) {
    background-color: var(--datepicker-selected-bg);
    border: 1px solid var(--datepicker-selected-border);
    color: var(--datepicker-color);
    font-weight: var(--bold);

    :hover {
      background-color: var(--datepicker-selected-hover);
    }
  }
`;
var FooterWrapper = styled15.div`
  background-color: var(--datepicker-footer-bg);
  box-shadow: 0px -4px 10px var(--tint-black);
  padding: 8px 16px;
  text-align: center;
`;
var CaptionWrapper = styled15.div`
  display: flex;

  ${Select} {
    &:first-of-type {
      max-width: 120px;
      margin-right: 8px;
      min-width: 120px;
    }

    &:last-of-type {
      max-width: 80px;
      min-width: 80px;
    }
  }
`;
function Overlay({
  children,
  classNames,
  footer,
  input,
  portal,
  selectedDay: omit,
  attachmentRef,
  position,
  ...unhandledProps
}) {
  const { overlay, overlayWrapper } = classNames;
  if (portal && input) {
    return /* @__PURE__ */ React13.createElement(Portal_default, null, /* @__PURE__ */ React13.createElement(Wrapper6, {
      role: "dialog",
      ...unhandledProps
    }, /* @__PURE__ */ React13.createElement("div", {
      ref: attachmentRef,
      className: overlay,
      style: position
    }, children, footer && /* @__PURE__ */ React13.createElement(FooterWrapper, null, footer))));
  }
  return /* @__PURE__ */ React13.createElement("div", {
    role: "dialog",
    className: overlayWrapper,
    ...unhandledProps
  }, /* @__PURE__ */ React13.createElement("div", {
    className: overlay
  }, children, footer && /* @__PURE__ */ React13.createElement(FooterWrapper, null, footer)));
}
Overlay.propTypes = {
  children: PropTypes12.node,
  classNames: PropTypes12.shape({
    overlay: PropTypes12.string,
    overlayWrapper: PropTypes12.string
  }),
  footer: PropTypes12.oneOfType([PropTypes12.node, PropTypes12.func]),
  input: PropTypes12.instanceOf(HTMLElement),
  portal: PropTypes12.bool,
  selectedDay: PropTypes12.instanceOf(Date),
  attachmentRef: PropTypes12.oneOfType([PropTypes12.func, PropTypes12.object]),
  position: PropTypes12.shape({
    top: PropTypes12.number,
    bottom: PropTypes12.number,
    left: PropTypes12.number,
    right: PropTypes12.number
  })
};
function Caption2({ classNames, date, onChange, portal }) {
  const month = date.getMonth();
  const year = date.getFullYear();
  const fallback = { label: `${year}`, value: year };
  const overrides = {
    menuList: (provided) => ({
      ...provided,
      maxHeight: "420px"
    })
  };
  const handleMonthChange = ({ value }) => {
    const next = new Date(date);
    onChange(new Date(next.setMonth(value)));
  };
  const handleYearChange = ({ value }) => {
    const next = new Date(date);
    onChange(new Date(next.setFullYear(value)));
  };
  return /* @__PURE__ */ React13.createElement("div", {
    className: classNames.caption
  }, /* @__PURE__ */ React13.createElement(CaptionWrapper, null, /* @__PURE__ */ React13.createElement(Select, {
    name: "Month picker",
    onChange: handleMonthChange,
    options: MONTH_OPTIONS,
    portal,
    styles: overrides,
    value: MONTH_OPTIONS.find(({ value }) => value === month)
  }), /* @__PURE__ */ React13.createElement(Select, {
    name: "Year picker",
    onChange: handleYearChange,
    options: YEAR_OPTIONS,
    portal,
    styles: overrides,
    value: YEAR_OPTIONS.find(({ value }) => value === year) || fallback
  })));
}
Caption2.propTypes = {
  classNames: PropTypes12.shape({
    caption: PropTypes12.string
  }),
  date: PropTypes12.instanceOf(Date),
  onChange: PropTypes12.func,
  portal: PropTypes12.bool
};
var DayInput = React13.forwardRef((props, ref) => {
  return /* @__PURE__ */ React13.createElement(Input_default, {
    ref: ($ele) => {
      ref($ele);
      props.setTargetRef($ele);
    },
    ...props
  });
});
DayInput.propTypes = {
  setTargetRef: PropTypes12.func
};
function DateInput({
  future = false,
  className,
  dayPickerProps = {},
  footer,
  inputProps: { error, ...inputProps } = {},
  onChange,
  onDayChange,
  onDayClick,
  onDayPickerHide,
  portal,
  value,
  placement = "bottom",
  ...unhandledProps
}) {
  const $picker = useRef5();
  const [{ staged, status }, setStaged] = useState7({});
  const [invalid, setInvalid] = useState7(false);
  const [isOpen, setIsOpen] = useState7(false);
  const [refs, position] = usePosition({ placement, visible: isOpen });
  const reset = () => {
    setStaged({});
    setInvalid(false);
  };
  useEffect6(reset, [value]);
  const endOfToday = useMemo3(() => {
    return endOf(Date.now(), "day");
  }, []);
  const handleDayChange = (date, ...rest) => {
    setStaged({ status: "commit", staged: date });
    onDayChange == null ? void 0 : onDayChange(date, ...rest);
  };
  const handleDayClick = (date, modifiers, ...rest) => {
    date.setHours(0);
    setStaged(modifiers.disabled ? {} : { status: "commit", staged: date });
    onDayClick == null ? void 0 : onDayClick(date, modifiers, ...rest, $picker.current);
  };
  const handleDayPickerShow = () => {
    setIsOpen(true);
  };
  const handleDayPickerHide = () => {
    const $input = $picker.current.input;
    const valid = validateDate($input.value, future);
    const previous = value && new Date(value);
    setIsOpen(false);
    switch (status) {
      case "commit":
        onChange == null ? void 0 : onChange(valid ? staged : previous);
        break;
      case "revert":
        onChange == null ? void 0 : onChange(previous);
        break;
      default:
        break;
    }
    setInvalid(!previous && !valid);
    setStaged({});
    onDayPickerHide == null ? void 0 : onDayPickerHide();
  };
  const handleInputKeyDown = (event, ...rest) => {
    var _a;
    const $input = $picker.current.input;
    switch (event.key) {
      case "Enter":
        $input.blur();
        break;
      case "Escape":
        setStaged({ status: status && "revert" });
        $input.blur();
        break;
      default:
        break;
    }
    (_a = inputProps.onKeyDown) == null ? void 0 : _a.call(inputProps, event, ...rest);
  };
  const overlay = (args) => /* @__PURE__ */ React13.createElement(Overlay, {
    attachmentRef: refs.attachment,
    position,
    footer,
    portal,
    ...args
  });
  const caption = (args) => /* @__PURE__ */ React13.createElement(Caption2, {
    onChange: handleDayChange,
    portal,
    ...args
  });
  return /* @__PURE__ */ React13.createElement(Wrapper6, {
    className
  }, /* @__PURE__ */ React13.createElement(DayPickerInput, {
    key: value,
    ref: $picker,
    onDayPickerShow: handleDayPickerShow,
    component: DayInput,
    dayPickerProps: {
      ...dayPickerProps,
      captionElement: caption,
      classNames: classes,
      disabledDays: [
        future ? {} : { after: endOfToday },
        ...dayPickerProps.disabledDays || []
      ],
      initialMonth: value,
      month: staged || value,
      onDayClick: handleDayClick,
      showOutsideDays: true,
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"]
    },
    format: DATE_FORMAT,
    formatDate: (date) => format(date, DATE_FORMAT),
    inputProps: {
      "aria-invalid": error || invalid,
      "aria-label": "Date picker",
      type: "text",
      error: error || invalid,
      onKeyDown: handleInputKeyDown,
      setTargetRef: ($ele) => {
        refs.target.current = $ele;
      },
      ...inputProps
    },
    keepFocus: false,
    onDayChange: handleDayChange,
    onDayPickerHide: handleDayPickerHide,
    overlayComponent: overlay,
    parseDate: parse,
    placeholder: "MM/DD/YY",
    value,
    ...unhandledProps
  }));
}
DateInput.propTypes = {
  dayPickerProps: PropTypes12.object,
  inputProps: PropTypes12.object,
  footer: PropTypes12.oneOfType([PropTypes12.node, PropTypes12.func]),
  future: PropTypes12.bool,
  onChange: PropTypes12.func,
  onDayClick: PropTypes12.func,
  className: PropTypes12.string,
  onDayChange: PropTypes12.func,
  onDayPickerHide: PropTypes12.func,
  portal: PropTypes12.bool,
  value: PropTypes12.instanceOf(Date),
  placement: PropTypes12.oneOf(["bottom", "top"])
};
var DateInput_default = styled15(DateInput)``;

// src/DateRangeInputs.js
import React14 from "react";
import PropTypes13 from "prop-types";
import styled16 from "styled-components";
var Wrapper7 = styled16.div`
  align-items: center;
  display: flex;
`;
var DateLabel = styled16(Label_default)`
  color: var(--datepicker-label);
  font-size: var(--x-small);
  font-weight: var(--normal);
  width: 100%;

  > :first-child {
    margin-top: 4px;
  }
`;
var Separator = styled16.span`
  color: var(--datepicker-separator);
  padding-top: 16px;

  ::before {
    content: '-';
    margin: 0 8px;
  }
`;
function DateRangeInputs({
  className,
  disabled = false,
  endProps = {},
  onChange,
  onDayClick,
  portal = false,
  startProps = {},
  value: { start, end } = {}
}) {
  const handleChangeFor = (changed) => (value) => {
    const next = { start, end, [changed]: value };
    const sanitized = sanitizeDates(next, changed);
    onChange == null ? void 0 : onChange(sanitized, changed);
  };
  const handleDayClickFor = (changed) => (value, ...unhandledProps) => {
    const next = { start, end, [changed]: value };
    const sanitized = sanitizeDates(next, changed);
    onDayClick == null ? void 0 : onDayClick(sanitized, changed, ...unhandledProps);
  };
  return /* @__PURE__ */ React14.createElement(Wrapper7, {
    className
  }, /* @__PURE__ */ React14.createElement(DateLabel, {
    htmlFor: "start"
  }, "Start", /* @__PURE__ */ React14.createElement(DateInput_default, {
    ...startProps,
    inputProps: {
      ...startProps.inputProps,
      "aria-label": "Start date",
      name: "start",
      disabled
    },
    onChange: handleChangeFor("start"),
    onDayClick: handleDayClickFor("start"),
    portal,
    value: start
  })), /* @__PURE__ */ React14.createElement(Separator, null), /* @__PURE__ */ React14.createElement(DateLabel, {
    htmlFor: "end"
  }, "End", /* @__PURE__ */ React14.createElement(DateInput_default, {
    ...endProps,
    inputProps: {
      ...endProps.inputProps,
      "aria-label": "End date",
      name: "end",
      disabled
    },
    onChange: handleChangeFor("end"),
    onDayClick: handleDayClickFor("end"),
    portal,
    value: end
  })));
}
DateRangeInputs.propTypes = {
  startProps: PropTypes13.object,
  endProps: PropTypes13.object,
  onChange: PropTypes13.func,
  onDayClick: PropTypes13.func,
  className: PropTypes13.string,
  disabled: PropTypes13.bool,
  portal: PropTypes13.bool,
  value: PropTypes13.shape({
    start: PropTypes13.instanceOf(Date),
    end: PropTypes13.instanceOf(Date)
  })
};
var DateRangeInputs_default = styled16(DateRangeInputs)``;

// src/DateRangePicker.js
import React15, { useCallback as useCallback2 } from "react";
import PropTypes14 from "prop-types";
import styled17 from "styled-components";
var Wrapper8 = styled17.div`
  align-items: stretch;
  display: flex;

  ${({ stacked }) => stacked ? `
          flex-direction: column;

          ${Select} {
            margin-bottom: 8px;
            max-width: unset;
          }
        ` : `
          flex-direction: row;

          ${Select} {
            margin-right: 16px;
            max-width: 180px;
            min-width: 180px;
          }

          ${DateRangeInputs_default} {
            margin-top: 4px;
          }

          ${DateInput_default} {
            width: 125px;
          }
        `}
`;
function DateRangePicker({
  calculate,
  className,
  onChange,
  options = [],
  portal = false,
  stacked = false,
  value: initial = {},
  ...unhandledProps
}) {
  const [{ range, start, end }, setValue] = useDateRange(
    options,
    initial,
    calculate
  );
  const handleTypeChange = useCallback2(
    ({ value: selected }) => {
      const next = calculateDatesFor(selected, calculate);
      setValue(next);
      onChange == null ? void 0 : onChange(next);
    },
    [calculate, onChange, setValue]
  );
  const handleDateChange = useCallback2(
    (dates) => {
      const next = { range: "custom", ...dates };
      setValue(next);
      onChange == null ? void 0 : onChange(next);
    },
    [onChange, setValue]
  );
  return /* @__PURE__ */ React15.createElement(Wrapper8, {
    className,
    stacked
  }, /* @__PURE__ */ React15.createElement(Label_default, {
    htmlFor: "range"
  }, "Date range", /* @__PURE__ */ React15.createElement(Select, {
    name: "range",
    onChange: handleTypeChange,
    options,
    portal,
    value: options.find(({ value: selected }) => selected === range)
  })), /* @__PURE__ */ React15.createElement(DateRangeInputs_default, {
    ...unhandledProps,
    disabled: range !== "custom",
    onChange: handleDateChange,
    portal,
    value: { start, end }
  }));
}
DateRangePicker.propTypes = {
  ...DateRangeInputs_default.propTypes,
  calculate: PropTypes14.func,
  className: PropTypes14.string,
  onChange: PropTypes14.func,
  options: PropTypes14.arrayOf(
    PropTypes14.shape({
      label: PropTypes14.string,
      value: PropTypes14.oneOfType([PropTypes14.string, PropTypes14.number])
    })
  ),
  portal: PropTypes14.bool,
  stacked: PropTypes14.bool,
  value: PropTypes14.shape({
    range: PropTypes14.oneOfType([PropTypes14.string, PropTypes14.number]),
    start: PropTypes14.instanceOf(Date),
    end: PropTypes14.instanceOf(Date)
  })
};
var DateRangePicker_default = styled17(DateRangePicker)``;

// src/DateRangeDropdown.js
import React17, { useState as useState9 } from "react";
import PropTypes16 from "prop-types";
import styled19 from "styled-components";
import isEqual from "lodash.isequal";

// src/Dropdown.js
import React16, {
  Children,
  cloneElement,
  useEffect as useEffect10,
  useMemo as useMemo4,
  useState as useState8,
  forwardRef as forwardRef2,
  useImperativeHandle
} from "react";
import PropTypes15 from "prop-types";
import styled18 from "styled-components";

// src/hooks/use-click-outside.js
import { useEffect as useEffect7 } from "react";
function useClickOutside(refs, onClickOutside) {
  useEffect7(() => {
    if (!refs || refs.length === 0) {
      return;
    }
    const handler = (event) => {
      const { target } = event;
      const inside = refs.filter(({ current }) => current).some(({ current }) => target === current || current.contains(target));
      if (!inside && typeof onClickOutside === "function") {
        onClickOutside(event);
      }
    };
    document.addEventListener("click", handler, true);
    return () => {
      document.removeEventListener("click", handler, true);
    };
  }, [refs, onClickOutside]);
}

// src/hooks/use-is-mounted.js
import { useEffect as useEffect8, useRef as useRef6 } from "react";
var useIsMounted = () => {
  const mounted = useRef6(false);
  useEffect8(() => {
    mounted.current = true;
  }, []);
  return mounted.current;
};
var use_is_mounted_default = useIsMounted;

// src/hooks/use-escape.js
import { useEffect as useEffect9 } from "react";
function useEscape(handler, capture = false) {
  useEffect9(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape" && typeof handler === "function") {
        handler(event);
      }
    };
    document.addEventListener("keydown", onKeyDown, capture);
    return () => {
      document.removeEventListener("keydown", onKeyDown, capture);
    };
  }, [capture, handler]);
}

// src/Dropdown.js
var Target = styled18.div.attrs({ role: "button" })`
  cursor: pointer;
`;
var Attachment = styled18.div`
  background: var(--white);
  border-radius: 6px;
  box-shadow: var(--dropdown-menu-shadow);
  color: var(--dropdown-text);
  margin-top: 6px;
  padding: 8px;
  position: fixed;
  z-index: var(--z-index-300);
`;
var Dropdown = forwardRef2(
  ({
    attachment,
    children,
    disabled = false,
    closeOnEscape = true,
    placement = "right",
    open = false,
    onShow = () => {
    },
    onHide = () => {
    },
    ...unhandledProps
  }, ref) => {
    const isMounted = use_is_mounted_default();
    const [visible, setIsVisible] = useState8(!disabled && open);
    const toggleVisible = () => {
      if (!disabled) {
        setIsVisible((current) => !current);
      }
    };
    const [refs, position, reposition] = usePosition({ placement, visible });
    useImperativeHandle(ref, () => ({
      reposition
    }));
    useClickOutside([refs.target, refs.attachment], visible && toggleVisible);
    useEscape(visible && closeOnEscape && toggleVisible);
    useEffect10(() => {
      setIsVisible(!disabled && open);
    }, [disabled, open]);
    useEffect10(() => {
      if (!isMounted) {
        return;
      }
      if (visible) {
        onShow();
      } else {
        onHide();
      }
    }, [visible]);
    const render = (element) => {
      if (typeof element === "function") {
        return element({ onClose: toggleVisible, visible });
      }
      const child = Children.only(element);
      return cloneElement(child, { onClose: toggleVisible });
    };
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(Target, {
      ...unhandledProps,
      "aria-disabled": disabled,
      ref: refs.target,
      onClick: toggleVisible
    }, render(children)), /* @__PURE__ */ React16.createElement(Portal_default, null, visible ? /* @__PURE__ */ React16.createElement(Attachment, {
      ref: refs.attachment,
      style: position
    }, render(attachment)) : null));
  }
);
Dropdown.propTypes = {
  attachment: PropTypes15.oneOfType([PropTypes15.func, PropTypes15.node]),
  children: PropTypes15.oneOfType([PropTypes15.func, PropTypes15.node]),
  closeOnEscape: PropTypes15.bool,
  disabled: PropTypes15.bool,
  placement: PropTypes15.oneOf(["left", "right"]),
  open: PropTypes15.bool,
  onShow: PropTypes15.func,
  onHide: PropTypes15.func
};
var Dropdown_default = styled18(Dropdown)``;
var List = styled18.ul.attrs({ role: "listbox" })`
  list-style: none;
`;
var LabelWrapper = styled18.div`
  display: flex;
  align-items: center;
`;
var Item2 = styled18.li.attrs({ role: "option" })`
  /* Link style overrides */
  --link-active-color: inherit;
  --link-color: inherit;
  --link-font-weight: inherit;
  --link-text-decoration: none;

  border-radius: 6px;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: var(--regular);
  font-weight: var(--normal);
  gap: 4px;
  justify-content: space-around;
  padding: 8px 12px;
  white-space: nowrap;

  :hover {
    background: var(--dropdown-option-bg);
    color: inherit;
  }

  ${({ isSelected }) => isSelected && `
      color: var(--dropdown-option-selected);
      font-weight: var(--bold);
    `}

  &[disabled] {
    pointer-events: none;
    color: var(--dirty-water);

    ${LabelWrapper} > ${Icon_default} {
      color: var(--dirty-water);
    }
  }

  ${Icon_default} {
    font-size: inherit;
    margin-right: 8px;
    width: 20px;
    color: var(--dropdown-icon);
  }
`;
function BaseMenuList({ options, onClose, ...unhandledProps }) {
  return /* @__PURE__ */ React16.createElement(List, {
    ...unhandledProps,
    onClick: onClose
  }, options.map(({ icon, isSelected, label, description, ...rest }) => /* @__PURE__ */ React16.createElement(Item2, {
    key: label,
    "aria-selected": isSelected,
    isSelected,
    ...rest
  }, /* @__PURE__ */ React16.createElement(LabelWrapper, null, icon && /* @__PURE__ */ React16.createElement(Icon_default, {
    icon
  }), label), description)));
}
BaseMenuList.propTypes = {
  options: PropTypes15.arrayOf(
    PropTypes15.shape({
      icon: PropTypes15.string,
      isSelected: PropTypes15.bool,
      label: PropTypes15.node
    })
  ),
  onClose: PropTypes15.func
};
var MenuList = styled18(BaseMenuList)``;
var Wrapper9 = styled18.div`
  align-items: center;
  color: var(--dropdown-text);
  display: flex;
  font-weight: var(--semi-bold);

  > ${Icon_default} {
    margin-right: 8px;
  }
`;
function BaseSortDropdown({ onChange, options, value, ...props }) {
  const items = useMemo4(() => {
    return options.map((option) => ({
      ...option,
      isSelected: value === option.value,
      onClick: (event) => onChange(option, event)
    }));
  }, [onChange, options, value]);
  const label = useMemo4(() => {
    const selected = options.find((option) => value === option.value);
    return (selected == null ? void 0 : selected.label) || "Sort by...";
  }, [options, value]);
  return /* @__PURE__ */ React16.createElement(Dropdown, {
    ...props,
    attachment: /* @__PURE__ */ React16.createElement(MenuList, {
      options: items
    })
  }, /* @__PURE__ */ React16.createElement(Wrapper9, null, /* @__PURE__ */ React16.createElement(Icon_default, {
    icon: "sort"
  }), label));
}
BaseSortDropdown.propTypes = {
  onChange: PropTypes15.func,
  options: PropTypes15.arrayOf(
    PropTypes15.shape({
      label: PropTypes15.string,
      value: PropTypes15.string
    })
  ),
  value: PropTypes15.string
};
var SortDropdown = styled18(BaseSortDropdown)``;

// src/DateRangeDropdown.js
var Wrapper10 = styled19.div``;
var Menu = styled19.div`
  padding: 18px 24px;

  ${ButtonGroup} {
    margin-top: 18px;
  }
`;
var Trigger = styled19(Button_default)`
  align-items: center;
  border: 1px solid var(--dropdown-inactive);
  color: var(--dropdown-text);
  display: flex;
  justify-content: space-between;
  text-transform: none;
  transition: ${easing("border")};

  :hover:not([disabled]) {
    border: 1px solid var(--dropdown-active);
    box-shadow: none;
  }

  ${Icon_default} {
    color: var(--dropdown-icon);
    font-size: var(--xx-small);
    margin-left: 16px;
    margin-right: 0;
  }

  ${({ active }) => active && `
      border: 1px solid var(--dropdown-active);
    `}
`;
var DateRangeLabel = styled19.span`
  font-weight: var(--normal);
  line-height: 1;
`;
var formatDateRangeLabel = ({ start, end }) => start && end ? `${format(start, DATE_FORMAT)} - ${format(end, DATE_FORMAT)}` : "Select date range...";
var DateRangeMenu = ({
  error,
  onApply,
  onChange,
  onClose,
  value: initial = {},
  ...unhandledProps
}) => {
  const [value, setValue] = useState9(initial);
  const handleApply = () => {
    onApply == null ? void 0 : onApply(value);
    onClose();
  };
  const handleChange = (next) => {
    setValue(next);
    onChange == null ? void 0 : onChange(next);
  };
  const { start, end } = value;
  const disabled = error || !(start && end) || isEqual(initial, value);
  return /* @__PURE__ */ React17.createElement(Menu, null, /* @__PURE__ */ React17.createElement(DateRangePicker_default, {
    ...unhandledProps,
    onChange: handleChange,
    value
  }), /* @__PURE__ */ React17.createElement(ButtonGroup, {
    right: true
  }, /* @__PURE__ */ React17.createElement(Button_default, {
    disabled,
    kind: "positive",
    onClick: handleApply
  }, "Apply"), /* @__PURE__ */ React17.createElement(Button_default, {
    kind: "secondary",
    onClick: onClose
  }, "Cancel")));
};
DateRangeMenu.propTypes = {
  ...DateRangePicker_default.propTypes,
  error: PropTypes16.bool,
  onApply: PropTypes16.func,
  onClose: PropTypes16.func
};
function DateRangeDropdown({
  className,
  disabled = false,
  error,
  onApply,
  options,
  value: initial = {},
  ...unhandledProps
}) {
  const [value, setValue] = useDateRange(options, initial);
  const handleApply = (next) => {
    setValue(next);
    onApply == null ? void 0 : onApply(next);
  };
  const attachment = ({ onClose }) => /* @__PURE__ */ React17.createElement(DateRangeMenu, {
    ...unhandledProps,
    disabled,
    error,
    onApply: handleApply,
    onClose,
    options,
    value
  });
  return /* @__PURE__ */ React17.createElement(Wrapper10, {
    className
  }, /* @__PURE__ */ React17.createElement(Dropdown_default, {
    attachment,
    closeOnEscape: false,
    disabled,
    placement: "left"
  }, ({ visible }) => /* @__PURE__ */ React17.createElement(Trigger, {
    "aria-label": "Open date range picker",
    active: visible,
    disabled,
    kind: "secondary"
  }, /* @__PURE__ */ React17.createElement(DateRangeLabel, null, formatDateRangeLabel(value)), /* @__PURE__ */ React17.createElement(Icon_default, {
    icon: `chevron-${visible ? "up" : "down"}`
  }))));
}
DateRangeDropdown.propTypes = {
  ...DateRangePicker_default.propTypes,
  disabled: PropTypes16.bool,
  error: PropTypes16.bool,
  onApply: PropTypes16.func,
  options: PropTypes16.arrayOf(
    PropTypes16.shape({
      label: PropTypes16.string,
      value: PropTypes16.oneOfType([PropTypes16.string, PropTypes16.number])
    })
  )
};
var DateRangeDropdown_default = styled19(DateRangeDropdown)``;

// src/DescriptiveList.js
import styled20 from "styled-components";
var Term = styled20.dt`
  float: left;
  font-weight: var(--bold);
  margin-right: 6px;
`;
var Definition = styled20.dd`
  align-items: center;
  display: flex;
`;
var DescriptiveList = styled20.dl`
  color: var(--descriptive-list-text);
  font-size: var(--regular);

  ${Definition}:not(:last-of-type),
  ${Term}:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;

// src/EmptyState.js
import React18 from "react";
import styled23 from "styled-components";
import PropTypes17 from "prop-types";

// src/Heading.js
import styled21 from "styled-components";
var H1 = styled21.h1`
  color: var(--heading-primary);
  font-weight: var(--bold);
  font-size: var(--xx-large);
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;
var H2 = styled21.h2`
  color: var(--heading-primary);
  font-weight: var(--normal);
  font-size: var(--x-large);
  line-height: 1.5em;
  letter-spacing: 0;
`;
var H3 = styled21.h3`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--large);
  line-height: 1.5em;
  letter-spacing: 0;
`;
var H4 = styled21.h4`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: 17px;
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;
var H5 = styled21.h5`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--small);
  line-height: 1.8em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

// src/Text.js
import styled22 from "styled-components";
var Text_default = styled22.p`
  --text-primary: var(--oh-hi-dark);
  --text-secondary: var(--sharkbait-ooh-la-la);
  --text-tertiary: var(--dirty-water);

  margin: 0;
  color: var(--text-primary);
  line-height: 1.5em;
  ${(props) => props.secondary && "color: var(--text-secondary)"};
  ${(props) => props.bold && "font-weight: var(--bold)"};
`;

// src/EmptyState.js
var EmptyStateWrapper = styled23.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
var ContentWrapper = styled23.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;
  max-width: 70%;
  text-align: center;
`;
var Headline = styled23(H3)`
  color: var(--pleather);
  margin-bottom: -5px;
`;
var Content2 = styled23(Text_default)`
  color: var(--pleather);
`;
var EmptyState = ({ action, children, headline, image }) => /* @__PURE__ */ React18.createElement(EmptyStateWrapper, null, /* @__PURE__ */ React18.createElement(ContentWrapper, null, image, headline && /* @__PURE__ */ React18.createElement(Headline, null, headline), /* @__PURE__ */ React18.createElement(Content2, null, children), action));
EmptyState.propTypes = {
  action: PropTypes17.node,
  children: PropTypes17.string.isRequired,
  headline: PropTypes17.string,
  image: PropTypes17.node.isRequired
};
var EmptyState_default = styled23(EmptyState)``;

// src/ExpandableText.js
import React19, { useEffect as useEffect11, useRef as useRef7, useState as useState10 } from "react";
import PropTypes18 from "prop-types";
import styled24 from "styled-components";
var Wrapper11 = styled24.div`
  display: flex;
  flex-direction: column;
`;
var Overflowable = styled24.span`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  display: -webkit-box;
  overflow: hidden;
`;
var Expand = styled24.span`
  align-self: flex-start;
  color: var(--primary);
  cursor: pointer;
  font-weight: var(--bold);

  :hover,
  :focus {
    color: var(--primary-dark);
  }

  :focus {
    outline: 1px solid var(--primary);
    outline-offset: 1px;
  }
`;
function ExpandableText({ children, className, lines = 1 }) {
  const ref = useRef7();
  const [expandable, setExpandable] = useState10(false);
  const [expanded, setExpanded] = useState10();
  useEffect11(() => {
    const { current: $text } = ref;
    const truncated = $text.scrollHeight > $text.clientHeight;
    setExpandable(truncated);
    setExpanded(!truncated);
  }, [children]);
  const toggle = () => {
    setExpanded((current) => !current);
  };
  return /* @__PURE__ */ React19.createElement(Wrapper11, {
    "aria-expanded": expanded,
    "aria-label": "Expandable text",
    className
  }, expanded && children, !expanded && /* @__PURE__ */ React19.createElement(Overflowable, {
    lines,
    ref
  }, children), expandable && /* @__PURE__ */ React19.createElement(Expand, {
    onClick: toggle,
    role: "button"
  }, "Show ", expanded ? "less" : "more"));
}
ExpandableText.propTypes = {
  children: PropTypes18.node,
  className: PropTypes18.string,
  lines: PropTypes18.number
};
var ExpandableText_default = styled24(ExpandableText)``;

// src/Fullscreen.js
import styled25 from "styled-components";
var Fullscreen = styled25.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 10000;
`;
var Fullscreen_default = Fullscreen;

// src/HorizontalScroll.js
import React20 from "react";
import PropTypes19 from "prop-types";
import styled26 from "styled-components";
import { useInView } from "react-intersection-observer";
var Wrapper12 = styled26.div`
  position: relative;
  width: 100%;

  &&::before,
  &&::after {
    align-items: center;
    background: none;
    border: none;
    bottom: 10px;
    content: '';
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 67px;
    z-index: 1;
  }

  &&::before {
    left: 0;
    background: linear-gradient(90deg, var(--white), transparent);
    ${({ $showLeftFade }) => $showLeftFade && "opacity: 1;"}
  }

  &&::after {
    right: 0;
    background: linear-gradient(270deg, var(--white), transparent);
    ${({ $showRightFade }) => $showRightFade && "opacity: 1;"}
  }
`;
var ScrollContent = styled26.div`
  display: flex;
  overflow: auto;
  position: relative;
  width: 100%;
`;
var EndCap = styled26.div`
  background-color: transparent;
  min-width: 1px;
`;
var LeftEndCap = styled26(EndCap)``;
var RightEndCap = styled26(EndCap)``;
var HorizontalScroll = ({ children }) => {
  const [leftRef, leftInView] = useInView();
  const [rightRef, rightInView] = useInView();
  return /* @__PURE__ */ React20.createElement(Wrapper12, {
    $showRightFade: !rightInView,
    $showLeftFade: !leftInView
  }, /* @__PURE__ */ React20.createElement(ScrollContent, null, /* @__PURE__ */ React20.createElement(LeftEndCap, {
    ref: leftRef
  }), children, /* @__PURE__ */ React20.createElement(RightEndCap, {
    ref: rightRef
  })));
};
HorizontalScroll.propTypes = {
  children: PropTypes19.node
};
var HorizontalScroll_default = styled26(HorizontalScroll)``;

// src/ListRow.js
import React28 from "react";
import PropTypes20 from "prop-types";
import styled27 from "styled-components";

// node_modules/@radix-ui/react-id/dist/index.module.js
import * as e from "react";

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i6 = 1; i6 < arguments.length; i6++) {
      var source = arguments[i6];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// node_modules/@radix-ui/react-id/dist/index.module.js
var t = { prefix: Math.round(1e10 * Math.random()), current: 0 };
var n = /* @__PURE__ */ e.createContext(t);
function useId(r18) {
  const o17 = e.useContext(n);
  return Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) || o17 !== t || console.warn("When server rendering, you must wrap your application in an <IdProvider> to ensure consistent ids are generated between the client and server."), e.useMemo(() => r18 || `radix-id-${o17.prefix}-${++o17.current}`, [r18]);
}

// ../../node_modules/@radix-ui/react-focus-guards/dist/index.module.js
import * as e2 from "react";
var t2 = 0;
function useFocusGuards() {
  e2.useEffect(() => {
    var e16, n7;
    const r18 = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", null !== (e16 = r18[0]) && void 0 !== e16 ? e16 : o()), document.body.insertAdjacentElement("beforeend", null !== (n7 = r18[1]) && void 0 !== n7 ? n7 : o()), t2++, () => {
      1 === t2 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e17) => e17.remove()), t2--;
    };
  }, []);
}
function o() {
  const e16 = document.createElement("span");
  return e16.setAttribute("data-radix-focus-guard", ""), e16.tabIndex = 0, e16.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e16;
}

// ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import * as e3 from "react";
function useCallbackRef(r18) {
  const t18 = e3.useRef(r18);
  return e3.useEffect(() => {
    t18.current = r18;
  }), e3.useMemo(() => (...e16) => {
    var r19;
    return null === (r19 = t18.current) || void 0 === r19 ? void 0 : r19.call(t18, ...e16);
  }, []);
}

// ../../node_modules/@radix-ui/react-use-direction/dist/index.module.js
import * as e4 from "react";
function useDirection(t18, n7) {
  const [r18, o17] = e4.useState("ltr"), [i6, u6] = e4.useState(), c8 = e4.useRef(0);
  return e4.useEffect(() => {
    if (void 0 === n7 && null != t18 && t18.parentElement) {
      const e16 = getComputedStyle(t18.parentElement);
      u6(e16);
    }
  }, [t18, n7]), e4.useEffect(() => (void 0 === n7 && function e16() {
    c8.current = requestAnimationFrame(() => {
      const t19 = null == i6 ? void 0 : i6.direction;
      t19 && o17(t19), e16();
    });
  }(), () => cancelAnimationFrame(c8.current)), [i6, n7, o17]), n7 || r18;
}

// node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import * as t3 from "react";
function useControllableState({ prop: o17, defaultProp: r18, onChange: n7 = () => {
} }) {
  const [a5, u6] = function({ defaultProp: o18, onChange: r19 }) {
    const n8 = t3.useState(o18), [a6] = n8, u7 = t3.useRef(a6), c9 = useCallbackRef(r19);
    return t3.useEffect(() => {
      u7.current !== a6 && (c9(a6), u7.current = a6);
    }, [a6, u7, c9]), n8;
  }({ defaultProp: r18, onChange: n7 }), c8 = void 0 !== o17, f7 = c8 ? o17 : a5, l8 = useCallbackRef(n7);
  return [f7, t3.useCallback((e16) => {
    if (c8) {
      const t18 = e16, r19 = "function" == typeof e16 ? t18(o17) : e16;
      r19 !== o17 && l8(r19);
    } else
      u6(e16);
  }, [c8, o17, u6, l8])];
}

// node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o2 from "react";
function composeRefs(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}
function useComposedRefs(...e16) {
  return o2.useCallback(composeRefs(...e16), e16);
}

// node_modules/@radix-ui/react-slot/dist/index.module.js
import * as t4 from "react";
var Slot = /* @__PURE__ */ t4.forwardRef((e16, o17) => {
  const { children: l8, ...c8 } = e16;
  return 1 === t4.Children.count(l8) ? /* @__PURE__ */ t4.createElement(r, _extends({}, c8, { ref: o17 }), l8) : /* @__PURE__ */ t4.createElement(t4.Fragment, null, t4.Children.map(l8, (e17) => /* @__PURE__ */ t4.isValidElement(e17) && e17.type === Slottable ? /* @__PURE__ */ t4.createElement(r, _extends({}, c8, { ref: o17 }), e17.props.children) : e17));
});
Slot.displayName = "Slot";
var r = /* @__PURE__ */ t4.forwardRef((n7, r18) => {
  const { children: l8, ...c8 } = n7, i6 = t4.Children.only(l8);
  return t4.isValidElement(i6) ? /* @__PURE__ */ t4.cloneElement(i6, { ...o3(c8, i6.props), ref: composeRefs(r18, i6.ref) }) : null;
});
r.displayName = "SlotClone";
var Slottable = ({ children: e16 }) => e16;
function o3(e16, t18) {
  const n7 = { ...t18 };
  for (const r18 in t18) {
    const o17 = e16[r18], c8 = t18[r18];
    /^on[A-Z]/.test(r18) ? n7[r18] = l(c8, o17) : "style" === r18 ? n7[r18] = { ...o17, ...c8 } : "className" === r18 && (n7[r18] = [o17, c8].filter(Boolean).join(" "));
  }
  return { ...e16, ...n7 };
}
function l(e16, t18) {
  return function(...n7) {
    null == e16 || e16(...n7);
    n7[0] instanceof Event && n7[0].defaultPrevented || null == t18 || t18(...n7);
  };
}

// node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r2 from "react";
var Primitive = ["a", "button", "div", "h2", "h3", "p", "img", "span", "svg"].reduce((i6, s8) => ({ ...i6, [s8]: /* @__PURE__ */ r2.forwardRef((i7, n7) => {
  const { asChild: a5, ...m5 } = i7, d9 = a5 ? Slot : s8;
  return i7.as && console.error(o4), /* @__PURE__ */ r2.createElement(d9, _extends({}, m5, { ref: n7 }));
}) }), {});
var o4 = "Warning: The `as` prop has been removed in favour of `asChild`. For details, see https://radix-ui.com/docs/primitives/overview/styling#changing-the-rendered-element";

// node_modules/@radix-ui/react-context/dist/index.module.js
import * as e5 from "react";
function createContext3(t18) {
  const r18 = /* @__PURE__ */ e5.createContext(null);
  function n7(t19) {
    const { children: n8, ...o17 } = t19, u6 = e5.useMemo(() => o17, Object.values(o17));
    return e5.createElement(r18.Provider, { value: u6 }, n8);
  }
  return n7.displayName = t18 + "Provider", [n7, function(n8) {
    const o17 = e5.useContext(r18);
    if (null === o17)
      throw new Error(`\`${n8}\` must be used within \`${t18}\``);
    return o17;
  }];
}

// node_modules/@radix-ui/react-collection/dist/index.module.js
import t5 from "react";
function createCollection() {
  const n7 = /* @__PURE__ */ t5.createContext({}), o17 = (e16) => {
    const { children: r18 } = e16, o18 = t5.useRef(null), c9 = t5.useRef(/* @__PURE__ */ new Map()).current;
    return t5.createElement(n7.Provider, { value: t5.useMemo(() => ({ itemMap: c9, collectionRef: o18 }), [c9]) }, r18);
  }, c8 = /* @__PURE__ */ t5.forwardRef((o18, c9) => {
    const { children: f8 } = o18, l9 = t5.useContext(n7), u6 = useComposedRefs(c9, l9.collectionRef);
    return t5.createElement(Slot, { ref: u6 }, f8);
  }), f7 = "data-radix-collection-item", l8 = /* @__PURE__ */ t5.forwardRef((o18, c9) => {
    const { children: l9, ...u6 } = o18, i6 = t5.useRef(null), a5 = useComposedRefs(c9, i6), s8 = t5.useContext(n7);
    return t5.useEffect(() => (s8.itemMap.set(i6, { ref: i6, ...u6 }), () => {
      s8.itemMap.delete(i6);
    })), /* @__PURE__ */ t5.createElement(Slot, { [f7]: "", ref: a5 }, l9);
  });
  return [o17, c8, l8, function() {
    const e16 = t5.useContext(n7);
    return { getItems() {
      const r18 = Array.from(e16.collectionRef.current.querySelectorAll(`[${f7}]`));
      return Array.from(e16.itemMap.values()).sort((e17, t18) => r18.indexOf(e17.ref.current) - r18.indexOf(t18.ref.current));
    } };
  }];
}

// node_modules/@radix-ui/primitive/dist/index.module.js
function composeEventHandlers(e16, n7, { checkForDefaultPrevented: t18 = true } = {}) {
  return function(r18) {
    if (null == e16 || e16(r18), false === t18 || !r18.defaultPrevented)
      return null == n7 ? void 0 : n7(r18);
  };
}

// node_modules/@radix-ui/react-roving-focus/dist/index.module.js
import * as u from "react";
var f = { bubbles: false, cancelable: true };
var [l2, m, p, d] = createCollection();
var [v, g] = createContext3("RovingFocusGroup");
var RovingFocusGroup = /* @__PURE__ */ u.forwardRef((e16, t18) => /* @__PURE__ */ u.createElement(l2, null, /* @__PURE__ */ u.createElement(m, null, /* @__PURE__ */ u.createElement(w, _extends({}, e16, { ref: t18 })))));
var w = /* @__PURE__ */ u.forwardRef((o17, n7) => {
  const { orientation: a5, dir: l8 = "ltr", loop: m5 = false, currentTabStopId: p5, defaultCurrentTabStopId: g3, onCurrentTabStopIdChange: w3, onEntryFocus: b3, ...F2 } = o17, E4 = u.useRef(null), I2 = useComposedRefs(n7, E4), [R3 = null, h2] = useControllableState({ prop: p5, defaultProp: g3, onChange: w3 }), [T2, A3] = u.useState(false), y2 = useCallbackRef(b3), { getItems: D2 } = d(), S2 = u.useRef(false);
  return u.useEffect(() => {
    const e16 = E4.current;
    if (e16)
      return e16.addEventListener("rovingFocusGroup.onEntryFocus", y2), () => e16.removeEventListener("rovingFocusGroup.onEntryFocus", y2);
  }, [y2]), /* @__PURE__ */ u.createElement(v, { orientation: a5, dir: l8, loop: m5, currentTabStopId: R3, onItemFocus: u.useCallback((e16) => h2(e16), [h2]), onItemShiftTab: u.useCallback(() => A3(true), []) }, /* @__PURE__ */ u.createElement(Primitive.div, _extends({ tabIndex: T2 ? -1 : 0, "aria-orientation": a5, "data-orientation": a5 }, F2, { ref: I2, style: { outline: "none", ...o17.style }, onMouseDown: composeEventHandlers(o17.onMouseDown, () => {
    S2.current = true;
  }), onFocus: composeEventHandlers(o17.onFocus, (e16) => {
    const t18 = !S2.current;
    if (e16.target === e16.currentTarget && t18 && !T2) {
      const t19 = new Event("rovingFocusGroup.onEntryFocus", f);
      if (e16.currentTarget.dispatchEvent(t19), !t19.defaultPrevented) {
        const e17 = D2().filter((e18) => e18.focusable);
        x([e17.find((e18) => e18.active), e17.find((e18) => e18.id === R3), ...e17].filter(Boolean).map((e18) => e18.ref.current));
      }
    }
    S2.current = false;
  }), onBlur: composeEventHandlers(o17.onBlur, () => A3(false)) })));
});
var RovingFocusItem = /* @__PURE__ */ u.forwardRef((e16, t18) => {
  const { focusable: n7 = true, active: i6 = false, ...a5 } = e16, f7 = useId(), l8 = g("RovingFocusItem"), m5 = l8.currentTabStopId === f7, { getItems: v4 } = d();
  return u.createElement(p, { id: f7, focusable: n7, active: i6 }, /* @__PURE__ */ u.createElement(Primitive.span, _extends({ tabIndex: m5 ? 0 : -1, "data-orientation": l8.orientation }, a5, { ref: t18, onMouseDown: composeEventHandlers(e16.onMouseDown, (e17) => {
    n7 ? l8.onItemFocus(f7) : e17.preventDefault();
  }), onFocus: composeEventHandlers(e16.onFocus, () => l8.onItemFocus(f7)), onKeyDown: composeEventHandlers(e16.onKeyDown, (e17) => {
    if ("Tab" === e17.key && e17.shiftKey)
      return void l8.onItemShiftTab();
    if (e17.target !== e17.currentTarget)
      return;
    const t19 = function(e18, t20, r19) {
      const o18 = function(e19, t21) {
        return "rtl" !== t21 ? e19 : "ArrowLeft" === e19 ? "ArrowRight" : "ArrowRight" === e19 ? "ArrowLeft" : e19;
      }(e18.key, r19);
      return "vertical" === t20 && ["ArrowLeft", "ArrowRight"].includes(o18) || "horizontal" === t20 && ["ArrowUp", "ArrowDown"].includes(o18) ? void 0 : b[o18];
    }(e17, l8.orientation, l8.dir);
    if (void 0 !== t19) {
      e17.preventDefault();
      let n8 = v4().filter((e18) => e18.focusable).map((e18) => e18.ref.current);
      if ("last" === t19)
        n8.reverse();
      else if ("prev" === t19 || "next" === t19) {
        "prev" === t19 && n8.reverse();
        const i7 = n8.indexOf(e17.currentTarget);
        n8 = l8.loop ? (o17 = i7 + 1, (r18 = n8).map((e18, t20) => r18[(o17 + t20) % r18.length])) : n8.slice(i7 + 1);
      }
      setTimeout(() => x(n8));
    }
    var r18, o17;
  }) })));
});
var b = { ArrowLeft: "prev", ArrowUp: "prev", ArrowRight: "next", ArrowDown: "next", PageUp: "first", Home: "first", PageDown: "last", End: "last" };
function x(e16) {
  const t18 = document.activeElement;
  for (const r18 of e16) {
    if (r18 === t18)
      return;
    if (r18.focus(), document.activeElement !== t18)
      return;
  }
}

// ../../node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import * as o5 from "react";
var useLayoutEffect4 = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? o5.useLayoutEffect : () => {
};

// node_modules/@radix-ui/react-portal/dist/index.module.js
import e6 from "react-dom";
import * as r3 from "react";
var Portal2 = /* @__PURE__ */ r3.forwardRef((i6, a5) => {
  var d9, n7;
  const { containerRef: m5, style: s8, ...u6 } = i6, c8 = null !== (d9 = null == m5 ? void 0 : m5.current) && void 0 !== d9 ? d9 : null === globalThis || void 0 === globalThis || null === (n7 = globalThis.document) || void 0 === n7 ? void 0 : n7.body, [, f7] = r3.useState({});
  return useLayoutEffect4(() => {
    f7({});
  }, []), c8 ? /* @__PURE__ */ e6.createPortal(/* @__PURE__ */ r3.createElement(Primitive.div, _extends({ "data-radix-portal": "" }, u6, { ref: a5, style: c8 === document.body ? { position: "absolute", top: 0, left: 0, zIndex: 2147483647, ...s8 } : void 0 })), c8) : null;
});

// node_modules/@radix-ui/react-use-size/dist/index.module.js
import * as e7 from "react";
function useSize(r18) {
  const [i6, t18] = e7.useState(void 0);
  return e7.useEffect(() => {
    if (r18) {
      const e16 = new ResizeObserver((e17) => {
        if (!Array.isArray(e17))
          return;
        if (!e17.length)
          return;
        const i7 = e17[0];
        let o17, n7;
        if ("borderBoxSize" in i7) {
          const e18 = i7.borderBoxSize, r19 = Array.isArray(e18) ? e18[0] : e18;
          o17 = r19.inlineSize, n7 = r19.blockSize;
        } else {
          const e18 = r18.getBoundingClientRect();
          o17 = e18.width, n7 = e18.height;
        }
        t18({ width: o17, height: n7 });
      });
      return e16.observe(r18, { box: "border-box" }), () => {
        t18(void 0), e16.unobserve(r18);
      };
    }
  }, [r18]), i6;
}

// node_modules/@radix-ui/rect/dist/index.module.js
function observeElementRect(n7, o17) {
  const a5 = e8.get(n7);
  return void 0 === a5 ? (e8.set(n7, { rect: {}, callbacks: [o17] }), 1 === e8.size && (t6 = requestAnimationFrame(c))) : a5.callbacks.push(o17), () => {
    const c8 = e8.get(n7);
    if (void 0 === c8)
      return;
    const a6 = c8.callbacks.indexOf(o17);
    a6 > -1 && c8.callbacks.splice(a6, 1), 0 === c8.callbacks.length && (e8.delete(n7), 0 === e8.size && cancelAnimationFrame(t6));
  };
}
var t6;
var e8 = /* @__PURE__ */ new Map();
function c() {
  const n7 = [];
  e8.forEach((t18, e16) => {
    const c8 = e16.getBoundingClientRect();
    var o17, a5;
    o17 = t18.rect, a5 = c8, (o17.width !== a5.width || o17.height !== a5.height || o17.top !== a5.top || o17.right !== a5.right || o17.bottom !== a5.bottom || o17.left !== a5.left) && (t18.rect = c8, n7.push(t18));
  }), n7.forEach((t18) => {
    t18.callbacks.forEach((e16) => e16(t18.rect));
  }), t6 = requestAnimationFrame(c);
}

// node_modules/@radix-ui/react-use-rect/dist/index.module.js
import * as r4 from "react";
function useRect(e16) {
  const [o17, c8] = r4.useState();
  return r4.useEffect(() => {
    if (e16) {
      const r18 = observeElementRect(e16, c8);
      return () => {
        c8(void 0), r18();
      };
    }
  }, [e16]), o17;
}

// ../../node_modules/@radix-ui/popper/dist/index.module.js
function getPlacementData({ anchorRect: p5, popperSize: c8, arrowSize: f7, arrowOffset: l8 = 0, side: d9, sideOffset: h2 = 0, align: x4, alignOffset: g3 = 0, shouldAvoidCollisions: u6 = true, collisionBoundariesRect: w3, collisionTolerance: m5 = 0 }) {
  if (!p5 || !c8 || !w3)
    return { popperStyles: o6, arrowStyles: n2 };
  const y2 = function(e16, r18, o17 = 0, n7 = 0, i6) {
    const p6 = i6 ? i6.height : 0, a5 = t7(r18, e16, "x"), s8 = t7(r18, e16, "y"), c9 = s8.before - o17 - p6, f8 = s8.after + o17 + p6, l9 = a5.before - o17 - p6, d10 = a5.after + o17 + p6;
    return { top: { start: { x: a5.start + n7, y: c9 }, center: { x: a5.center, y: c9 }, end: { x: a5.end - n7, y: c9 } }, right: { start: { x: d10, y: s8.start + n7 }, center: { x: d10, y: s8.center }, end: { x: d10, y: s8.end - n7 } }, bottom: { start: { x: a5.start + n7, y: f8 }, center: { x: a5.center, y: f8 }, end: { x: a5.end - n7, y: f8 } }, left: { start: { x: l9, y: s8.start + n7 }, center: { x: l9, y: s8.center }, end: { x: l9, y: s8.end - n7 } } };
  }(c8, p5, h2, g3, f7), b3 = y2[d9][x4];
  if (false === u6) {
    const t18 = e9(b3);
    let o17 = n2;
    f7 && (o17 = i({ popperSize: c8, arrowSize: f7, arrowOffset: l8, side: d9, align: x4 }));
    return { popperStyles: { ...t18, "--radix-popper-transform-origin": r5(c8, d9, x4, l8, f7) }, arrowStyles: o17, placedSide: d9, placedAlign: x4 };
  }
  const S2 = DOMRect.fromRect({ ...c8, ...b3 }), $ = (O3 = w3, z2 = m5, DOMRect.fromRect({ width: O3.width - 2 * z2, height: O3.height - 2 * z2, x: O3.left + z2, y: O3.top + z2 }));
  var O3, z2;
  const R3 = s(S2, $), M2 = y2[a(d9)][x4], D2 = function(t18, e16, r18) {
    const o17 = a(t18);
    return e16[t18] && !r18[o17] ? o17 : t18;
  }(d9, R3, s(DOMRect.fromRect({ ...c8, ...M2 }), $)), A3 = function(t18, e16, r18, o17, n7) {
    const i6 = "top" === r18 || "bottom" === r18, p6 = i6 ? "left" : "top", a5 = i6 ? "right" : "bottom", s8 = i6 ? "width" : "height", c9 = e16[s8] > t18[s8];
    if (("start" === o17 || "center" === o17) && (n7[p6] && c9 || n7[a5] && !c9))
      return "end";
    if (("end" === o17 || "center" === o17) && (n7[a5] && c9 || n7[p6] && !c9))
      return "start";
    return o17;
  }(c8, p5, d9, x4, R3), I2 = e9(y2[D2][A3]);
  let C3 = n2;
  f7 && (C3 = i({ popperSize: c8, arrowSize: f7, arrowOffset: l8, side: D2, align: A3 }));
  return { popperStyles: { ...I2, "--radix-popper-transform-origin": r5(c8, D2, A3, l8, f7) }, arrowStyles: C3, placedSide: D2, placedAlign: A3 };
}
function t7(t18, e16, r18) {
  const o17 = t18["x" === r18 ? "left" : "top"], n7 = "x" === r18 ? "width" : "height", i6 = t18[n7], p5 = e16[n7];
  return { before: o17 - p5, start: o17, center: o17 + (i6 - p5) / 2, end: o17 + i6 - p5, after: o17 + i6 };
}
function e9(t18) {
  return { position: "absolute", top: 0, left: 0, minWidth: "max-content", willChange: "transform", transform: `translate3d(${Math.round(t18.x + window.scrollX)}px, ${Math.round(t18.y + window.scrollY)}px, 0)` };
}
function r5(t18, e16, r18, o17, n7) {
  const i6 = "top" === e16 || "bottom" === e16, p5 = n7 ? n7.width : 0, a5 = n7 ? n7.height : 0, s8 = p5 / 2 + o17;
  let c8 = "", f7 = "";
  return i6 ? (c8 = { start: `${s8}px`, center: "center", end: t18.width - s8 + "px" }[r18], f7 = "top" === e16 ? `${t18.height + a5}px` : -a5 + "px") : (c8 = "left" === e16 ? `${t18.width + a5}px` : -a5 + "px", f7 = { start: `${s8}px`, center: "center", end: t18.height - s8 + "px" }[r18]), `${c8} ${f7}`;
}
var o6 = { position: "fixed", top: 0, left: 0, opacity: 0, transform: "translate3d(0, -200%, 0)" };
var n2 = { position: "absolute", opacity: 0 };
function i({ popperSize: t18, arrowSize: e16, arrowOffset: r18, side: o17, align: n7 }) {
  const i6 = (t18.width - e16.width) / 2, a5 = (t18.height - e16.width) / 2, s8 = { top: 0, right: 90, bottom: 180, left: -90 }[o17], c8 = Math.max(e16.width, e16.height), f7 = { width: `${c8}px`, height: `${c8}px`, transform: `rotate(${s8}deg)`, willChange: "transform", position: "absolute", [o17]: "100%", direction: p2(o17, n7) };
  return "top" !== o17 && "bottom" !== o17 || ("start" === n7 && (f7.left = `${r18}px`), "center" === n7 && (f7.left = `${i6}px`), "end" === n7 && (f7.right = `${r18}px`)), "left" !== o17 && "right" !== o17 || ("start" === n7 && (f7.top = `${r18}px`), "center" === n7 && (f7.top = `${a5}px`), "end" === n7 && (f7.bottom = `${r18}px`)), f7;
}
function p2(t18, e16) {
  return ("top" !== t18 && "right" !== t18 || "end" !== e16) && ("bottom" !== t18 && "left" !== t18 || "end" === e16) ? "ltr" : "rtl";
}
function a(t18) {
  return { top: "bottom", right: "left", bottom: "top", left: "right" }[t18];
}
function s(t18, e16) {
  return { top: t18.top < e16.top, right: t18.right > e16.right, bottom: t18.bottom > e16.bottom, left: t18.left < e16.left };
}

// node_modules/@radix-ui/react-popper/dist/index.module.js
import * as s2 from "react";
var [p3, l3] = createContext3("Popper");
var Popper = ({ children: e16 }) => {
  const [r18, o17] = s2.useState(null);
  return s2.createElement(p3, { anchor: r18, onAnchorChange: o17 }, e16);
};
var PopperAnchor = /* @__PURE__ */ s2.forwardRef((e16, o17) => {
  const { virtualRef: t18, ...n7 } = e16, a5 = l3("PopperAnchor"), p5 = s2.useRef(null), f7 = useComposedRefs(o17, p5);
  return s2.useEffect(() => {
    a5.onAnchorChange((null == t18 ? void 0 : t18.current) || p5.current);
  }), t18 ? null : /* @__PURE__ */ s2.createElement(Primitive.div, _extends({}, n7, { ref: f7 }));
});
var [f2, d2] = createContext3("PopperContent");
var PopperContent = /* @__PURE__ */ s2.forwardRef((e16, n7) => {
  const { side: p5 = "bottom", sideOffset: d9, align: u6 = "center", alignOffset: m5, collisionTolerance: w3, avoidCollisions: h2 = true, ...x4 } = e16, v4 = l3("PopperContent"), [A3, g3] = s2.useState(), E4 = useRect(v4.anchor), [y2, C3] = s2.useState(null), P3 = useSize(y2), [S2, R3] = s2.useState(null), O3 = useSize(S2), b3 = useComposedRefs(n7, (e17) => C3(e17)), z2 = function() {
    const [e17, r18] = s2.useState(void 0);
    return s2.useEffect(() => {
      let e18;
      function o17() {
        r18({ width: window.innerWidth, height: window.innerHeight });
      }
      function t18() {
        window.clearTimeout(e18), e18 = window.setTimeout(o17, 100);
      }
      return o17(), window.addEventListener("resize", t18), () => window.removeEventListener("resize", t18);
    }, []), e17;
  }(), T2 = z2 ? DOMRect.fromRect({ ...z2, x: 0, y: 0 }) : void 0, { popperStyles: k2, arrowStyles: L2, placedSide: B2, placedAlign: D2 } = getPlacementData({ anchorRect: E4, popperSize: P3, arrowSize: O3, arrowOffset: A3, side: p5, sideOffset: d9, align: u6, alignOffset: m5, shouldAvoidCollisions: h2, collisionBoundariesRect: T2, collisionTolerance: w3 }), H6 = void 0 !== B2;
  return s2.createElement("div", { style: k2, "data-radix-popper-content-wrapper": "" }, /* @__PURE__ */ s2.createElement(f2, { arrowStyles: L2, onArrowChange: R3, onArrowOffsetChange: g3 }, /* @__PURE__ */ s2.createElement(Primitive.div, _extends({ "data-side": B2, "data-align": D2 }, x4, { style: { ...x4.style, animation: H6 ? void 0 : "none" }, ref: b3 }))));
});
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content3 = PopperContent;

// node_modules/@radix-ui/react-presence/dist/index.module.js
import * as t8 from "react";
var Presence = (u6) => {
  const { present: o17, children: s8 } = u6, i6 = function(n7) {
    const [u7, o18] = t8.useState(), s9 = t8.useRef({}), i7 = t8.useRef(n7), c9 = t8.useRef("none"), d10 = n7 ? "mounted" : "unmounted", [m5, a5] = function(e16, n8) {
      return t8.useReducer((e17, t18) => {
        const r18 = n8[e17][t18];
        return null != r18 ? r18 : e17;
      }, e16);
    }(d10, { mounted: { UNMOUNT: "unmounted", ANIMATION_OUT: "unmountSuspended" }, unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" }, unmounted: { MOUNT: "mounted" } });
    return t8.useEffect(() => {
      const e16 = r6(s9.current);
      c9.current = "mounted" === m5 ? e16 : "none";
    }, [m5]), useLayoutEffect4(() => {
      const e16 = s9.current, t18 = i7.current;
      if (t18 !== n7) {
        const u8 = c9.current, o19 = r6(e16);
        if (n7)
          a5("MOUNT");
        else if ("none" === o19 || "none" === (null == e16 ? void 0 : e16.display))
          a5("UNMOUNT");
        else {
          const e17 = u8 !== o19;
          a5(t18 && e17 ? "ANIMATION_OUT" : "UNMOUNT");
        }
        i7.current = n7;
      }
    }, [n7, a5]), useLayoutEffect4(() => {
      if (u7) {
        const e16 = (e17) => {
          const n8 = r6(s9.current).includes(e17.animationName);
          e17.target === u7 && n8 && a5("ANIMATION_END");
        };
        return u7.addEventListener("animationcancel", e16), u7.addEventListener("animationend", e16), () => {
          u7.removeEventListener("animationcancel", e16), u7.removeEventListener("animationend", e16);
        };
      }
    }, [u7, a5]), { isPresent: ["mounted", "unmountSuspended"].includes(m5), ref: t8.useCallback((e16) => {
      e16 && (s9.current = getComputedStyle(e16)), o18(e16);
    }, []) };
  }(o17), c8 = "function" == typeof s8 ? s8({ present: i6.isPresent }) : t8.Children.only(s8), d9 = useComposedRefs(i6.ref, c8.ref);
  return "function" == typeof s8 || i6.isPresent ? /* @__PURE__ */ t8.cloneElement(c8, { ref: d9 }) : null;
};
function r6(e16) {
  return (null == e16 ? void 0 : e16.animationName) || "none";
}
Presence.displayName = "Presence";

// node_modules/@radix-ui/react-focus-scope/dist/index.module.js
import * as o7 from "react";
var c2 = { bubbles: false, cancelable: true };
var FocusScope = /* @__PURE__ */ o7.forwardRef((i6, f7) => {
  const { loop: l8 = false, trapped: m5 = false, onMountAutoFocus: p5, onUnmountAutoFocus: v4, ...E4 } = i6, [F2, S2] = o7.useState(null), b3 = useCallbackRef(p5), T2 = useCallbackRef(v4), y2 = o7.useRef(null), L2 = useComposedRefs(f7, (e16) => S2(e16)), h2 = o7.useRef({ paused: false, pause() {
    this.paused = true;
  }, resume() {
    this.paused = false;
  } }).current;
  o7.useEffect(() => {
    if (m5) {
      let e16 = function(e17) {
        if (h2.paused || !F2)
          return;
        const t19 = e17.target;
        F2.contains(t19) ? y2.current = t19 : a2(y2.current, { select: true });
      }, t18 = function(e17) {
        !h2.paused && F2 && (F2.contains(e17.relatedTarget) || a2(y2.current, { select: true }));
      };
      return document.addEventListener("focusin", e16), document.addEventListener("focusout", t18), () => {
        document.removeEventListener("focusin", e16), document.removeEventListener("focusout", t18);
      };
    }
  }, [m5, F2, h2.paused]), o7.useEffect(() => {
    if (F2) {
      d3.add(h2);
      const e16 = document.activeElement;
      if (!F2.contains(e16)) {
        const t18 = new Event("focusScope.autoFocusOnMount", c2);
        F2.addEventListener("focusScope.autoFocusOnMount", b3), F2.dispatchEvent(t18), t18.defaultPrevented || (!function(e17, { select: t19 = false } = {}) {
          const n7 = document.activeElement;
          for (const o17 of e17)
            if (a2(o17, { select: t19 }), document.activeElement !== n7)
              return;
        }(r7(F2), { select: true }), document.activeElement === e16 && a2(F2));
      }
      return () => {
        F2.removeEventListener("focusScope.autoFocusOnMount", b3), setTimeout(() => {
          const t18 = new Event("focusScope.autoFocusOnUnmount", c2);
          F2.addEventListener("focusScope.autoFocusOnUnmount", T2), F2.dispatchEvent(t18), t18.defaultPrevented || a2(null != e16 ? e16 : document.body, { select: true }), F2.removeEventListener("focusScope.autoFocusOnUnmount", T2), d3.remove(h2);
        }, 0);
      };
    }
  }, [F2, b3, T2, h2]);
  const x4 = o7.useCallback((e16) => {
    if (!l8 && !m5)
      return;
    if (h2.paused)
      return;
    const t18 = "Tab" === e16.key && !e16.altKey && !e16.ctrlKey && !e16.metaKey, n7 = document.activeElement;
    if (t18 && n7) {
      const t19 = e16.currentTarget, [o17, u6] = function(e17) {
        const t20 = r7(e17), n8 = s3(t20, e17), o18 = s3(t20.reverse(), e17);
        return [n8, o18];
      }(t19);
      o17 && u6 ? e16.shiftKey || n7 !== u6 ? e16.shiftKey && n7 === o17 && (e16.preventDefault(), l8 && a2(u6, { select: true })) : (e16.preventDefault(), l8 && a2(o17, { select: true })) : n7 === t19 && e16.preventDefault();
    }
  }, [l8, m5, h2.paused]);
  return o7.createElement(Primitive.div, _extends({ tabIndex: -1 }, E4, { ref: L2, onKeyDown: x4 }));
});
function r7(e16) {
  const t18 = [], n7 = document.createTreeWalker(e16, NodeFilter.SHOW_ELEMENT, { acceptNode: (e17) => {
    const t19 = "INPUT" === e17.tagName && "hidden" === e17.type;
    return e17.disabled || e17.hidden || t19 ? NodeFilter.FILTER_SKIP : e17.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  } });
  for (; n7.nextNode(); )
    t18.push(n7.currentNode);
  return t18;
}
function s3(e16, t18) {
  for (const n7 of e16)
    if (!i2(n7, { upTo: t18 }))
      return n7;
}
function i2(e16, { upTo: t18 }) {
  if ("hidden" === getComputedStyle(e16).visibility)
    return true;
  for (; e16; ) {
    if (void 0 !== t18 && e16 === t18)
      return false;
    if ("none" === getComputedStyle(e16).display)
      return true;
    e16 = e16.parentElement;
  }
  return false;
}
function a2(e16, { select: t18 = false } = {}) {
  if (e16 && e16.focus) {
    const n7 = document.activeElement;
    e16.focus({ preventScroll: true }), e16 !== n7 && function(e17) {
      return e17 instanceof HTMLInputElement && "select" in e17;
    }(e16) && t18 && e16.select();
  }
}
var d3 = function() {
  let e16 = [];
  return { add(t18) {
    const n7 = e16[0];
    t18 !== n7 && (null == n7 || n7.pause()), e16 = f3(e16, t18), e16.unshift(t18);
  }, remove(t18) {
    var n7;
    e16 = f3(e16, t18), null === (n7 = e16[0]) || void 0 === n7 || n7.resume();
  } };
}();
function f3(e16, t18) {
  const n7 = [...e16], o17 = n7.indexOf(t18);
  return -1 !== o17 && n7.splice(o17, 1), n7;
}

// ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js
import * as t9 from "react";
function useEscapeKeydown(n7) {
  const o17 = useCallbackRef(n7);
  t9.useEffect(() => {
    const e16 = (e17) => {
      "Escape" === e17.key && o17(e17);
    };
    return document.addEventListener("keydown", e16), () => document.removeEventListener("keydown", e16);
  }, [o17]);
}

// node_modules/@radix-ui/react-use-body-pointer-events/dist/index.module.js
import * as t10 from "react";
var n3;
var o8 = 0;
function useBodyPointerEvents({ disabled: r18 }) {
  const u6 = t10.useRef(false), c8 = t10.useRef(false);
  t10.useEffect(() => {
    const e16 = (e17) => {
      const t19 = "mouse" === e17.pointerType;
      u6.current = !t19, c8.current = t19 && 0 === e17.button;
    }, t18 = () => {
      u6.current = false, c8.current = false;
    };
    return document.addEventListener("pointerdown", e16), document.addEventListener("pointerup", t18), () => {
      document.removeEventListener("pointerdown", e16), document.removeEventListener("pointerup", t18);
    };
  }, []), useLayoutEffect4(() => {
    if (r18) {
      let e16 = function() {
        o8--, 0 === o8 && (document.body.style.pointerEvents = n3);
      };
      return 0 === o8 && (n3 = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", o8++, () => {
        u6.current ? document.addEventListener("click", e16, { once: true }) : c8.current ? document.addEventListener("pointerup", e16, { once: true }) : e16();
      };
    }
  }, [r18]);
}

// node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
import * as u2 from "react";
var [s4, a3] = E();
var [c3, l4] = C();
var [d4, m2] = E("TotalLayerCountWithDisabledOutsidePointerEventsProvider");
var [f4, p4] = C("RunningLayerCountWithDisabledOutsidePointerEventsProvider");
var DismissableLayer = /* @__PURE__ */ u2.forwardRef((e16, t18) => {
  const n7 = 0 === l4(), r18 = /* @__PURE__ */ u2.createElement(v2, _extends({}, e16, { ref: t18 }));
  return n7 ? /* @__PURE__ */ u2.createElement(s4, null, /* @__PURE__ */ u2.createElement(d4, null, r18)) : r18;
});
var v2 = /* @__PURE__ */ u2.forwardRef((s8, d9) => {
  const { disableOutsidePointerEvents: v4 = false, onEscapeKeyDown: E4, onPointerDownOutside: C3, onFocusOutside: b3, onInteractOutside: w3, onDismiss: L2, ...P3 } = s8, y2 = a3(), D2 = l4() + 1, x4 = D2 === y2, O3 = m2(v4), g3 = p4() + (v4 ? 1 : 0), h2 = g3 < O3;
  useBodyPointerEvents({ disabled: v4 }), useEscapeKeydown((e16) => {
    x4 && (null == E4 || E4(e16), e16.defaultPrevented || null == L2 || L2());
  });
  const { onPointerDownCapture: R3 } = function(e16) {
    const n7 = useCallbackRef(e16), r18 = u2.useRef(false);
    return u2.useEffect(() => {
      const e17 = (e18) => {
        const t19 = e18.target;
        if (t19 && !r18.current) {
          const r19 = new CustomEvent("dismissableLayer.pointerDownOutside", { bubbles: false, cancelable: true, detail: { originalEvent: e18 } });
          t19.addEventListener("dismissableLayer.pointerDownOutside", n7, { once: true }), t19.dispatchEvent(r19);
        }
        r18.current = false;
      }, t18 = window.setTimeout(() => {
        document.addEventListener("pointerdown", e17);
      }, 0);
      return () => {
        window.clearTimeout(t18), document.removeEventListener("pointerdown", e17);
      };
    }, [n7]), { onPointerDownCapture: () => r18.current = true };
  }((e16) => {
    h2 || (null == C3 || C3(e16), null == w3 || w3(e16), e16.defaultPrevented || null == L2 || L2());
  }), { onBlurCapture: T2, onFocusCapture: F2 } = function(e16) {
    const n7 = useCallbackRef(e16), r18 = u2.useRef(false);
    return u2.useEffect(() => {
      const e17 = (e18) => {
        const t18 = e18.target;
        if (t18 && !r18.current) {
          const r19 = new CustomEvent("dismissableLayer.focusOutside", { bubbles: false, cancelable: true, detail: { originalEvent: e18 } });
          t18.addEventListener("dismissableLayer.focusOutside", n7, { once: true }), t18.dispatchEvent(r19);
        }
      };
      return document.addEventListener("focusin", e17), () => document.removeEventListener("focusin", e17);
    }, [n7]), { onFocusCapture: () => r18.current = true, onBlurCapture: () => r18.current = false };
  }((e16) => {
    null == b3 || b3(e16), null == w3 || w3(e16), e16.defaultPrevented || null == L2 || L2();
  }), B2 = O3 > 0 && !h2;
  return u2.createElement(c3, { runningCount: D2 }, /* @__PURE__ */ u2.createElement(f4, { runningCount: g3 }, /* @__PURE__ */ u2.createElement(Primitive.div, _extends({}, P3, { ref: d9, style: { pointerEvents: B2 ? "auto" : void 0, ...P3.style }, onPointerDownCapture: composeEventHandlers(s8.onPointerDownCapture, R3), onBlurCapture: composeEventHandlers(s8.onBlurCapture, T2), onFocusCapture: composeEventHandlers(s8.onFocusCapture, F2) }))));
});
function E(e16) {
  const t18 = /* @__PURE__ */ u2.createContext({ total: 0, setTotal: () => {
  } }), n7 = ({ children: e17 }) => {
    const [n8, r18] = u2.useState(0), o17 = u2.useMemo(() => ({ total: n8, setTotal: r18 }), [n8, r18]);
    return u2.createElement(t18.Provider, { value: o17 }, e17);
  };
  return [n7, function(e17 = true) {
    const { total: n8, setTotal: r18 } = u2.useContext(t18);
    return u2.useLayoutEffect(() => {
      if (e17)
        return r18((e18) => e18 + 1), () => r18((e18) => e18 - 1);
    }, [e17, r18]), n8;
  }];
}
function C(e16) {
  const t18 = /* @__PURE__ */ u2.createContext(0), n7 = (e17) => {
    const { children: n8, runningCount: r18 } = e17;
    return u2.createElement(t18.Provider, { value: r18 }, n8);
  };
  return [n7, function() {
    return u2.useContext(t18) || 0;
  }];
}

// ../../node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x4) {
    return Boolean(x4);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e16) {
          console.error("aria-hidden: cannot operate on ", node, e16);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};

// ../../node_modules/tslib/modules/index.js
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn
} = import_tslib.default;

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
import * as React27 from "react";

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
import * as React23 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";

// ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

// ../../node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState21 } from "react";
function useCallbackRef2(initialValue, callback) {
  var ref = useState21(function() {
    return {
      value: initialValue,
      callback,
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}

// ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as React21 from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React21.useLayoutEffect : React21.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef2(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// ../../node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a5) {
  return a5;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x4) {
          return x4 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x4) {
          return cb(x4);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x4) {
          pendingQueue.push(x4);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}

// ../../node_modules/use-sidecar/dist/es2015/exports.js
import * as React22 from "react";
var SideCar = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target2 = sideCar.read();
  if (!Target2) {
    throw new Error("Sidecar medium not found");
  }
  return React22.createElement(Target2, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}

// ../../node_modules/react-remove-scroll/dist/es2015/medium.js
var effectCar = createSidecarMedium();

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
var nothing = function() {
  return;
};
var RemoveScroll = React23.forwardRef(function(props, parentRef) {
  var ref = React23.useRef(null);
  var _a = React23.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container2 = _b === void 0 ? "div" : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React23.createElement(
    React23.Fragment,
    null,
    enabled && React23.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref }),
    forwardProps ? React23.cloneElement(React23.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React23.createElement(Container2, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
import * as React26 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
import * as React25 from "react";

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
import * as React24 from "react";

// ../../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var getNonce = function() {
  if (currentNonce) {
    return currentNonce;
  }
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};

// ../../node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css7) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css7;
  } else {
    tag.appendChild(document.createTextNode(css7));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React24.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/component.js
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles = _a.styles, dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse2 = function(x4) {
  return parseInt(x4 || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse2(left), parse2(top), parse2(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  React25.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React25.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React25.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};

// ../../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var options;
var nonPassive = passiveSupported ? { passive: false } : false;

// ../../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  var styles = window.getComputedStyle(node);
  return styles[overflow] !== "hidden" && !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible");
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), s8 = _a[1], d9 = _a[2];
      if (s8 > d9) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x4, y2) {
  return x4[0] === y2[0] && x4[1] === y2[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React26.useRef([]);
  var touchStartRef = React26.useRef([0, 0]);
  var activeAxis = React26.useRef();
  var id = React26.useState(idCounter++)[0];
  var Style2 = React26.useState(function() {
    return styleSingleton();
  })[0];
  var lastProps = React26.useRef(props);
  React26.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React26.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React26.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React26.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e16) {
      return e16.name === event.type && e16.target === event.target && deltaCompare(e16.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React26.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e16) {
        return e16 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React26.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React26.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React26.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React26.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React26.createElement(
    React26.Fragment,
    null,
    inert ? React26.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React26.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}

// ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
var ReactRemoveScroll = React27.forwardRef(function(props, ref) {
  return React27.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: sidecar_default }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var Combination_default = ReactRemoveScroll;

// node_modules/@radix-ui/react-menu/dist/index.module.js
import * as E2 from "react";
var x2 = ["Enter", " "];
var b2 = ["ArrowUp", "PageDown", "End"];
var R = ["ArrowDown", "PageUp", "Home", ...b2];
var M = { ltr: [...x2, "ArrowRight"], rtl: [...x2, "ArrowLeft"] };
var y = { ltr: ["ArrowLeft"], rtl: ["ArrowRight"] };
var [I, P] = createContext3("Menu");
var Menu2 = (e16) => {
  const { open: t18 = false, children: o17, onOpenChange: u6, modal: a5 = true } = e16, [i6, l8] = E2.useState(null), s8 = E2.useRef(false), d9 = useCallbackRef(u6), f7 = useDirection(i6, e16.dir);
  return E2.useEffect(() => {
    const e17 = () => s8.current = true, t19 = () => s8.current = false;
    return document.addEventListener("keydown", e17, { capture: true }), document.addEventListener("pointerdown", t19, { capture: true }), document.addEventListener("pointermove", t19, { capture: true }), () => {
      document.removeEventListener("keydown", e17, { capture: true }), document.removeEventListener("pointerdown", t19, { capture: true }), document.removeEventListener("pointermove", t19, { capture: true });
    };
  }, []), /* @__PURE__ */ E2.createElement(Root2, null, /* @__PURE__ */ E2.createElement(I, { isSubmenu: false, isUsingKeyboardRef: s8, dir: f7, open: t18, onOpenChange: d9, content: i6, onContentChange: l8, onRootClose: E2.useCallback(() => d9(false), [d9]), modal: a5 }, o17));
};
var MenuSub = (t18) => {
  const { children: r18, open: o17 = false, onOpenChange: u6 } = t18, a5 = P("MenuSub"), [i6, l8] = E2.useState(null), [s8, d9] = E2.useState(null), f7 = useCallbackRef(u6);
  return E2.useEffect(() => (false === a5.open && f7(false), () => f7(false)), [a5.open, f7]), /* @__PURE__ */ E2.createElement(Root2, null, /* @__PURE__ */ E2.createElement(I, { isSubmenu: true, isUsingKeyboardRef: a5.isUsingKeyboardRef, dir: a5.dir, open: o17, onOpenChange: f7, content: s8, onContentChange: d9, onRootClose: a5.onRootClose, contentId: useId(), trigger: i6, onTriggerChange: l8, triggerId: useId(), modal: false }, r18));
};
var MenuAnchor = /* @__PURE__ */ E2.forwardRef((e16, t18) => /* @__PURE__ */ E2.createElement(Anchor, _extends({}, e16, { ref: t18 })));
var [k, D, S, O] = createCollection();
var [T, L] = createContext3("MenuContent");
var MenuContent = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const { forceMount: n7, ...r18 } = e16, o17 = P("MenuContent");
  return E2.createElement(k, null, /* @__PURE__ */ E2.createElement(Presence, { present: n7 || o17.open }, /* @__PURE__ */ E2.createElement(D, null, o17.isSubmenu ? /* @__PURE__ */ E2.createElement(G, _extends({}, r18, { ref: t18 })) : /* @__PURE__ */ E2.createElement(A, _extends({}, r18, { ref: t18 })))));
});
var A = /* @__PURE__ */ E2.forwardRef((e16, t18) => P("MenuContent").modal ? /* @__PURE__ */ E2.createElement(F, _extends({}, e16, { ref: t18 })) : /* @__PURE__ */ E2.createElement(K, _extends({}, e16, { ref: t18 })));
var F = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const n7 = P("MenuContent"), r18 = E2.useRef(null), o17 = useComposedRefs(t18, r18);
  return E2.useEffect(() => {
    const e17 = r18.current;
    if (e17)
      return hideOthers(e17);
  }, []), /* @__PURE__ */ E2.createElement(U, _extends({}, e16, { ref: o17, trapFocus: n7.open, disableOutsidePointerEvents: n7.open, disableOutsideScroll: true, onFocusOutside: composeEventHandlers(e16.onFocusOutside, (e17) => e17.preventDefault(), { checkForDefaultPrevented: false }), onDismiss: () => n7.onOpenChange(false) }));
});
var K = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const n7 = P("MenuContent");
  return E2.createElement(U, _extends({}, e16, { ref: t18, trapFocus: false, disableOutsidePointerEvents: false, disableOutsideScroll: false, onDismiss: () => n7.onOpenChange(false) }));
});
var G = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const n7 = P("MenuContent"), r18 = E2.useRef(null), o17 = useComposedRefs(t18, r18);
  return n7.isSubmenu ? /* @__PURE__ */ E2.createElement(U, _extends({ id: n7.contentId, "aria-labelledby": n7.triggerId }, e16, { ref: o17, align: "start", side: "rtl" === n7.dir ? "left" : "right", portalled: true, disableOutsidePointerEvents: false, disableOutsideScroll: false, trapFocus: false, onOpenAutoFocus: (e17) => {
    var t19;
    n7.isUsingKeyboardRef.current && (null === (t19 = r18.current) || void 0 === t19 || t19.focus()), e17.preventDefault();
  }, onCloseAutoFocus: (e17) => e17.preventDefault(), onFocusOutside: composeEventHandlers(e16.onFocusOutside, (e17) => {
    e17.target !== n7.trigger && n7.onOpenChange(false);
  }), onEscapeKeyDown: composeEventHandlers(e16.onEscapeKeyDown, n7.onRootClose), onKeyDown: composeEventHandlers(e16.onKeyDown, (e17) => {
    const t19 = e17.currentTarget.contains(e17.target), r19 = y[n7.dir].includes(e17.key);
    var o18;
    t19 && r19 && (n7.onOpenChange(false), null === (o18 = n7.trigger) || void 0 === o18 || o18.focus());
  }) })) : null;
});
var U = /* @__PURE__ */ E2.forwardRef((e16, n7) => {
  const { loop: r18 = false, trapFocus: u6, onOpenAutoFocus: i6, onCloseAutoFocus: l8, disableOutsidePointerEvents: f7, onEscapeKeyDown: p5, onPointerDownOutside: v4, onFocusOutside: h2, onInteractOutside: x4, onDismiss: M2, disableOutsideScroll: y2, portalled: I2, ...k2 } = e16, D2 = P("MenuContent"), { getItems: S2 } = O(), [L2, A3] = E2.useState(null), F2 = E2.useRef(null), K2 = useComposedRefs(n7, F2, D2.onContentChange), G2 = E2.useRef(0), U2 = E2.useRef(""), V2 = E2.useRef(0), X = E2.useRef(null), B2 = E2.useRef("right"), z2 = E2.useRef(0), W = I2 ? Portal2 : E2.Fragment, j = y2 ? Combination_default : E2.Fragment, q = (e17) => {
    var t18, n8;
    const r19 = U2.current + e17, o17 = S2().filter((e18) => !e18.disabled), u7 = document.activeElement, a5 = null === (t18 = o17.find((e18) => e18.ref.current === u7)) || void 0 === t18 ? void 0 : t18.textValue, c8 = function(e18, t19, n9) {
      const r20 = t19.length > 1 && Array.from(t19).every((e19) => e19 === t19[0]) ? t19[0] : t19, o18 = n9 ? e18.indexOf(n9) : -1;
      let u8 = (a6 = e18, c9 = Math.max(o18, 0), a6.map((e19, t20) => a6[(c9 + t20) % a6.length]));
      var a6, c9;
      1 === r20.length && (u8 = u8.filter((e19) => e19 !== n9));
      const i8 = u8.find((e19) => e19.toLowerCase().startsWith(r20.toLowerCase()));
      return i8 !== n9 ? i8 : void 0;
    }(o17.map((e18) => e18.textValue), r19, a5), i7 = null === (n8 = o17.find((e18) => e18.textValue === c8)) || void 0 === n8 ? void 0 : n8.ref.current;
    !function e18(t19) {
      U2.current = t19, window.clearTimeout(G2.current), "" !== t19 && (G2.current = window.setTimeout(() => e18(""), 1e3));
    }(r19), i7 && setTimeout(() => i7.focus());
  };
  E2.useEffect(() => () => window.clearTimeout(G2.current), []), useFocusGuards();
  const J = E2.useCallback((e17) => {
    var t18, n8;
    return B2.current === (null === (t18 = X.current) || void 0 === t18 ? void 0 : t18.side) && function(e18, t19) {
      if (!t19)
        return false;
      return function(e19, t20) {
        const { x: n9, y: r19 } = e19;
        let o17 = false;
        for (let e20 = 0, u7 = t20.length - 1; e20 < t20.length; u7 = e20++) {
          const a5 = t20[e20].x, c8 = t20[e20].y, i7 = t20[u7].x, l9 = t20[u7].y;
          c8 > r19 != l9 > r19 && n9 < (i7 - a5) * (r19 - c8) / (l9 - c8) + a5 && (o17 = !o17);
        }
        return o17;
      }({ x: e18.clientX, y: e18.clientY }, t19);
    }(e17, null === (n8 = X.current) || void 0 === n8 ? void 0 : n8.area);
  }, []);
  return E2.createElement(W, null, /* @__PURE__ */ E2.createElement(j, null, /* @__PURE__ */ E2.createElement(T, { searchRef: U2, onItemEnter: E2.useCallback((e17) => {
    J(e17) && e17.preventDefault();
  }, [J]), onItemLeave: E2.useCallback((e17) => {
    var t18;
    J(e17) || (null === (t18 = F2.current) || void 0 === t18 || t18.focus(), A3(null));
  }, [J]), onTriggerLeave: E2.useCallback((e17) => {
    J(e17) && e17.preventDefault();
  }, [J]), pointerGraceTimerRef: V2, onPointerGraceIntentChange: E2.useCallback((e17) => {
    X.current = e17;
  }, []) }, /* @__PURE__ */ E2.createElement(FocusScope, { asChild: true, trapped: u6, onMountAutoFocus: composeEventHandlers(i6, (e17) => {
    var t18;
    e17.preventDefault(), null === (t18 = F2.current) || void 0 === t18 || t18.focus();
  }), onUnmountAutoFocus: l8 }, /* @__PURE__ */ E2.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: f7, onEscapeKeyDown: p5, onPointerDownOutside: v4, onFocusOutside: h2, onInteractOutside: x4, onDismiss: M2 }, /* @__PURE__ */ E2.createElement(RovingFocusGroup, { asChild: true, dir: D2.dir, orientation: "vertical", loop: r18, currentTabStopId: L2, onCurrentTabStopIdChange: A3, onEntryFocus: (e17) => {
    D2.isUsingKeyboardRef.current || e17.preventDefault();
  } }, /* @__PURE__ */ E2.createElement(Content3, _extends({ role: "menu", dir: D2.dir, "data-state": Y(D2.open) }, k2, { ref: K2, style: { outline: "none", ...k2.style }, onKeyDown: composeEventHandlers(k2.onKeyDown, (e17) => {
    const t18 = e17.target, n8 = e17.currentTarget.contains(t18), r19 = e17.ctrlKey || e17.altKey || e17.metaKey;
    n8 && !r19 && 1 === e17.key.length && q(e17.key), "Tab" === e17.key && e17.preventDefault();
    const o17 = F2.current;
    if (e17.target !== o17)
      return;
    if (!R.includes(e17.key))
      return;
    e17.preventDefault();
    const u7 = S2().filter((e18) => !e18.disabled).map((e18) => e18.ref.current);
    b2.includes(e17.key) && u7.reverse(), function(e18) {
      const t19 = document.activeElement;
      for (const n9 of e18) {
        if (n9 === t19)
          return;
        if (n9.focus(), document.activeElement !== t19)
          return;
      }
    }(u7);
  }), onBlur: composeEventHandlers(e16.onBlur, (e17) => {
    e17.currentTarget.contains(e17.target) || (window.clearTimeout(G2.current), U2.current = "");
  }), onPointerMove: composeEventHandlers(e16.onPointerMove, H((e17) => {
    const t18 = e17.target, n8 = z2.current !== e17.clientX;
    if (e17.currentTarget.contains(t18) && n8) {
      const t19 = e17.clientX > z2.current ? "right" : "left";
      B2.current = t19, z2.current = e17.clientX;
    }
  })) }))))))));
});
var MenuGroup = /* @__PURE__ */ E2.forwardRef((e16, t18) => /* @__PURE__ */ E2.createElement(Primitive.div, _extends({ role: "group" }, e16, { ref: t18 })));
var MenuLabel = /* @__PURE__ */ E2.forwardRef((e16, t18) => /* @__PURE__ */ E2.createElement(Primitive.div, _extends({}, e16, { ref: t18 })));
var MenuItem = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const { disabled: n7 = false, onSelect: r18, ...o17 } = e16, u6 = E2.useRef(null), a5 = P("MenuItem"), c8 = L("MenuItem"), i6 = useComposedRefs(t18, u6), l8 = E2.useRef(false);
  return E2.createElement(V, _extends({}, o17, { ref: i6, disabled: n7, onClick: composeEventHandlers(e16.onClick, () => {
    const e17 = u6.current;
    if (!n7 && e17) {
      const t19 = new Event("menu.itemSelect", { bubbles: true, cancelable: true });
      e17.addEventListener("menu.itemSelect", (e18) => null == r18 ? void 0 : r18(e18), { once: true }), e17.dispatchEvent(t19), t19.defaultPrevented ? l8.current = false : a5.onRootClose();
    }
  }), onPointerDown: (t19) => {
    var n8;
    null === (n8 = e16.onPointerDown) || void 0 === n8 || n8.call(e16, t19), l8.current = true;
  }, onPointerUp: composeEventHandlers(e16.onPointerUp, (e17) => {
    var t19;
    l8.current || null === (t19 = e17.currentTarget) || void 0 === t19 || t19.click();
  }), onKeyDown: composeEventHandlers(e16.onKeyDown, (e17) => {
    const t19 = "" !== c8.searchRef.current;
    n7 || t19 && " " === e17.key || x2.includes(e17.key) && (e17.currentTarget.click(), e17.preventDefault());
  }) }));
});
var V = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const { disabled: n7 = false, textValue: r18, ...o17 } = e16, a5 = E2.useRef(null), c8 = useComposedRefs(t18, a5), l8 = L("MenuItem"), [s8, d9] = E2.useState("");
  return E2.useEffect(() => {
    const e17 = a5.current;
    var t19;
    e17 && d9((null !== (t19 = e17.textContent) && void 0 !== t19 ? t19 : "").trim());
  }, [o17.children]), /* @__PURE__ */ E2.createElement(S, { disabled: n7, textValue: null != r18 ? r18 : s8 }, /* @__PURE__ */ E2.createElement(RovingFocusItem, { asChild: true, focusable: !n7 }, /* @__PURE__ */ E2.createElement(Primitive.div, _extends({ role: "menuitem", "aria-disabled": n7 || void 0, "data-disabled": n7 ? "" : void 0 }, o17, { ref: c8, onPointerMove: composeEventHandlers(e16.onPointerMove, H((e17) => {
    if (n7)
      l8.onItemLeave(e17);
    else if (l8.onItemEnter(e17), !e17.defaultPrevented) {
      e17.currentTarget.focus();
    }
  })), onPointerLeave: composeEventHandlers(e16.onPointerLeave, H((e17) => l8.onItemLeave(e17))) }))));
});
var MenuCheckboxItem = /* @__PURE__ */ E2.forwardRef((e16, t18) => {
  const { checked: n7 = false, onCheckedChange: r18, ...o17 } = e16;
  return E2.createElement(B.Provider, { value: n7 }, /* @__PURE__ */ E2.createElement(MenuItem, _extends({ role: "menuitemcheckbox", "aria-checked": n7 }, o17, { ref: t18, "data-state": z(n7), onSelect: composeEventHandlers(o17.onSelect, () => null == r18 ? void 0 : r18(!n7), { checkForDefaultPrevented: false }) })));
});
var B = /* @__PURE__ */ E2.createContext(false);
var MenuSeparator = /* @__PURE__ */ E2.forwardRef((e16, t18) => /* @__PURE__ */ E2.createElement(Primitive.div, _extends({ role: "separator", "aria-orientation": "horizontal" }, e16, { ref: t18 })));
function Y(e16) {
  return e16 ? "open" : "closed";
}
function z(e16) {
  return e16 ? "checked" : "unchecked";
}
function H(e16) {
  return (t18) => "mouse" === t18.pointerType ? e16(t18) : void 0;
}
var Root3 = Menu2;
var Sub = MenuSub;
var Anchor2 = MenuAnchor;
var Content4 = MenuContent;
var Group = MenuGroup;
var Label3 = MenuLabel;
var Item3 = MenuItem;
var CheckboxItem = MenuCheckboxItem;
var Separator2 = MenuSeparator;

// node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js
import * as d5 from "react";
var [u3, i3] = createContext3("DropdownMenu");
var DropdownMenu = (e16) => {
  const { children: r18, open: t18, defaultOpen: a5, onOpenChange: p5, dir: c8, modal: i6 = true } = e16, s8 = d5.useContext(m3), [f7 = false, w3] = useControllableState({ prop: t18, defaultProp: a5, onChange: p5 }), g3 = d5.useCallback(() => w3((e17) => !e17), [w3]);
  return s8 ? /* @__PURE__ */ d5.createElement(u3, { isRootMenu: false, open: f7, onOpenChange: w3, onOpenToggle: g3 }, /* @__PURE__ */ d5.createElement(Sub, { open: f7, onOpenChange: w3 }, r18)) : /* @__PURE__ */ d5.createElement(l5, { dir: c8, open: f7, onOpenChange: w3, onOpenToggle: g3, modal: i6 }, r18);
};
var l5 = (r18) => {
  const { children: n7, dir: t18, open: a5, onOpenChange: p5, onOpenToggle: c8, modal: i6 = true } = r18, l8 = d5.useRef(null);
  return d5.createElement(u3, { isRootMenu: true, triggerId: useId(), triggerRef: l8, contentId: useId(), open: a5, onOpenChange: p5, onOpenToggle: c8, modal: i6 }, /* @__PURE__ */ d5.createElement(Root3, { open: a5, onOpenChange: p5, dir: t18, modal: i6 }, n7));
};
var DropdownMenuTrigger = /* @__PURE__ */ d5.forwardRef((e16, n7) => {
  const t18 = i3("DropdownMenuTrigger");
  return t18.isRootMenu ? /* @__PURE__ */ d5.createElement(Anchor2, { asChild: true }, /* @__PURE__ */ d5.createElement(Primitive.button, _extends({ type: "button", id: t18.triggerId, "aria-haspopup": "menu", "aria-expanded": !!t18.open || void 0, "aria-controls": t18.open ? t18.contentId : void 0, "data-state": t18.open ? "open" : "closed" }, e16, { ref: composeRefs(n7, t18.triggerRef), onPointerDown: composeEventHandlers(e16.onPointerDown, (e17) => {
    0 === e17.button && false === e17.ctrlKey && (t18.open || e17.preventDefault(), t18.onOpenToggle());
  }), onKeyDown: composeEventHandlers(e16.onKeyDown, (e17) => {
    [" ", "Enter", "ArrowDown"].includes(e17.key) && (e17.preventDefault(), t18.onOpenChange(true));
  }) }))) : null;
});
var m3 = /* @__PURE__ */ d5.createContext(false);
var DropdownMenuContent = /* @__PURE__ */ d5.forwardRef((e16, r18) => {
  const n7 = i3("DropdownMenuContent"), t18 = { ...e16, style: { ...e16.style, "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)" } };
  return d5.createElement(m3.Provider, { value: true }, n7.isRootMenu ? /* @__PURE__ */ d5.createElement(s5, _extends({}, t18, { ref: r18 })) : /* @__PURE__ */ d5.createElement(Content4, _extends({}, t18, { ref: r18 })));
});
var s5 = /* @__PURE__ */ d5.forwardRef((e16, r18) => {
  const { portalled: n7 = true, ...t18 } = e16, a5 = i3("DropdownMenuContent"), p5 = d5.useRef(false);
  return a5.isRootMenu ? /* @__PURE__ */ d5.createElement(Content4, _extends({ id: a5.contentId, "aria-labelledby": a5.triggerId }, t18, { ref: r18, portalled: n7, onCloseAutoFocus: (o17) => {
    var r19, n8;
    (null === (r19 = e16.onCloseAutoFocus) || void 0 === r19 || r19.call(e16, o17), o17.defaultPrevented) || (p5.current || null === (n8 = a5.triggerRef.current) || void 0 === n8 || n8.focus(), o17.preventDefault());
    p5.current = false;
  }, onInteractOutside: (o17) => {
    var r19, n8;
    if (null === (r19 = e16.onInteractOutside) || void 0 === r19 || r19.call(e16, o17), !o17.defaultPrevented) {
      const e17 = o17.detail.originalEvent, r20 = 0 === e17.button && true === e17.ctrlKey, n9 = 2 === e17.button || r20;
      a5.modal && !n9 || (p5.current = true);
    }
    const t19 = o17.target;
    (null === (n8 = a5.triggerRef.current) || void 0 === n8 ? void 0 : n8.contains(t19)) && o17.preventDefault();
  } })) : null;
});
var DropdownMenuGroup = /* @__PURE__ */ d5.forwardRef((e16, r18) => /* @__PURE__ */ d5.createElement(Group, _extends({}, e16, { ref: r18 })));
var DropdownMenuLabel = /* @__PURE__ */ d5.forwardRef((e16, r18) => /* @__PURE__ */ d5.createElement(Label3, _extends({}, e16, { ref: r18 })));
var DropdownMenuItem = /* @__PURE__ */ d5.forwardRef((e16, r18) => /* @__PURE__ */ d5.createElement(Item3, _extends({}, e16, { ref: r18 })));
var DropdownMenuCheckboxItem = /* @__PURE__ */ d5.forwardRef((e16, r18) => /* @__PURE__ */ d5.createElement(CheckboxItem, _extends({}, e16, { ref: r18 })));
var DropdownMenuSeparator = /* @__PURE__ */ d5.forwardRef((e16, r18) => /* @__PURE__ */ d5.createElement(Separator2, _extends({}, e16, { ref: r18 })));
var Root4 = DropdownMenu;
var Trigger2 = DropdownMenuTrigger;
var Content5 = DropdownMenuContent;
var Group2 = DropdownMenuGroup;
var Label4 = DropdownMenuLabel;
var Item4 = DropdownMenuItem;
var CheckboxItem2 = DropdownMenuCheckboxItem;
var Separator3 = DropdownMenuSeparator;

// src/ListRow.js
var truncate = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var Description2 = styled27.span`
  ${truncate}

  color: var(--sharkbait-ooh-la-la);
  font-size: var(--x-small);
  font-weight: var(--normal);
  grid-area: description;
  margin-top: 4px;
`;
var MainText = styled27.span`
  ${truncate}

  color: var(--pleather);
  font-weight: var(--normal);
  grid-area: main;

  ${({ $description }) => $description && `
      font-weight: var(--bold);
    `}
`;
var Wrapper13 = styled27.div`
  /* Link style overrides */
  --link-active-color: inherit;
  --link-color: inherit;
  --link-focus-outline-color: transparent;
  --link-font-weight: inherit;
  --link-text-decoration: none;

  border-radius: 6px;
  color: var(--pleather);
  cursor: pointer;
  display: block;
  font-size: var(--regular);
  text-decoration: none;
  padding: 10px 16px;
  width: 100%;

  &:focus,
  &:focus-visible {
    background-color: var(--noreaster);
    color: var(--oh-hi-dark);
    outline: none;

    ${MainText} {
      color: var(--oh-hi-dark);
    }

    ${Icon_default} {
      color: var(--pleather);
    }
  }

  &[disabled] {
    color: var(--dark-resting);
    cursor: not-allowed;

    &:hover {
      background-color: inherit;
    }

    ${MainText},
    ${Description2} {
      color: var(--dark-resting);
    }

    ${Icon_default} {
      color: var(--myst);
    }
  }
`;
var ContentWrapper2 = styled27.div`
  align-items: center;
  display: grid;
  grid-template:
    'prefix main suffix caret'
    '. description . .'
    / min-content 1fr;
  width: 100%;
`;
var IconWrapper = styled27.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${Icon_default} {
    color: var(--sharkbait-ooh-la-la);
    width: 20px;
  }
`;
var PrefixWrapper = styled27(IconWrapper)`
  grid-area: prefix;
  padding-right: 8px;
`;
var SuffixWrapper = styled27(IconWrapper)`
  grid-area: suffix;
  padding-left: 8px;
`;
var CaretWrapper = styled27(IconWrapper)`
  grid-area: caret;

  ${Icon_default} {
    height: 16px;
    width: 16px;
  }
`;
var BaseContent = ({
  children,
  description,
  prefix: prefix2,
  suffix,
  caret,
  ...unhandledProps
}) => /* @__PURE__ */ React28.createElement(ContentWrapper2, {
  ...unhandledProps
}, prefix2 && /* @__PURE__ */ React28.createElement(PrefixWrapper, null, prefix2), /* @__PURE__ */ React28.createElement(MainText, {
  $description: !!description
}, children), suffix && /* @__PURE__ */ React28.createElement(SuffixWrapper, null, suffix), caret && /* @__PURE__ */ React28.createElement(CaretWrapper, null, /* @__PURE__ */ React28.createElement(Icon_default, {
  icon: "angle-right"
})), description && /* @__PURE__ */ React28.createElement(Description2, null, description));
BaseContent.propTypes = {
  children: PropTypes20.node,
  description: PropTypes20.string,
  prefix: PropTypes20.node,
  suffix: PropTypes20.node,
  caret: PropTypes20.bool
};
var Content6 = styled27(BaseContent)``;
var BaseListRow = ({
  children,
  description,
  disabled,
  prefix: prefix2,
  onClick,
  suffix,
  caret,
  ...unhandledProps
}) => /* @__PURE__ */ React28.createElement(Item4, {
  asChild: true,
  disabled,
  onSelect: onClick
}, /* @__PURE__ */ React28.createElement(Wrapper13, {
  disabled,
  ...unhandledProps
}, /* @__PURE__ */ React28.createElement(Content6, {
  description,
  prefix: prefix2,
  suffix,
  caret
}, children)));
BaseListRow.propTypes = {
  caret: PropTypes20.bool,
  children: PropTypes20.node,
  description: PropTypes20.string,
  disabled: PropTypes20.bool,
  onClick: PropTypes20.func,
  prefix: PropTypes20.node,
  suffix: PropTypes20.node
};
var ListRow = styled27(BaseListRow)``;
var ListRow_default = ListRow;

// src/Logo.js
import React29 from "react";
import PropTypes21 from "prop-types";
import styled28 from "styled-components";
var Wrapper14 = styled28.span`
  align-items: center;
  color: var(--primary);
  display: flex;
  font-size: var(--x-large);
  justify-content: center;

  svg {
    height: 1em;
    width: 1em;

    path {
      fill: currentColor;
    }
  }
`;
var Logo = ({ className }) => /* @__PURE__ */ React29.createElement(Wrapper14, {
  className
}, /* @__PURE__ */ React29.createElement("svg", {
  viewBox: "0 0 1600 2000",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React29.createElement("path", {
  d: "M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"
})));
Logo.propTypes = {
  className: PropTypes21.string
};
var Logo_default = styled28(Logo)``;

// src/Menu.js
import styled29, { createGlobalStyle } from "styled-components";
var MenuPortalOverride = createGlobalStyle`
  div[data-radix-portal] {
    z-index: 10010 !important
  }
`;
var MenuContent2 = styled29(Content5)`
  background-color: var(--white);
  border-radius: 6px;
  box-shadow: var(--level-1);
`;
var MenuHeading = styled29(Label4)`
  color: var(--pleather);
  cursor: default;
  font-weight: var(--bold);
  overflow: hidden;
  padding: 10px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var MenuSection = styled29(Group2)`
  padding: 8px 4px;
`;
var MenuSeparator2 = styled29(Separator3)`
  border-bottom: 0;
  border-top: 1px solid var(--ui-vertical-separator);
`;
var MenuTrigger = styled29(Trigger2)`
  &:focus-visible {
    outline-width: 0px;
  }
`;
var MenuItem2 = styled29(Item4)``;
var MenuCheckboxItem2 = styled29(CheckboxItem2)``;
var Menu3 = styled29(Root4)``;

// src/Modal.js
import React30, { useEffect as useEffect30 } from "react";
import PropTypes22 from "prop-types";
import styled30 from "styled-components";
var P2 = styled30.p`
  font-size: var(--regular);
`;
var Heading = styled30.h2`
  color: var(--heading-primary);
  font-size: var(--large);
  font-weight: var(--semi-bold);
  line-height: 1.5;
  margin: -8px 0 12px;
  padding-right: 16px;
  word-break: break-word;
`;
var Description3 = styled30.span`
  display: inline-block;
  font-size: var(--regular);
  font-weight: var(--normal);
  line-height: 1.5;
  margin: 0 0 1em;
`;
var Overflow = styled30.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 8px;
`;
var ModalFooter = styled30.div`
  margin-top: 24px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;
var CloseButton = styled30(IconButton).attrs(() => ({ icon: "times" }))`
  position: absolute;
  right: 26px;
  top: 26px;
`;
var Overlay2 = styled30.div.attrs(() => ({
  role: "button",
  "aria-label": "overlay"
}))`
  background: var(--overlay);
  height: 100%;
  opacity: 0.8;
  position: absolute;
  width: 100%;
  z-index: 10001;
`;
var Dialog = styled30.div.attrs(() => ({ role: "dialog" }))`
  background: var(--white);
  border-radius: 12px;
  box-shadow: var(--level-4);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  max-height: 80%;
  min-height: 160px;
  padding: 32px;
  position: relative;
  z-index: 10002;

  width: ${({ size }) => {
  switch (size) {
    case "xl":
      return "800px";
    case "l":
      return "600px";
    case "m":
      return "500px";
    default:
      return "400px";
  }
}};

  ${({ size }) => size === "full" && `
      border-radius: 0;
      height: 100%;
      max-height: 100%;
      width: 100%;

      ${Heading} {
        font-size: var(--x-large);
      }

      ${CloseButton} {
        font-size: var(--large);
      }
  `}
`;
var Modal = ({
  children,
  className,
  closeOnEscape = true,
  onClose,
  size = "s",
  timeout = 200,
  visible = true
}) => {
  useEffect30(() => {
    if (!visible) {
      return () => {
      };
    }
    const {
      style: { overflow }
    } = document.body;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [visible]);
  useEscape(visible && closeOnEscape && onClose);
  return /* @__PURE__ */ React30.createElement(Portal_default, {
    timeout
  }, /* @__PURE__ */ React30.createElement(Fade_default, {
    visible,
    timeout
  }, /* @__PURE__ */ React30.createElement(Fullscreen_default, null, /* @__PURE__ */ React30.createElement(Overlay2, {
    onClick: onClose
  }), /* @__PURE__ */ React30.createElement(Dialog, {
    className,
    size
  }, onClose && /* @__PURE__ */ React30.createElement(CloseButton, {
    onClick: onClose,
    label: "Dismiss dialog",
    title: "Dismiss dialog"
  }), children))));
};
Modal.propTypes = {
  children: PropTypes22.node,
  className: PropTypes22.string,
  closeOnEscape: PropTypes22.bool,
  onClose: PropTypes22.func,
  size: PropTypes22.oneOf(["s", "m", "l", "xl", "full"]),
  timeout: PropTypes22.number,
  visible: PropTypes22.bool
};
var Modal_default = styled30(Modal)``;

// src/MoreMenu.js
import React31, { forwardRef as forwardRef14 } from "react";
import PropTypes23 from "prop-types";
import styled31 from "styled-components";
var Opener = styled31(SquareButton)`
  ${({ small }) => small && `
    width: 32px;
    height: 24px;
  `}

  &[aria-expanded="true"] {
    border: 1px solid var(--primary);
    background-color: var(--luna);

    ${Icon_default} {
      color: var(--primary);
    }
  }
`;
var OpenButton = forwardRef14(
  ({ icon, small, ...unhandledProps }, forwardedRef) => /* @__PURE__ */ React31.createElement(Opener, {
    "aria-label": "Open more menu",
    icon,
    ref: forwardedRef,
    kind: "secondary",
    small,
    ...unhandledProps
  })
);
OpenButton.propTypes = {
  icon: PropTypes23.string,
  small: PropTypes23.bool
};
var MoreMenu = ({
  icon = "ellipsis-h",
  align = "end",
  children,
  side = "bottom",
  small = false
}) => /* @__PURE__ */ React31.createElement(Menu3, null, /* @__PURE__ */ React31.createElement(MenuTrigger, {
  asChild: true
}, /* @__PURE__ */ React31.createElement(OpenButton, {
  icon,
  small
})), /* @__PURE__ */ React31.createElement(MenuContent2, {
  align,
  side,
  sideOffset: 12
}, children));
MoreMenu.propTypes = {
  align: PropTypes23.oneOf(["start", "center", "end"]),
  children: PropTypes23.node,
  icon: PropTypes23.string,
  side: PropTypes23.oneOf(["top", "right", "bottom", "left"]),
  small: PropTypes23.bool
};
var MoreMenu_default = styled31(MoreMenu)``;

// src/Notice.js
import React32 from "react";
import PropTypes24 from "prop-types";
import styled32 from "styled-components";
var Header = styled32.div`
  font-weight: var(--bold);
  margin-bottom: 4px;
`;
var Body3 = styled32.div`
  flex-grow: 1;
  line-height: var(--medium-large);
`;
var Wrapper15 = styled32.div`
  align-items: flex-start;
  background-color: var(--primary-x-light);
  border-color: var(--primary-light);
  border-radius: 6px;
  border-style: solid;
  border-width: 2px;
  color: var(--banner-text);
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;

  > ${Icon_default} {
    color: var(--primary);
    height: var(--medium-large);
    margin-right: 8px;
    width: var(--medium-large);
  }

  > ${IconButton} {
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${UILink} {
    color: var(--pleather);
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;
function BaseNotice({ children, className, header, icon, onDismiss }) {
  return /* @__PURE__ */ React32.createElement(Wrapper15, {
    className,
    role: "alert"
  }, header && /* @__PURE__ */ React32.createElement(Icon_default, {
    icon: icon || faInfoCircle,
    role: "img"
  }), /* @__PURE__ */ React32.createElement(Body3, null, header && /* @__PURE__ */ React32.createElement(Header, null, header), children), onDismiss && /* @__PURE__ */ React32.createElement(IconButton, {
    icon: "times",
    label: "Dismiss notice",
    onClick: onDismiss
  }));
}
BaseNotice.propTypes = {
  children: PropTypes24.node,
  className: PropTypes24.string,
  header: PropTypes24.string,
  icon: PropTypes24.string,
  onDismiss: PropTypes24.func
};
var Notice = styled32(BaseNotice)``;
var Notice_default = Notice;
var NegativeNotice = styled32(Notice)`
  background-color: var(--danger-x-light);
  border-color: var(--danger-light);

  > ${Icon_default} {
    color: var(--danger-dark);
  }
`;
var WarningNotice = styled32(Notice)`
  background-color: var(--warn-light);
  border-color: var(--warn);

  > ${Icon_default} {
    color: var(--warn-dark);
  }
`;
var SuccessNotice = styled32(Notice)`
  background-color: var(--ice-ice-baby);
  border-color: var(--cutecumber);

  > ${Icon_default} {
    color: var(--bulbasaur);
  }
`;

// src/Page.js
import React35 from "react";
import styled35 from "styled-components";

// src/StatusLabel.js
import React34 from "react";
import PropTypes26 from "prop-types";
import styled34 from "styled-components";

// src/Table.js
import React33 from "react";
import PropTypes25 from "prop-types";
import styled33, { css as css3 } from "styled-components";
var Thead = styled33.thead``;
var stickyStyles = css3`
  border-collapse: separate;
  ${Thead} {
    position: sticky;
    top: 0px;
    background-color: var(--white);
    border-bottom: 1px solid var(--tint-black);
  }
`;
var Table = styled33.table`
  background: var(--white);
  border-collapse: collapse;
  color: var(--table-text);
  width: 100%;

  ${({ sticky }) => sticky && stickyStyles}
`;
var Tbody = styled33.tbody``;
var Tfoot = styled33.tfoot``;
var Tr = styled33.tr``;
var Td = styled33.td`
  border-bottom: 1px solid var(--table-border);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;

  @media print {
    white-space: normal;
  }
`;
var ThWrapper = styled33.th`
  border-bottom: 1px solid var(--table-border);
  font-weight: var(--bold);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;
  transition: ${easing("background")};

  :hover {
    ${({ sortable }) => sortable && `background: var(--table-header-hover);`}
  }

  ${({ sortable }) => sortable && `
      cursor: pointer
  `};

  ${({ sortable, sorted }) => sortable && sorted && `
      border-bottom: 2px solid var(--table-header-sorted);
    `}

  @media print {
    white-space: normal;
    width: auto;
  }
`;
var ThSortIcon = styled33(Icon_default)`
  font-size: var(--xx-small);
  margin-left: 8px;
`;
var ThContent = styled33.span`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
function BaseTh({ children, sorted, ...unhandledProps }) {
  return /* @__PURE__ */ React33.createElement(ThWrapper, {
    sorted,
    ...unhandledProps
  }, /* @__PURE__ */ React33.createElement(ThContent, null, children, sorted === "asc" && /* @__PURE__ */ React33.createElement(ThSortIcon, {
    icon: "arrow-up"
  }), sorted === "desc" && /* @__PURE__ */ React33.createElement(ThSortIcon, {
    icon: "arrow-down"
  })));
}
BaseTh.propTypes = {
  children: PropTypes25.node,
  sortable: PropTypes25.bool,
  sorted: PropTypes25.oneOf(["asc", "desc"])
};
var Th = styled33(BaseTh)``;

// src/StatusLabel.js
var ARCHIVED = "ARCHIVED";
var DRAFT = "DRAFT";
var PUBLISHED = "PUBLISHED";
var SCHEDULED = "SCHEDULED";
var INACTIVE2 = "INACTIVE";
var ACTIVE2 = "ACTIVE";
var labels = {
  ARCHIVED: "Archived",
  DRAFT: "Draft",
  PUBLISHED: "Live",
  SCHEDULED: "Scheduled",
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE"
};
function getColorVariables(status, active) {
  switch (status) {
    case SCHEDULED:
      return {
        background: "--color-blue-100",
        color: "--color-blue-600"
      };
    default:
      return active || status === "ACTIVE" ? {
        background: "--status-active-bg",
        color: "--status-active"
      } : {
        background: "--status-inactive-bg",
        color: "--status-inactive"
      };
  }
}
function getStatus(state, published) {
  switch (true) {
    case state === ARCHIVED:
      return ARCHIVED;
    case (state === SCHEDULED && !published):
      return SCHEDULED;
    case state === INACTIVE2:
      return INACTIVE2;
    case state === ACTIVE2:
      return ACTIVE2;
    default:
      return published ? PUBLISHED : DRAFT;
  }
}
function getIcon(status) {
  switch (status) {
    case PUBLISHED:
      return "check-circle";
    case DRAFT:
      return "minus-circle";
    case SCHEDULED:
      return "clock";
    default:
      return "circle";
  }
}
var Label5 = styled34(Text_default)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var Wrapper16 = styled34.div`
  align-items: center;
  border-radius: 6px;
  color: var(--status-text);
  display: inline-flex;
  font-size: var(--small);
  font-weight: var(--bold);
  height: 24px;
  justify-content: center;
  max-width: 160px;
  padding: 4px 12px;
  text-transform: capitalize;

  ${Icon_default} {
    margin-right: 6px;
  }

  ${({ active, status }) => {
  const { background, color } = getColorVariables(status, active);
  return `
      background: var(${background});

      ${Icon_default} {
        color: var(${color});
      }
    `;
}}

  /**
   * Table context
   */

  ${Table} & {
    background: none;
    border-radius: 0;
    font-weight: var(--normal);
    padding: 0;
  }
`;
function BaseStatusLabel({
  active = false,
  className,
  icon,
  label,
  status,
  ...unhandledProps
}) {
  return /* @__PURE__ */ React34.createElement(Wrapper16, {
    "aria-label": label,
    active,
    className,
    status,
    ...unhandledProps
  }, icon && /* @__PURE__ */ React34.createElement(Icon_default, {
    icon
  }), /* @__PURE__ */ React34.createElement(Label5, null, label));
}
BaseStatusLabel.propTypes = {
  active: PropTypes26.bool,
  className: PropTypes26.string,
  icon: PropTypes26.string,
  label: PropTypes26.string,
  status: PropTypes26.oneOf([ARCHIVED, DRAFT, PUBLISHED, SCHEDULED])
};
var StatusLabel_default = styled34(BaseStatusLabel)``;
function BaseContentStatus({ className, published = false, state }) {
  const status = getStatus(state, published);
  const active = status === PUBLISHED;
  const label = labels[status];
  const icon = getIcon(status);
  return /* @__PURE__ */ React34.createElement(BaseStatusLabel, {
    active,
    status,
    className,
    icon,
    label
  });
}
BaseContentStatus.propTypes = {
  className: PropTypes26.string,
  published: PropTypes26.bool,
  state: PropTypes26.oneOf([ARCHIVED, DRAFT, PUBLISHED, SCHEDULED])
};
var ContentStatus = styled34(BaseContentStatus)``;

// src/Page.js
var Page_default = styled35.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 870px;
  padding: 0 0 100px 0;
  width: 100%;
`;
var PageHeader = styled35.div.attrs(() => ({
  "data-no-print": true,
  "data-appcues": "page-header"
}))`
  background-color: var(--white);
  border-bottom: 1px solid var(--ui-horizontal-separator);
  padding-left: 60px;
  padding-right: 60px;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;

  > ${H1} {
    width: 50%;
  }

  ${H1} {
    font-size: var(--x-large);
    font-weight: var(--normal);
    letter-spacing: 0;
    line-height: 1.5em;
  }
`;
var PageTitle = styled35.div.attrs({ "data-appcues": "page-title" })`
  align-items: center;
  display: flex;
  position: relative;

  > ${ContentStatus} {
    margin-left: 16px;
  }
`;
var PageActions = styled35.div.attrs({ "data-appcues": "page-actions" })`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
var PageReturn = styled35(Link_default).attrs({
  children: /* @__PURE__ */ React35.createElement(Icon_default, {
    icon: "chevron-left"
  })
})`
  height: 24px;
  width: 24px;
  position: absolute;
  top: 8px;
  left: -32px;
  color: var(--blurple);
`;
var PageSubheader = styled35.div`
  width: 100%;
  color: var(--sharkbait-ooh-la-la);
`;
var PageDescription = styled35.div`
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 100%;
`;
var PageBody = styled35.section.attrs({ "data-appcues": "page-body" })`
  flex-grow: 1;
  margin: 0 auto;
  max-width: 1240px;
  padding: 16px 60px 0;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  @media print {
    padding: 5px;
  }

  @media (max-width: 1240px) {
    max-width: 870px;
  }
`;

// src/Panel.js
import styled36 from "styled-components";
var Header2 = styled36.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
var Title = styled36.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
var Actions = styled36.div`
  display: flex;
  gap: 16px;
`;
var Body4 = styled36.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
var Footer = styled36.footer`
  position: relative;
  text-align: center;
`;
var Section = styled36.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
var SectionTitle = styled36.span`
  font-weight: var(--bold);
  color: var(--heading-primary);
  display: flex;
  align-items: center;

  ${StatusLabel_default} {
    margin-left: 8px;
  }
`;
var Panel_default = styled36.div`
  background-color: white;
  border-radius: 6px;
  box-shadow: var(--level-1);
  width: 100%;
  padding: 8px 0;
  overflow: auto;

  > ${Header2}, ${Body4}, ${Footer} {
    padding: 8px 24px;
  }

  > ${Table} {
    border-top: 1px solid var(--tint-black);
  }
`;

// src/Paragraph.js
import PropTypes27 from "prop-types";
import styled37 from "styled-components";
var Paragraph = styled37.p`
  color: var(--pleather);
  font-size: var(--regular);
  font-weight: ${({ bold }) => bold ? "var(--semi-bold)" : "var(--normal)"};
  letter-spacing: 0;
  line-height: 1.5em;
`;
Paragraph.propTypes = {
  bold: PropTypes27.bool
};
var Paragraph_default = Paragraph;

// src/PrintButton.js
import React36 from "react";
import styled38 from "styled-components";
var PrintButton = () => /* @__PURE__ */ React36.createElement(SquareButton, {
  "aria-label": "Print",
  kind: "secondary",
  icon: "print",
  onClick: () => {
    window.print();
  }
});
var PrintButton_default = styled38(PrintButton)``;

// src/Progress.js
import React37 from "react";
import { Indicator as Indicator2, Root as Root5 } from "@radix-ui/react-progress";
import styled39 from "styled-components";
import PropTypes28 from "prop-types";
var ProgressBar = styled39(Indicator2)`
  background: var(--progress-default);
  height: 100%;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: 0.25s ease;
`;
var Bar = styled39(Root5)`
  height: ${({ $height }) => $height === "regular" && "6px"};
  height: ${({ $height }) => $height === "large" && "8px"};
  min-width: 100px;
  border-radius: 100px;
  overflow: hidden;
  box-shadow: var(--basement);

  &[data-background='light'] {
    background: var(--progress-light);
  }

  &[data-background='dark'] {
    background: var(--progress-dark);
  }

  &[data-value='100'] {
    ${ProgressBar} {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
`;
Bar.propTypes = {
  $height: PropTypes28.oneOf(["regular", "large"])
};
Bar.defaultProps = {
  $height: "regular"
};
function BaseProgress({
  max = 100,
  value = 0,
  background = "light",
  ...unhandledProps
}) {
  return /* @__PURE__ */ React37.createElement(Bar, {
    max,
    value,
    "data-background": background,
    ...unhandledProps
  }, /* @__PURE__ */ React37.createElement(ProgressBar, {
    style: { width: `${value}%` }
  }));
}
BaseProgress.propTypes = {
  background: PropTypes28.oneOf(["dark", "light"]),
  value: PropTypes28.number,
  max: PropTypes28.number,
  $height: PropTypes28.oneOf(["regular", "large"])
};
var Progress = styled39(BaseProgress)``;
Progress.displayName = "Progress";
var SuccessProgress = styled39(Progress)`
  > ${ProgressBar} {
    background: var(--progress-success);
  }
`;
SuccessProgress.displayName = "SuccessProgress";
var ErrorProgress = styled39(Progress)`
  > ${ProgressBar} {
    background: var(--progress-error);
  }
`;
ErrorProgress.displayName = "ErrorProgress";
var TrialProgressBar = styled39(Progress)`
  > ${ProgressBar} {
    background: ${({ $status }) => $status === "regular" && "var(--blues-cues)"};
    background: ${({ $status }) => $status === "warn" && "var(--warn-dark)"};
    background: ${({ $status }) => $status === "alert" && "var(--danger-dark)"};
  }
`;
TrialProgressBar.propTypes = {
  $status: PropTypes28.oneOf(["regular", "warn", "alert"]),
  $height: PropTypes28.oneOf(["regular", "large"])
};
TrialProgressBar.defaultProps = {
  $status: "regular"
};
TrialProgressBar.displayName = "TrialProgressBar";
var Progress_default = Progress;

// src/Radio.js
import React38, { forwardRef as forwardRef15 } from "react";
import styled40 from "styled-components";
import { Item as Item5, Indicator as Indicator3, Root as Root6 } from "@radix-ui/react-radio-group-legacy";
import PropTypes29 from "prop-types";
var StyledItem = styled40(Item5)`
  all: unset;
  border-radius: 100%;
  border: 2px solid var(--radio);
  height: 12px;
  max-width: 12px;
  min-width: 12px;
  transition: ${easing("background-color", "border-color", "box-shadow")};

  &:hover {
    border-color: var(--radio-hover);
  }

  &:focus {
    background: var(--radio-selected-focus-bg);
    box-shadow: 0 0 0 5px var(--radio-selected-focus-bg);
    outline: none;
  }

  &[data-state='checked'] {
    border: 2px solid var(--radio-checked);
  }

  &:disabled {
    border-color: var(--radio-disabled);
  }
`;
var StyledIndicator = styled40(Indicator3)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  &::after {
    content: '';
    background-color: var(--radio-checked);
    border-radius: 100%;
    display: block;
    height: 8px;
    width: 8px;

    @keyframes appear {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    animation: ${easing("appear")};
  }
`;
var Control2 = styled40.div`
  align-items: center;
  display: flex;
  gap: 0.8em;
  min-height: 40px;
  padding: 12px 24px;
  position: relative;
  user-select: none;

  &:hover {
    background-color: var(--radio-group-hover);
    border-radius: 6px;
  }
`;
var Label6 = styled40.label`
  position: relative;
  color: var(--pleather);
  cursor: pointer;
  font-weight: var(--normal);
`;
var Radio = forwardRef15((unhandledProps, ref) => /* @__PURE__ */ React38.createElement(StyledItem, {
  ...unhandledProps,
  ref
}, /* @__PURE__ */ React38.createElement(StyledIndicator, null)));
Radio.propTypes = {
  className: PropTypes29.string,
  children: PropTypes29.node,
  label: PropTypes29.string
};
Radio.displayName = "Radio";
var Radio_default = styled40(Radio)``;
var Group3 = styled40(Root6)``;
Group3.displayName = "RadioGroup";

// src/Skeleton.js
import React39 from "react";
import styled41, { keyframes } from "styled-components";
import PropTypes30 from "prop-types";
var movingGradientAnimation = keyframes`
  0% { background-position: -250px 0; }
  100% { background-position: 250px 0; }
`;
var Skeleton = styled41.div`
  height: ${({ height = 32 }) => Number.isInteger(height) ? `${height}px` : height};
  width: ${({ width = 48 }) => Number.isInteger(width) ? `${width}px` : width};
  background: var(--skeleton-gradient);
  background-size: 500px 100px;
  animation: ${movingGradientAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  border-radius: 6px;
`;
Skeleton.propTypes = {
  width: PropTypes30.oneOfType([PropTypes30.number, PropTypes30.string]),
  height: PropTypes30.oneOfType([PropTypes30.number, PropTypes30.string])
};
var Skeleton_default = Skeleton;
var ImageWrapper = styled41(Skeleton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
var IconWrapper2 = styled41(Icon_default)`
  color: var(--skeleton-icon);
`;
var BaseImageSkeleton = (unhandledProps) => {
  return /* @__PURE__ */ React39.createElement(ImageWrapper, {
    ...unhandledProps
  }, /* @__PURE__ */ React39.createElement(IconWrapper2, {
    icon: "image"
  }));
};
var ImageSkeleton = styled41(BaseImageSkeleton)``;
ImageSkeleton.displayName = "ImageSkeleton";

// src/Spinner.js
import React40, { useEffect as useEffect31, useRef as useRef21 } from "react";
import PropTypes31 from "prop-types";
import styled42, { css as css4, keyframes as keyframes2 } from "styled-components";

// src/hooks/use-toggle.js
import { useState as useState25 } from "react";
function useToggle(initialValue = false) {
  const [value, setValue] = useState25(initialValue);
  const toggle = () => setValue((val) => !val);
  return [value, toggle];
}

// src/Spinner.js
var pulse = keyframes2`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;
var merge = keyframes2`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
  }
`;
var spinner = keyframes2`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;
var move = ($position) => keyframes2`
  0% {
    left: 18px;
    ${$position}: 18px;
  }
  100% {
    left: 18px;
    ${$position}: 42px;
  }
`;
var grow = ($position) => keyframes2`
  0% {
    background: transparent;
    border: 4px solid transparent;

    ${$position === "top" ? `border-bottom-color: var(--primary);` : `border-top-color: var(--primary);`}
  }
  100% {
    background: transparent;
    border: 4px solid transparent;
    height: 50px;
    left: -5px;
    width: 50px;

    ${$position}: -2px;

    ${$position === "top" ? `border-bottom-color: var(--primary);` : `border-top-color: var(--primary);
          `}
  }
`;
var Wrapper17 = styled42.div`
  display: grid;
  grid-template-columns: 1fr;
`;
var Rotate = styled42.div`
  animation: ${pulse} 0.6s ease-in-out 1, ${spinner} 1.5s linear 0.5s infinite;
  background: var(--primary-grad);
  border-radius: 50%;
  display: block;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  position: relative;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`;
var Arc = styled42.div`
  background: var(--primary);
  border-radius: 50%;
  height: 6px;
  left: 18px;
  position: absolute;
  width: 6px;
  transform: translateZ(0);
  will-change: transform;

  ${({ $position }) => css4`
    animation: ${move($position)} 0.5s linear 1 0.5s forwards,
      ${grow($position)} 0.5s linear 1 1s forwards,
      ${merge} 0.5s linear 1 3s forwards;

    ${$position}: 18px;
  `}
`;
var IconWrapper3 = styled42.div`
  align-items: center;
  animation: ${pulse} 0.6s ease-in-out 1;
  background: var(--primary-grad);
  border-radius: 100%;
  display: flex;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  justify-content: center;
  position: absolute;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`;
var Icon2 = styled42(Logo_default)`
  color: var(--white);
  font-size: var(--large);
`;
var Spinner = (unhandledProps) => {
  const $rotate = useRef21();
  const $top = useRef21();
  const $bottom = useRef21();
  const [key, reset] = useToggle();
  useEffect31(() => {
    const timer = setInterval(reset, 3600);
    return () => {
      clearInterval(timer);
    };
  }, [reset]);
  return /* @__PURE__ */ React40.createElement(Wrapper17, {
    "aria-label": "Loading",
    "aria-busy": true,
    "aria-live": "polite",
    key,
    ...unhandledProps
  }, /* @__PURE__ */ React40.createElement(Rotate, {
    ref: $rotate
  }, /* @__PURE__ */ React40.createElement(Arc, {
    $position: "top",
    ref: $top
  }), /* @__PURE__ */ React40.createElement(Arc, {
    $position: "bottom",
    ref: $bottom
  })), /* @__PURE__ */ React40.createElement(IconWrapper3, null, /* @__PURE__ */ React40.createElement(Icon2, null)));
};
Spinner.propTypes = {
  className: PropTypes31.string
};
var Spinner_default = styled42(Spinner)``;

// src/Switch.js
import React41, { useEffect as useEffect32, useState as useState26, useCallback as useCallback11, useMemo as useMemo11 } from "react";
import PropTypes32 from "prop-types";
import styled43 from "styled-components";
var Wrapper18 = styled43.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
var Label7 = styled43.label``;
var Text2 = styled43.span``;
var SwitchWrapper = styled43.div`
  display: flex;
  gap: 12px;
  font-weight: var(--bold);
`;
var InputWrapper3 = styled43.div`
  position: relative;
`;
var HiddenInput = styled43.input`
  cursor: inherit;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
var SwitchInput = styled43.div`
  display: flex;
  width: 32px;
  height: 16px;
  border-radius: 8px;
  position: relative;
  will-change: left, right;
  cursor: pointer;
  padding: 3px;
  outline: none;
  background-color: var(--switch-bg);
  z-index: 1;

  :hover,
  :focus {
    background-color: var(--switch-hover-bg);

    :after {
      background-color: var(--switch-dot-hover-bg);
    }
  }

  :after {
    transition: ${easing("transform")};
    content: '';
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: var(--switch-dot-bg);
  }

  :focus {
    :before {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      right: -4px;
      bottom: -4px;
      border: 2px solid var(--pleather);
      border-radius: 16px;
    }
  }

  :focus:not(:focus-visible) {
    :before {
      boder: none;
    }
  }

  &[aria-checked='true'] {
    background-color: var(--switch-checked-bg);

    :after {
      /* SwitchInput width - after width - SwitchInput padding = 16px*/
      transform: translateX(16px);
      background-color: var(--switch-dot-checked-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-checked-hover-bg);
      :after {
        background-color: var(--switch-dot-checked-hover-bg);
      }
    }
  }

  &[aria-disabled='true'] {
    background-color: var(--switch-disabled-bg);

    :after {
      background-color: var(--switch-dot-disabled-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-disabled-bg);
      :after {
        background-color: var(--switch-dot-disabled-bg);
      }
    }
  }

  &[aria-disabled='true'][aria-checked='true'] {
    background-color: var(--switch-disabled-checked-bg);

    :after {
      transform: translateX(16px);
      background-color: var(--switch-dot-disabled-checked-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-disabled-checked-bg);
      :after {
        background-color: var(--switch-dot-disabled-checked-bg);
      }
    }
  }
`;
function Switch({
  checked: initialValue = false,
  className,
  disabled,
  label,
  onChange,
  onKeyDown,
  textOff,
  textOn,
  ...unhandledProps
}) {
  const [checked, setChecked] = useState26(initialValue);
  const { labelID, textOffID, textOnID } = useMemo11(() => {
    const random = Number.parseInt(Math.random() * Number.MAX_SAFE_INTEGER, 10);
    return {
      labelID: `${random}-label-switch`,
      textOffID: `${random}-text-on-switch`,
      textOnID: `${random}-text-off-switch`
    };
  }, []);
  useEffect32(() => {
    setChecked(initialValue);
  }, [initialValue]);
  const handleChange = useCallback11(
    (event) => {
      if (disabled || event.nativeEvent.defaultPrevented) {
        return;
      }
      event.preventDefault();
      if (onChange) {
        onChange(!checked, event);
        event.persist();
      }
      setChecked(!checked);
    },
    [checked, disabled, onChange]
  );
  const handleKeyDown = useCallback11(
    (event) => {
      if (event.key === " ") {
        event.preventDefault();
        onChange == null ? void 0 : onChange(!checked, event);
        setChecked((isChecked) => !isChecked);
      }
      onKeyDown == null ? void 0 : onKeyDown(event);
    },
    [onKeyDown, onChange, checked]
  );
  return /* @__PURE__ */ React41.createElement(Wrapper18, null, label && /* @__PURE__ */ React41.createElement(Label7, {
    id: labelID
  }, label), /* @__PURE__ */ React41.createElement(SwitchWrapper, null, textOff && /* @__PURE__ */ React41.createElement(Text2, {
    id: textOffID
  }, textOff), /* @__PURE__ */ React41.createElement(InputWrapper3, null, /* @__PURE__ */ React41.createElement(SwitchInput, {
    checked,
    className,
    disabled,
    onClick: handleChange,
    "aria-checked": checked,
    "aria-disabled": disabled,
    onKeyDown: handleKeyDown,
    tabIndex: disabled ? -1 : 0,
    role: "switch",
    "aria-label": "switch input",
    "aria-labelledby": `${labelID} ${textOffID} ${textOnID}`
  }), /* @__PURE__ */ React41.createElement(HiddenInput, {
    "aria-hidden": "true",
    checked,
    disabled,
    onChange: handleChange,
    type: "checkbox",
    tabIndex: "-1",
    ...unhandledProps
  })), textOn && /* @__PURE__ */ React41.createElement(Text2, {
    id: textOnID
  }, textOn)));
}
Switch.propTypes = {
  checked: PropTypes32.bool,
  children: PropTypes32.node,
  className: PropTypes32.string,
  disabled: PropTypes32.bool,
  label: PropTypes32.string,
  textOff: PropTypes32.string,
  textOn: PropTypes32.string,
  onChange: PropTypes32.func,
  onKeyDown: PropTypes32.func
};
var Switch_default = styled43(Switch)``;

// src/Toast.js
import React42 from "react";
import styled44 from "styled-components";
import { Toaster } from "react-hot-toast";
var Wrapper19 = styled44.span`
  --toast-default-background: var(--smurf-blood);
  --toast-default-font-color: var(--white);

  --toast-success-background: var(--ice-ice-baby);
  --toast-success-border-color: var(--cutecumber);
  --toast-success-font-color: var(--pleather);
  --toast-success-icon-color: var(--cutecumber);

  --toast-error-background: var(--bubble-tape);
  --toast-error-border-color: var(--motorola-razr);
  --toast-error-font-color: var(--pleather);
  --toast-error-icon-color: var(--pink-power-ranger);
`;
var Prefix2 = styled44(Icon_default)`
  font-size: var(--large);

  ${({ kind }) => {
  switch (kind) {
    case "success":
      return "color: var(--toast-success-icon-color)";
    case "error":
      return "color: var(--toast-error-icon-color)";
    default:
      return "";
  }
}}
`;
function Toast2() {
  return /* @__PURE__ */ React42.createElement(Wrapper19, null, /* @__PURE__ */ React42.createElement(Toaster, {
    position: "top-center",
    toastOptions: {
      duration: 3e3,
      style: {
        background: "var(--toast-default-background)",
        borderRadius: "12px",
        color: "var(--toast-default-font-color)",
        justifyContent: "flex-start",
        padding: "16px",
        display: "flex",
        gap: "8px"
      },
      success: {
        icon: /* @__PURE__ */ React42.createElement(Prefix2, {
          icon: "check-circle",
          kind: "success"
        }),
        style: {
          background: "var(--toast-success-background)",
          border: "1px solid var(--toast-success-border-color)",
          color: "var(--toast-success-font-color)"
        }
      },
      error: {
        icon: /* @__PURE__ */ React42.createElement(Prefix2, {
          icon: "exclamation-circle",
          kind: "error"
        }),
        style: {
          background: "var(--toast-error-background)",
          border: "1px solid var(--toast-error-border-color)",
          color: "var(--toast-error-font-color)"
        }
      }
    }
  }));
}

// src/Tooltip.js
import React43, {
  Children as Children5,
  cloneElement as cloneElement5,
  useCallback as useCallback12,
  useLayoutEffect as useLayoutEffect7,
  useRef as useRef22,
  useState as useState27
} from "react";
import PropTypes33 from "prop-types";
import styled45 from "styled-components";
import debounce3 from "lodash.debounce";
var Wrapped = styled45.div`
  display: inline-block;

  > * {
    &[disabled] {
      pointer-events: none;
    }
  }
`;
var Reset = styled45.div`
  left: 0;
  position: fixed;
  top: 0;
`;
var Tip = styled45.div`
  background: var(--tooltip-bg);
  border-color: var(--tooltip-bg);
  border-radius: 6px;
  color: var(--white);
  font-weight: var(--normal);
  font-size: var(--x-small);
  line-height: 1.5;
  padding: 10px 12px;
  position: absolute;
  text-align: center;
  white-space: normal;

  ::after {
    border: solid transparent;
    border-width: var(--tooltip-caret-width);
    content: '';
    display: inline-block;
    position: absolute;
  }

  ${Link} {
    color: var(--color-blurple-400);
    :active {
      color: var(--color-blurple-300);
    }
  }

  ${({ size }) => {
  switch (size) {
    case "l":
      return `width: 320px;`;
    case "m":
      return `width: 200px;`;
    case "s":
      return `width: 120px;`;
    default:
      return `white-space: nowrap;`;
  }
}}

  ${({ placement }) => {
  switch (placement) {
    case "top":
      return `
        transform: translateY(calc(-1 * var(--tooltip-caret-width)));

        ::after {
          top: 100%;
          left: calc(50% - var(--tooltip-caret-width));
          border-top-color: inherit;
        }
      `;
    case "right":
      return `
        transform: translateX(var(--tooltip-caret-width));

        ::after {
          right: 100%;
          top: calc(50% - var(--tooltip-caret-width));
          border-right-color: inherit;
        }
      `;
    case "bottom":
      return `
        transform: translateY(var(--tooltip-caret-width));

        ::after {
          bottom: 100%;
          left: calc(50% - var(--tooltip-caret-width));
          border-bottom-color: inherit;
        }
      `;
    case "left":
      return `
        transform: translateX(calc(-1 * var(--tooltip-caret-width)));

        ::after {
          left: 100%;
          top: calc(50% - var(--tooltip-caret-width));
          border-left-color: inherit;
        }
      `;
    default:
      return "";
  }
}}

  ${({ persist }) => !persist && `pointer-events: none;`}
`;
var getBoundingClientRect2 = ($element) => $element ? $element.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, height: 0, width: 0 };
var getPositions2 = ({ attachment, target }) => ({
  top: {
    top: target.top - attachment.height,
    left: target.left + target.width / 2 - attachment.width / 2
  },
  right: {
    top: target.top + target.height / 2 - attachment.height / 2,
    left: target.right
  },
  bottom: {
    top: target.bottom,
    left: target.left + target.width / 2 - attachment.width / 2
  },
  left: {
    top: target.top + target.height / 2 - attachment.height / 2,
    left: target.left - attachment.width
  }
});
var usePosition2 = ({ placement, visible }) => {
  const target = useRef22();
  const attachment = useRef22();
  const [position, setPosition] = useState27({});
  const reposition = useCallback12(() => {
    const { current: $target } = target;
    const { current: $attachment } = attachment;
    const targetRect = getBoundingClientRect2($target);
    const attachmentRect = getBoundingClientRect2($attachment);
    const positions = getPositions2({
      attachment: attachmentRect,
      target: targetRect
    });
    setPosition(positions[placement]);
  }, [placement]);
  useLayoutEffect7(() => {
    if (!visible) {
      return;
    }
    const handler = debounce3(reposition, 16, { leading: true });
    setTimeout(reposition);
    window.addEventListener("resize", handler);
    window.addEventListener("scroll", handler);
    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("scroll", handler);
    };
  }, [reposition, visible]);
  return [{ attachment, target }, position];
};
function Tooltip({
  children,
  className,
  delay = 100,
  disabled = false,
  label,
  persist = false,
  placement = "top",
  size,
  timeout = 200,
  visible: forced,
  wrapped = false
}) {
  const [open, setOpen] = useState27(false);
  const visible = forced != null ? forced : open;
  const [refs, position] = usePosition2({ placement, visible });
  if (disabled) {
    return typeof children === "function" ? children() : children;
  }
  const handleMouseOver = () => {
    setOpen(true);
  };
  const handleMouseOut = () => {
    setOpen(false);
  };
  const renderTarget = () => {
    const unhandledProps = {
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      ref: refs.target,
      className
    };
    if (wrapped) {
      return /* @__PURE__ */ React43.createElement(Wrapped, {
        ...unhandledProps
      }, children);
    }
    const child = Children5.only(children);
    return cloneElement5(child, unhandledProps);
  };
  return /* @__PURE__ */ React43.createElement(React43.Fragment, null, renderTarget(), /* @__PURE__ */ React43.createElement(Portal_default, {
    timeout: delay + timeout
  }, /* @__PURE__ */ React43.createElement(Reset, null, /* @__PURE__ */ React43.createElement(Fade_default, {
    delay,
    from: "center",
    timeout,
    visible
  }, /* @__PURE__ */ React43.createElement(Tip, {
    className,
    placement,
    ref: refs.attachment,
    role: "tooltip",
    size,
    style: position,
    persist,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut
  }, typeof label === "function" ? label() : label)))));
}
Tooltip.propTypes = {
  children: PropTypes33.oneOfType([PropTypes33.func, PropTypes33.node]),
  className: PropTypes33.string,
  delay: PropTypes33.number,
  disabled: PropTypes33.bool,
  label: PropTypes33.oneOfType([PropTypes33.func, PropTypes33.node]),
  persist: PropTypes33.bool,
  placement: PropTypes33.oneOf(["top", "right", "bottom", "left"]),
  size: PropTypes33.oneOf(["s", "m", "l"]),
  timeout: PropTypes33.number,
  visible: PropTypes33.bool,
  wrapped: PropTypes33.bool
};
var Tooltip_default = styled45(Tooltip)``;

// src/TextArea.js
import styled46 from "styled-components";
var TextArea = styled46.textarea`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  outline: none;
  padding: 10px 14px;
  width: 100%;
  &::placeholder {
    color: var(--input);
  }
  &:focus {
    border-color: var(--input-focus);
  }
`;
var TextArea_default = TextArea;

// src/TabsNav.js
import styled47 from "styled-components";
var TabsNav = styled47.nav`
  --tablink-active-color: var(--blurple);
  --tablink-resting-color: var(--pleather);

  display: flex;
  flex-direction: row;
  background-color: var(--white);
  box-shadow: var(--level-1);

  ${({ sticky }) => sticky && `
      position: sticky;
      top: 100px;
      z-index: 1;
    `}
`;
var TabsList = styled47.ol``;
var TabItem = styled47.li`
  display: inline-block;
  min-width: 200px;
  padding: 18px 0;
  text-align: center;

  ${({ $active }) => $active && `
      border-bottom: 2px solid var(--tablink-active-color);

      ${Link_default} {
        color: var(--tablink-active-color);
      }
    `}

  ${Link_default} {
    --link-color: var(--tablink-resting-color);
    --link-text-decoration: none;
    --link-hover-color: var(--tablink-active-color);
    --link-visited-color: var(--link-color);
  }
`;

// src/DataList.js
import React45, { useCallback as useCallback13, useEffect as useEffect33, useState as useState28 } from "react";
import { Input as SonarInput } from "@appcues/sonar";
import PropTypes35 from "prop-types";
import styled49, { css as css5 } from "styled-components";
import { useCombobox } from "downshift";

// src/ThreeDotsLoader.js
import React44 from "react";
import PropTypes34 from "prop-types";
import styled48 from "styled-components";
var ThreeDotsLoader = ({ className }) => {
  return /* @__PURE__ */ React44.createElement("div", {
    className: `${className}`
  }, /* @__PURE__ */ React44.createElement("div", {
    className: "dot-loader"
  }, /* @__PURE__ */ React44.createElement("div", {
    className: "bounce1"
  }), /* @__PURE__ */ React44.createElement("div", {
    className: "bounce2"
  }), /* @__PURE__ */ React44.createElement("div", {
    className: "bounce3"
  })));
};
ThreeDotsLoader.propTypes = {
  className: PropTypes34.string
};
var ThreeDotsLoader_default = styled48(ThreeDotsLoader)`
  .dot-loader {
    width: 100%;
    text-align: center;
  }

  .dot-loader > div {
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.dotColor || "#fff"};

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .dot-loader .bounce1 {
    animation-delay: -0.32s;
  }

  .dot-loader .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

// src/DataList.js
function escapeRegExp(string = "") {
  return string.replace(/[$()*+.?[\\\]^{|}-]/g, "\\$&");
}
var Wrapper20 = styled49.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
var OptionList = styled49.ul`
  position: absolute;
  background-color: var(--dropdown-bg);
  border-color: var(--dropdown-inactive);
  border-radius: 6px;
  box-shadow: var(--dropdown-menu-shadow);
  cursor: pointer;
  list-style-type: none;
  max-height: ${maxMenuHeight}px;
  overflow-y: auto;
  padding: 8px;
  z-index: var(--z-index-300);
  margin-top: 8px;
`;
var Option2 = styled49.li`
  border-radius: 6px;
  color: var(--dropdown-text);
  padding: 8px;
  user-select: none;

  ${(props) => props.$isFocused && css5`
      background-color: var(--dropdown-option-bg);
      color: var(--dropdown-active);
    `},
`;
var Mark = styled49.mark`
  font-weight: var(--bold);
  color: var(--dropdown-text);
  background-color: unset;
`;
var Heading2 = styled49.div`
  color: var(--dark-resting);
  font-size: var(--xx-small);
  font-weight: var(--normal);
  padding: 4px 8px;
  text-transform: uppercase;
  user-select: none;
`;
var getPattern = (value) => new RegExp(`(${escapeRegExp(String(value))})`, "i");
var DEFAULT_SUGGESTIONS = [];
function DataList({
  value = "",
  suggestions = DEFAULT_SUGGESTIONS,
  loading = false,
  useSonar = false,
  onSelectedItemChange,
  ...unhandledProps
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const [matches, setMatches] = useState28(suggestions);
  const handleInputValueChange = useCallback13(
    ({ inputValue: inputValue2 }) => {
      const pattern2 = getPattern(inputValue2 ? String(inputValue2) : "");
      setMatches([
        ...new Set(suggestions.filter((suggestion) => pattern2.test(suggestion)))
      ]);
    },
    [suggestions]
  );
  const SuggestionInput = useSonar ? SonarInput : Input_default;
  const {
    getInputProps,
    getItemProps,
    getMenuProps,
    highlightedIndex,
    inputValue,
    isOpen,
    openMenu
  } = useCombobox({
    items: matches,
    initialInputValue: value,
    onInputValueChange: handleInputValueChange,
    onSelectedItemChange
  });
  useEffect33(() => {
    handleInputValueChange({ inputValue });
  }, [handleInputValueChange, inputValue, suggestions]);
  const [refs, position] = usePosition({ placement: "left", visible: isOpen });
  const targetInputWidth = (useSonar ? (_b = (_a = refs.target) == null ? void 0 : _a.current) == null ? void 0 : _b.parentElement.offsetWidth : (_d = (_c = refs.target) == null ? void 0 : _c.current) == null ? void 0 : _d.offsetWidth) || 0;
  const pattern = getPattern(inputValue);
  const [firstSuggestion] = suggestions;
  const hasMatches = matches.length > 0;
  const showMenu = isOpen && (hasMatches || loading);
  const handleFocus = () => {
    if (!isOpen) {
      openMenu();
    }
  };
  const offset = ((((_f = (_e = refs.target) == null ? void 0 : _e.current) == null ? void 0 : _f.parentElement.offsetWidth) || 0) - (((_h = (_g = refs.target) == null ? void 0 : _g.current) == null ? void 0 : _h.offsetWidth) || 0)) / 2;
  return /* @__PURE__ */ React45.createElement(Wrapper20, null, /* @__PURE__ */ React45.createElement(SuggestionInput, {
    type: "text",
    ...getInputProps({
      placeholder: firstSuggestion && `e.g. ${firstSuggestion}`,
      onFocus: handleFocus,
      ref: refs.target,
      ...unhandledProps
    })
  }), /* @__PURE__ */ React45.createElement(Portal_default, null, /* @__PURE__ */ React45.createElement(OptionList, {
    ...getMenuProps({
      ref: refs.attachment,
      style: showMenu ? {
        top: position.top,
        left: useSonar ? position.left - offset : position.left,
        width: targetInputWidth,
        position: "fixed"
      } : { display: "none" }
    })
  }, hasMatches && /* @__PURE__ */ React45.createElement(React45.Fragment, null, /* @__PURE__ */ React45.createElement(Heading2, {
    role: "heading"
  }, "Example values"), matches.map((match, index) => /* @__PURE__ */ React45.createElement(Option2, {
    $isFocused: highlightedIndex === index,
    key: match,
    ...getItemProps({ item: match, index })
  }, match.split(pattern).map(
    (part, partialIndex) => inputValue && pattern.test(part) ? /* @__PURE__ */ React45.createElement(Mark, {
      key: partialIndex
    }, part) : part
  )))), loading && /* @__PURE__ */ React45.createElement(ThreeDotsLoader_default, {
    dotColor: "#5C5CFF"
  }))));
}
DataList.propTypes = {
  value: PropTypes35.string,
  suggestions: PropTypes35.arrayOf(PropTypes35.string),
  loading: PropTypes35.bool,
  onSelectedItemChange: PropTypes35.func,
  useSonar: PropTypes35.bool
};
var DataList_default = styled49(DataList)``;

// src/SonarDataList.js
import React46, { useCallback as useCallback14, useEffect as useEffect34, useState as useState29, useMemo as useMemo12 } from "react";
import { Input as SonarInput2 } from "@appcues/sonar";
import PropTypes36 from "prop-types";
import styled50, { css as css6 } from "styled-components";
import { useCombobox as useCombobox2 } from "downshift";
import debounce4 from "lodash.debounce";
function escapeRegExp2(string = "") {
  return string.replace(/[$()*+.?[\\\]^{|}-]/g, "\\$&");
}
var Wrapper21 = styled50.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
var OptionList2 = styled50.ul`
  position: absolute;
  background-color: var(--dropdown-bg);
  border-color: var(--dropdown-inactive);
  border-radius: 6px;
  box-shadow: var(--dropdown-menu-shadow);
  cursor: pointer;
  list-style-type: none;
  max-height: ${maxMenuHeight}px;
  overflow-y: auto;
  padding: 8px;
  z-index: var(--z-index-300);
  margin-top: 8px;
`;
var Option3 = styled50.li`
  border-radius: 6px;
  color: var(--dropdown-text);
  padding: 8px;
  user-select: none;

  ${(props) => props.$isFocused && css6`
      background-color: var(--dropdown-option-bg);
      color: var(--dropdown-active);
    `},
`;
var Mark2 = styled50.mark`
  font-weight: var(--bold);
  color: var(--dropdown-text);
  background-color: unset;
`;
var Heading3 = styled50.div`
  color: var(--dark-resting);
  font-size: var(--xx-small);
  font-weight: var(--normal);
  padding: 4px 8px;
  text-transform: uppercase;
  user-select: none;
`;
var getPattern2 = (value) => new RegExp(`(${escapeRegExp2(String(value))})`, "i");
var DEFAULT_SUGGESTIONS2 = [];
function DataList2({
  value = "",
  suggestions = DEFAULT_SUGGESTIONS2,
  loading = false,
  onSelectedItemChange,
  onChange,
  label = "Example values",
  ...unhandledProps
}) {
  var _a, _b, _c, _d, _e, _f;
  const [matches, setMatches] = useState29(suggestions);
  const [localInputValue, setLocalInputValue] = useState29(value);
  const debouncedOnChange = useMemo12(
    () => debounce4((inputValue2) => {
      if (onChange) {
        onChange({ target: { value: inputValue2 } });
      }
    }, 300),
    [onChange]
  );
  const handleInputValueChange = useCallback14(
    ({ inputValue: inputValue2 }) => {
      setLocalInputValue(inputValue2);
      const pattern2 = getPattern2(inputValue2 ? String(inputValue2) : "");
      setMatches([
        ...new Set(suggestions.filter((suggestion) => pattern2.test(suggestion)))
      ]);
      debouncedOnChange(inputValue2);
    },
    [suggestions, debouncedOnChange]
  );
  useEffect34(() => {
    if (value !== localInputValue) {
      setLocalInputValue(value);
    }
  }, [value, localInputValue]);
  useEffect34(() => {
    return () => {
      debouncedOnChange.cancel();
    };
  }, [debouncedOnChange]);
  const handleBlur = (event) => {
    const currentInputValue = localInputValue;
    const isValidSuggestion = suggestions.includes(currentInputValue);
    const isEmpty = !currentInputValue.trim();
    if (!isValidSuggestion && !isEmpty && currentInputValue !== value) {
      setLocalInputValue(value);
      debouncedOnChange.cancel();
      if (unhandledProps.onBlur) {
        const modifiedEvent = {
          ...event,
          target: { ...event.target, value }
        };
        unhandledProps.onBlur(modifiedEvent);
      }
    } else if (unhandledProps.onBlur) {
      unhandledProps.onBlur(event);
    }
  };
  const {
    getInputProps,
    getItemProps,
    getMenuProps,
    highlightedIndex,
    inputValue,
    isOpen,
    openMenu
  } = useCombobox2({
    items: matches,
    inputValue: localInputValue,
    onInputValueChange: handleInputValueChange,
    onSelectedItemChange
  });
  useEffect34(() => {
    handleInputValueChange({ inputValue });
  }, [handleInputValueChange, inputValue, suggestions]);
  const [refs, position] = usePosition({ placement: "left", visible: isOpen });
  const targetInputWidth = (_b = (_a = refs.target) == null ? void 0 : _a.current) == null ? void 0 : _b.parentElement.offsetWidth;
  const pattern = getPattern2(inputValue);
  const [firstSuggestion] = suggestions;
  const hasMatches = matches.length > 0;
  const showMenu = isOpen && (hasMatches || loading);
  const handleFocus = () => {
    if (!isOpen) {
      openMenu();
    }
  };
  const offset = ((((_d = (_c = refs.target) == null ? void 0 : _c.current) == null ? void 0 : _d.parentElement.offsetWidth) || 0) - (((_f = (_e = refs.target) == null ? void 0 : _e.current) == null ? void 0 : _f.offsetWidth) || 0)) / 2;
  return /* @__PURE__ */ React46.createElement(Wrapper21, null, /* @__PURE__ */ React46.createElement(SonarInput2, {
    type: "text",
    ...getInputProps({
      placeholder: firstSuggestion && `e.g. ${firstSuggestion}`,
      onFocus: handleFocus,
      ref: refs.target,
      ...unhandledProps,
      onChange: void 0,
      onBlur: handleBlur
    })
  }), /* @__PURE__ */ React46.createElement(Portal_default, null, /* @__PURE__ */ React46.createElement(OptionList2, {
    ...getMenuProps({
      ref: refs.attachment,
      style: showMenu ? {
        top: position.top,
        left: position.left - offset,
        width: targetInputWidth,
        position: "fixed"
      } : { display: "none" }
    })
  }, hasMatches && /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(Heading3, {
    role: "heading"
  }, label), matches.map((match, index) => /* @__PURE__ */ React46.createElement(Option3, {
    $isFocused: highlightedIndex === index,
    key: match,
    ...getItemProps({ item: match, index })
  }, match.split(pattern).map(
    (part, partialIndex) => inputValue && pattern.test(part) ? /* @__PURE__ */ React46.createElement(Mark2, {
      key: partialIndex
    }, part) : part
  )))), loading && /* @__PURE__ */ React46.createElement(ThreeDotsLoader_default, {
    dotColor: "#5C5CFF"
  }))));
}
DataList2.propTypes = {
  value: PropTypes36.string,
  suggestions: PropTypes36.arrayOf(PropTypes36.string),
  loading: PropTypes36.bool,
  onSelectedItemChange: PropTypes36.func,
  onChange: PropTypes36.func,
  useSonar: PropTypes36.bool,
  label: PropTypes36.string
};
var SonarDataList_default = styled50(DataList2)``;

// src/Form.js
import styled51 from "styled-components";
var Form_default = styled51.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${Label_default} {
    position: relative;

    ${ErrorMsg} {
      position: absolute;
      bottom: -21px;
    }
  }

  ${Select} {
    max-width: 100%;
  }

  ${ButtonGroup} {
    margin-top: 8px;
  }
`;

// ../../node_modules/@radix-ui/react-id/dist/index.module.js
import * as e10 from "react";
var r8 = e10["useId".toString()] || (() => {
});
var n4 = 0;
function useId2(o17) {
  const [u6, i6] = e10.useState(r8());
  return useLayoutEffect4(() => {
    o17 || i6((t18) => null != t18 ? t18 : String(n4++));
  }, [o17]), o17 || (u6 ? `radix-${u6}` : "");
}

// ../../node_modules/@radix-ui/react-slot/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o9 from "react";
function composeRefs2(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}

// ../../node_modules/@radix-ui/react-slot/dist/index.module.js
import * as t11 from "react";
var Slot2 = /* @__PURE__ */ t11.forwardRef((e16, o17) => {
  const { children: a5, ...s8 } = e16;
  return t11.Children.toArray(a5).some(l6) ? /* @__PURE__ */ t11.createElement(t11.Fragment, null, t11.Children.map(a5, (e17) => l6(e17) ? /* @__PURE__ */ t11.createElement(n5, _extends({}, s8, { ref: o17 }), e17.props.children) : e17)) : /* @__PURE__ */ t11.createElement(n5, _extends({}, s8, { ref: o17 }), a5);
});
Slot2.displayName = "Slot";
var n5 = /* @__PURE__ */ t11.forwardRef((r18, n7) => {
  const { children: l8, ...a5 } = r18;
  return t11.isValidElement(l8) ? /* @__PURE__ */ t11.cloneElement(l8, { ...o10(a5, l8.props), ref: composeRefs2(n7, l8.ref) }) : t11.Children.count(l8) > 1 ? t11.Children.only(null) : null;
});
n5.displayName = "SlotClone";
var Slottable2 = ({ children: e16 }) => /* @__PURE__ */ t11.createElement(t11.Fragment, null, e16);
function l6(e16) {
  return t11.isValidElement(e16) && e16.type === Slottable2;
}
function o10(e16, t18) {
  const r18 = { ...t18 };
  for (const n7 in t18) {
    const l8 = e16[n7], o17 = t18[n7];
    /^on[A-Z]/.test(n7) ? r18[n7] = (...e17) => {
      null == o17 || o17(...e17), null == l8 || l8(...e17);
    } : "style" === n7 ? r18[n7] = { ...l8, ...o17 } : "className" === n7 && (r18[n7] = [l8, o17].filter(Boolean).join(" "));
  }
  return { ...e16, ...r18 };
}

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r9 from "react";
var Primitive2 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o17, i6) => ({ ...o17, [i6]: /* @__PURE__ */ r9.forwardRef((o18, m5) => {
  const { asChild: a5, ...s8 } = o18, n7 = a5 ? Slot2 : i6;
  return r9.useEffect(() => {
    window[Symbol.for("radix-ui")] = true;
  }, []), /* @__PURE__ */ r9.createElement(n7, _extends({}, s8, { ref: m5 }));
}) }), {});

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o11 from "react";
function composeRefs3(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}
function useComposedRefs2(...e16) {
  return o11.useCallback(composeRefs3(...e16), e16);
}

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-presence/dist/index.module.js
import * as t12 from "react";
var Presence2 = (u6) => {
  const { present: o17, children: i6 } = u6, s8 = function(n7) {
    const [u7, o18] = t12.useState(), i7 = t12.useRef({}), s9 = t12.useRef(n7), c9 = t12.useRef("none"), a6 = n7 ? "mounted" : "unmounted", [d9, m5] = function(e16, n8) {
      return t12.useReducer((e17, t18) => {
        const r18 = n8[e17][t18];
        return null != r18 ? r18 : e17;
      }, e16);
    }(a6, { mounted: { UNMOUNT: "unmounted", ANIMATION_OUT: "unmountSuspended" }, unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" }, unmounted: { MOUNT: "mounted" } });
    return t12.useEffect(() => {
      const e16 = r10(i7.current);
      c9.current = "mounted" === d9 ? e16 : "none";
    }, [d9]), useLayoutEffect4(() => {
      const e16 = i7.current, t18 = s9.current;
      if (t18 !== n7) {
        const u8 = c9.current, o19 = r10(e16);
        if (n7)
          m5("MOUNT");
        else if ("none" === o19 || "none" === (null == e16 ? void 0 : e16.display))
          m5("UNMOUNT");
        else {
          const e17 = u8 !== o19;
          m5(t18 && e17 ? "ANIMATION_OUT" : "UNMOUNT");
        }
        s9.current = n7;
      }
    }, [n7, m5]), useLayoutEffect4(() => {
      if (u7) {
        const e16 = (e17) => {
          const n9 = r10(i7.current).includes(e17.animationName);
          e17.target === u7 && n9 && m5("ANIMATION_END");
        }, n8 = (e17) => {
          e17.target === u7 && (c9.current = r10(i7.current));
        };
        return u7.addEventListener("animationstart", n8), u7.addEventListener("animationcancel", e16), u7.addEventListener("animationend", e16), () => {
          u7.removeEventListener("animationstart", n8), u7.removeEventListener("animationcancel", e16), u7.removeEventListener("animationend", e16);
        };
      }
      m5("ANIMATION_END");
    }, [u7, m5]), { isPresent: ["mounted", "unmountSuspended"].includes(d9), ref: t12.useCallback((e16) => {
      e16 && (i7.current = getComputedStyle(e16)), o18(e16);
    }, []) };
  }(o17), c8 = "function" == typeof i6 ? i6({ present: s8.isPresent }) : t12.Children.only(i6), a5 = useComposedRefs2(s8.ref, c8.ref);
  return "function" == typeof i6 || s8.isPresent ? /* @__PURE__ */ t12.cloneElement(c8, { ref: a5 }) : null;
};
function r10(e16) {
  return (null == e16 ? void 0 : e16.animationName) || "none";
}
Presence2.displayName = "Presence";

// ../../node_modules/@radix-ui/react-portal/node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r11 from "react";
var Primitive3 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o17, i6) => ({ ...o17, [i6]: /* @__PURE__ */ r11.forwardRef((o18, m5) => {
  const { asChild: a5, ...s8 } = o18, n7 = a5 ? Slot2 : i6;
  return r11.useEffect(() => {
    window[Symbol.for("radix-ui")] = true;
  }, []), /* @__PURE__ */ r11.createElement(n7, _extends({}, s8, { ref: m5 }));
}) }), {});

// ../../node_modules/@radix-ui/react-portal/dist/index.module.js
import e11 from "react-dom";
import * as r12 from "react";
var Portal3 = /* @__PURE__ */ r12.forwardRef((a5, i6) => {
  var n7, d9;
  const { containerRef: s8, style: u6, ...c8 } = a5, m5 = null !== (n7 = null == s8 ? void 0 : s8.current) && void 0 !== n7 ? n7 : null === globalThis || void 0 === globalThis || null === (d9 = globalThis.document) || void 0 === d9 ? void 0 : d9.body, [, f7] = r12.useState({});
  return useLayoutEffect4(() => {
    f7({});
  }, []), m5 ? /* @__PURE__ */ e11.createPortal(/* @__PURE__ */ r12.createElement(Primitive3.div, _extends({ "data-radix-portal": "" }, c8, { ref: i6, style: m5 === document.body ? { position: "absolute", top: 0, left: 0, zIndex: 2147483647, ...u6 } : void 0 })), m5) : null;
});

// ../../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r13 from "react";
var Primitive4 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o17, i6) => ({ ...o17, [i6]: /* @__PURE__ */ r13.forwardRef((o18, m5) => {
  const { asChild: a5, ...s8 } = o18, n7 = a5 ? Slot2 : i6;
  return r13.useEffect(() => {
    window[Symbol.for("radix-ui")] = true;
  }, []), /* @__PURE__ */ r13.createElement(n7, _extends({}, s8, { ref: m5 }));
}) }), {});

// ../../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o12 from "react";
function composeRefs4(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}
function useComposedRefs3(...e16) {
  return o12.useCallback(composeRefs4(...e16), e16);
}

// ../../node_modules/@radix-ui/react-focus-scope/dist/index.module.js
import * as o13 from "react";
var c4 = { bubbles: false, cancelable: true };
var FocusScope2 = /* @__PURE__ */ o13.forwardRef((i6, f7) => {
  const { loop: l8 = false, trapped: m5 = false, onMountAutoFocus: p5, onUnmountAutoFocus: v4, ...E4 } = i6, [F2, S2] = o13.useState(null), b3 = useCallbackRef(p5), T2 = useCallbackRef(v4), y2 = o13.useRef(null), L2 = useComposedRefs3(f7, (e16) => S2(e16)), h2 = o13.useRef({ paused: false, pause() {
    this.paused = true;
  }, resume() {
    this.paused = false;
  } }).current;
  o13.useEffect(() => {
    if (m5) {
      let e16 = function(e17) {
        if (h2.paused || !F2)
          return;
        const t19 = e17.target;
        F2.contains(t19) ? y2.current = t19 : a4(y2.current, { select: true });
      }, t18 = function(e17) {
        !h2.paused && F2 && (F2.contains(e17.relatedTarget) || a4(y2.current, { select: true }));
      };
      return document.addEventListener("focusin", e16), document.addEventListener("focusout", t18), () => {
        document.removeEventListener("focusin", e16), document.removeEventListener("focusout", t18);
      };
    }
  }, [m5, F2, h2.paused]), o13.useEffect(() => {
    if (F2) {
      d6.add(h2);
      const t18 = document.activeElement;
      if (!F2.contains(t18)) {
        const n7 = new Event("focusScope.autoFocusOnMount", c4);
        F2.addEventListener("focusScope.autoFocusOnMount", b3), F2.dispatchEvent(n7), n7.defaultPrevented || (!function(e17, { select: t19 = false } = {}) {
          const n8 = document.activeElement;
          for (const o17 of e17)
            if (a4(o17, { select: t19 }), document.activeElement !== n8)
              return;
        }((e16 = r14(F2), e16.filter((e17) => "A" !== e17.tagName)), { select: true }), document.activeElement === t18 && a4(F2));
      }
      return () => {
        F2.removeEventListener("focusScope.autoFocusOnMount", b3), setTimeout(() => {
          const e17 = new Event("focusScope.autoFocusOnUnmount", c4);
          F2.addEventListener("focusScope.autoFocusOnUnmount", T2), F2.dispatchEvent(e17), e17.defaultPrevented || a4(null != t18 ? t18 : document.body, { select: true }), F2.removeEventListener("focusScope.autoFocusOnUnmount", T2), d6.remove(h2);
        }, 0);
      };
    }
    var e16;
  }, [F2, b3, T2, h2]);
  const N = o13.useCallback((e16) => {
    if (!l8 && !m5)
      return;
    if (h2.paused)
      return;
    const t18 = "Tab" === e16.key && !e16.altKey && !e16.ctrlKey && !e16.metaKey, n7 = document.activeElement;
    if (t18 && n7) {
      const t19 = e16.currentTarget, [o17, u6] = function(e17) {
        const t20 = r14(e17), n8 = s6(t20, e17), o18 = s6(t20.reverse(), e17);
        return [n8, o18];
      }(t19);
      o17 && u6 ? e16.shiftKey || n7 !== u6 ? e16.shiftKey && n7 === o17 && (e16.preventDefault(), l8 && a4(u6, { select: true })) : (e16.preventDefault(), l8 && a4(o17, { select: true })) : n7 === t19 && e16.preventDefault();
    }
  }, [l8, m5, h2.paused]);
  return o13.createElement(Primitive4.div, _extends({ tabIndex: -1 }, E4, { ref: L2, onKeyDown: N }));
});
function r14(e16) {
  const t18 = [], n7 = document.createTreeWalker(e16, NodeFilter.SHOW_ELEMENT, { acceptNode: (e17) => {
    const t19 = "INPUT" === e17.tagName && "hidden" === e17.type;
    return e17.disabled || e17.hidden || t19 ? NodeFilter.FILTER_SKIP : e17.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  } });
  for (; n7.nextNode(); )
    t18.push(n7.currentNode);
  return t18;
}
function s6(e16, t18) {
  for (const n7 of e16)
    if (!i4(n7, { upTo: t18 }))
      return n7;
}
function i4(e16, { upTo: t18 }) {
  if ("hidden" === getComputedStyle(e16).visibility)
    return true;
  for (; e16; ) {
    if (void 0 !== t18 && e16 === t18)
      return false;
    if ("none" === getComputedStyle(e16).display)
      return true;
    e16 = e16.parentElement;
  }
  return false;
}
function a4(e16, { select: t18 = false } = {}) {
  if (e16 && e16.focus) {
    const n7 = document.activeElement;
    e16.focus({ preventScroll: true }), e16 !== n7 && function(e17) {
      return e17 instanceof HTMLInputElement && "select" in e17;
    }(e16) && t18 && e16.select();
  }
}
var d6 = function() {
  let e16 = [];
  return { add(t18) {
    const n7 = e16[0];
    t18 !== n7 && (null == n7 || n7.pause()), e16 = f5(e16, t18), e16.unshift(t18);
  }, remove(t18) {
    var n7;
    e16 = f5(e16, t18), null === (n7 = e16[0]) || void 0 === n7 || n7.resume();
  } };
}();
function f5(e16, t18) {
  const n7 = [...e16], o17 = n7.indexOf(t18);
  return -1 !== o17 && n7.splice(o17, 1), n7;
}

// ../../node_modules/@radix-ui/react-use-body-pointer-events/dist/index.module.js
import * as t13 from "react";
var n6;
var o14 = 0;
function useBodyPointerEvents2({ disabled: r18 }) {
  const i6 = t13.useRef(false);
  useLayoutEffect4(() => {
    if (r18) {
      let e16 = function() {
        o14--, 0 === o14 && (document.body.style.pointerEvents = n6);
      }, t18 = function(e17) {
        i6.current = "mouse" !== e17.pointerType;
      };
      return 0 === o14 && (n6 = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", o14++, document.addEventListener("pointerup", t18), () => {
        i6.current ? document.addEventListener("click", e16, { once: true }) : e16(), document.removeEventListener("pointerup", t18);
      };
    }
  }, [r18]);
}

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o15 from "react";
function composeRefs5(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}
function useComposedRefs4(...e16) {
  return o15.useCallback(composeRefs5(...e16), e16);
}

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r15 from "react";
var Primitive5 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o17, i6) => ({ ...o17, [i6]: /* @__PURE__ */ r15.forwardRef((o18, m5) => {
  const { asChild: a5, ...s8 } = o18, n7 = a5 ? Slot2 : i6;
  return r15.useEffect(() => {
    window[Symbol.for("radix-ui")] = true;
  }, []), /* @__PURE__ */ r15.createElement(n7, _extends({}, s8, { ref: m5 }));
}) }), {});

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/primitive/dist/index.module.js
function composeEventHandlers2(e16, n7, { checkForDefaultPrevented: t18 = true } = {}) {
  return function(r18) {
    if (null == e16 || e16(r18), false === t18 || !r18.defaultPrevented)
      return null == n7 ? void 0 : n7(r18);
  };
}

// ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
import * as i5 from "react";
var u4 = /* @__PURE__ */ i5.createContext({ layers: /* @__PURE__ */ new Set(), layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(), branches: /* @__PURE__ */ new Set() });
var DismissableLayer2 = /* @__PURE__ */ i5.forwardRef((l8, m5) => {
  const { disableOutsidePointerEvents: f7 = false, onEscapeKeyDown: p5, onPointerDownOutside: v4, onFocusOutside: b3, onInteractOutside: E4, onDismiss: y2, ...w3 } = l8, h2 = i5.useContext(u4), [D2, x4] = i5.useState(null), [, C3] = i5.useState({}), L2 = useComposedRefs4(m5, (e16) => x4(e16)), P3 = Array.from(h2.layers), [O3] = [...h2.layersWithOutsidePointerEventsDisabled].slice(-1), g3 = P3.indexOf(O3), B2 = D2 ? P3.indexOf(D2) : -1, R3 = h2.layersWithOutsidePointerEventsDisabled.size > 0, F2 = B2 >= g3, S2 = function(e16) {
    const n7 = useCallbackRef(e16), r18 = i5.useRef(false);
    return i5.useEffect(() => {
      const e17 = (e18) => {
        if (e18.target && !r18.current) {
          d7("dismissableLayer.pointerDownOutside", n7, { originalEvent: e18 });
        }
        r18.current = false;
      }, t18 = window.setTimeout(() => {
        document.addEventListener("pointerdown", e17);
      }, 0);
      return () => {
        window.clearTimeout(t18), document.removeEventListener("pointerdown", e17);
      };
    }, [n7]), { onPointerDownCapture: () => r18.current = true };
  }((e16) => {
    const t18 = e16.target, n7 = [...h2.branches].some((e17) => e17.contains(t18));
    F2 && !n7 && (null == v4 || v4(e16), null == E4 || E4(e16), e16.defaultPrevented || null == y2 || y2());
  }), W = function(e16) {
    const n7 = useCallbackRef(e16), r18 = i5.useRef(false);
    return i5.useEffect(() => {
      const e17 = (e18) => {
        if (e18.target && !r18.current) {
          d7("dismissableLayer.focusOutside", n7, { originalEvent: e18 });
        }
      };
      return document.addEventListener("focusin", e17), () => document.removeEventListener("focusin", e17);
    }, [n7]), { onFocusCapture: () => r18.current = true, onBlurCapture: () => r18.current = false };
  }((e16) => {
    const t18 = e16.target;
    [...h2.branches].some((e17) => e17.contains(t18)) || (null == b3 || b3(e16), null == E4 || E4(e16), e16.defaultPrevented || null == y2 || y2());
  });
  return useEscapeKeydown((e16) => {
    B2 === h2.layers.size - 1 && (null == p5 || p5(e16), e16.defaultPrevented || null == y2 || y2());
  }), useBodyPointerEvents2({ disabled: f7 }), i5.useEffect(() => {
    D2 && (f7 && h2.layersWithOutsidePointerEventsDisabled.add(D2), h2.layers.add(D2), c5());
  }, [D2, f7, h2]), i5.useEffect(() => () => {
    D2 && (h2.layers.delete(D2), h2.layersWithOutsidePointerEventsDisabled.delete(D2), c5());
  }, [D2, h2]), i5.useEffect(() => {
    const e16 = () => C3({});
    return document.addEventListener("dismissableLayer.update", e16), () => document.removeEventListener("dismissableLayer.update", e16);
  }, []), /* @__PURE__ */ i5.createElement(Primitive5.div, _extends({}, w3, { ref: L2, style: { pointerEvents: R3 ? F2 ? "auto" : "none" : void 0, ...l8.style }, onFocusCapture: composeEventHandlers2(l8.onFocusCapture, W.onFocusCapture), onBlurCapture: composeEventHandlers2(l8.onBlurCapture, W.onBlurCapture), onPointerDownCapture: composeEventHandlers2(l8.onPointerDownCapture, S2.onPointerDownCapture) }));
});
function c5() {
  const e16 = new Event("dismissableLayer.update");
  document.dispatchEvent(e16);
}
function d7(e16, t18, n7) {
  const r18 = n7.originalEvent.target, s8 = new CustomEvent(e16, { bubbles: false, cancelable: true, detail: n7 });
  return t18 && r18.addEventListener(e16, t18, { once: true }), !r18.dispatchEvent(s8);
}

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-primitive/dist/index.module.js
import * as r16 from "react";
var Primitive6 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o17, i6) => ({ ...o17, [i6]: /* @__PURE__ */ r16.forwardRef((o18, m5) => {
  const { asChild: a5, ...s8 } = o18, n7 = a5 ? Slot2 : i6;
  return r16.useEffect(() => {
    window[Symbol.for("radix-ui")] = true;
  }, []), /* @__PURE__ */ r16.createElement(n7, _extends({}, s8, { ref: m5 }));
}) }), {});

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-size/dist/index.module.js
import * as e12 from "react";
function useSize2(r18) {
  const [i6, t18] = e12.useState(void 0);
  return e12.useEffect(() => {
    if (r18) {
      const e16 = new ResizeObserver((e17) => {
        if (!Array.isArray(e17))
          return;
        if (!e17.length)
          return;
        const i7 = e17[0];
        let o17, n7;
        if ("borderBoxSize" in i7) {
          const e18 = i7.borderBoxSize, r19 = Array.isArray(e18) ? e18[0] : e18;
          o17 = r19.inlineSize, n7 = r19.blockSize;
        } else {
          const e18 = r18.getBoundingClientRect();
          o17 = e18.width, n7 = e18.height;
        }
        t18({ width: o17, height: n7 });
      });
      return e16.observe(r18, { box: "border-box" }), () => e16.unobserve(r18);
    }
    t18(void 0);
  }, [r18]), i6;
}

// ../../node_modules/@radix-ui/rect/dist/index.module.js
function observeElementRect2(n7, o17) {
  const i6 = e13.get(n7);
  return void 0 === i6 ? (e13.set(n7, { rect: {}, callbacks: [o17] }), 1 === e13.size && (t14 = requestAnimationFrame(c6))) : (i6.callbacks.push(o17), o17(n7.getBoundingClientRect())), () => {
    const c8 = e13.get(n7);
    if (void 0 === c8)
      return;
    const i7 = c8.callbacks.indexOf(o17);
    i7 > -1 && c8.callbacks.splice(i7, 1), 0 === c8.callbacks.length && (e13.delete(n7), 0 === e13.size && cancelAnimationFrame(t14));
  };
}
var t14;
var e13 = /* @__PURE__ */ new Map();
function c6() {
  const n7 = [];
  e13.forEach((t18, e16) => {
    const c8 = e16.getBoundingClientRect();
    var o17, i6;
    o17 = t18.rect, i6 = c8, (o17.width !== i6.width || o17.height !== i6.height || o17.top !== i6.top || o17.right !== i6.right || o17.bottom !== i6.bottom || o17.left !== i6.left) && (t18.rect = c8, n7.push(t18));
  }), n7.forEach((t18) => {
    t18.callbacks.forEach((e16) => e16(t18.rect));
  }), t14 = requestAnimationFrame(c6);
}

// ../../node_modules/@radix-ui/react-use-rect/dist/index.module.js
import * as r17 from "react";
function useRect2(e16) {
  const [o17, c8] = r17.useState();
  return r17.useEffect(() => {
    if (e16) {
      const r18 = observeElementRect2(e16, c8);
      return () => {
        c8(void 0), r18();
      };
    }
  }, [e16]), o17;
}

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-context/dist/index.module.js
import * as e14 from "react";
function createContextScope(n7, o17 = []) {
  let r18 = [];
  const c8 = () => {
    const t18 = r18.map((t19) => /* @__PURE__ */ e14.createContext(t19));
    return function(o18) {
      const r19 = (null == o18 ? void 0 : o18[n7]) || t18;
      return e14.useMemo(() => ({ [`__scope${n7}`]: { ...o18, [n7]: r19 } }), [o18, r19]);
    };
  };
  return c8.scopeName = n7, [function(t18, o18) {
    const c9 = /* @__PURE__ */ e14.createContext(o18), u6 = r18.length;
    function s8(t19) {
      const { scope: o19, children: r19, ...s9 } = t19, i6 = (null == o19 ? void 0 : o19[n7][u6]) || c9, a5 = e14.useMemo(() => s9, Object.values(s9));
      return e14.createElement(i6.Provider, { value: a5 }, r19);
    }
    return r18 = [...r18, o18], s8.displayName = t18 + "Provider", [s8, function(r19, s9) {
      const i6 = (null == s9 ? void 0 : s9[n7][u6]) || c9, a5 = e14.useContext(i6);
      if (a5)
        return a5;
      if (void 0 !== o18)
        return o18;
      throw new Error(`\`${r19}\` must be used within \`${t18}\``);
    }];
  }, t15(c8, ...o17)];
}
function t15(...t18) {
  const n7 = t18[0];
  if (1 === t18.length)
    return n7;
  const o17 = () => {
    const o18 = t18.map((e16) => ({ useScope: e16(), scopeName: e16.scopeName }));
    return function(t19) {
      const r18 = o18.reduce((e16, { useScope: n8, scopeName: o19 }) => ({ ...e16, ...n8(t19)[`__scope${o19}`] }), {});
      return e14.useMemo(() => ({ [`__scope${n7.scopeName}`]: r18 }), [r18]);
    };
  };
  return o17.scopeName = n7.scopeName, o17;
}

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import * as o16 from "react";
function composeRefs6(...o17) {
  return (e16) => o17.forEach((o18) => function(o19, e17) {
    "function" == typeof o19 ? o19(e17) : null != o19 && (o19.current = e17);
  }(o18, e16));
}
function useComposedRefs5(...e16) {
  return o16.useCallback(composeRefs6(...e16), e16);
}

// ../../node_modules/@radix-ui/react-popper/dist/index.module.js
import * as s7 from "react";
var [c7, l7] = createContextScope("Popper");
var [f6, d8] = c7("Popper");
var Popper2 = (e16) => {
  const { __scopePopper: o17, children: r18 } = e16, [t18, n7] = s7.useState(null);
  return s7.createElement(f6, { scope: o17, anchor: t18, onAnchorChange: n7 }, r18);
};
var PopperAnchor2 = /* @__PURE__ */ s7.forwardRef((e16, r18) => {
  const { __scopePopper: t18, virtualRef: n7, ...p5 } = e16, c8 = d8("PopperAnchor", t18), l8 = s7.useRef(null), f7 = useComposedRefs5(r18, l8);
  return s7.useEffect(() => {
    c8.onAnchorChange((null == n7 ? void 0 : n7.current) || l8.current);
  }), n7 ? null : /* @__PURE__ */ s7.createElement(Primitive6.div, _extends({}, p5, { ref: f7 }));
});
var [u5, m4] = c7("PopperContent");
var PopperContent2 = /* @__PURE__ */ s7.forwardRef((e16, n7) => {
  const { __scopePopper: c8, side: l8 = "bottom", sideOffset: f7, align: m5 = "center", alignOffset: w3, collisionTolerance: h2, avoidCollisions: x4 = true, ...v4 } = e16, P3 = d8("PopperContent", c8), [A3, g3] = s7.useState(), E4 = useRect2(P3.anchor), [y2, C3] = s7.useState(null), S2 = useSize2(y2), [R3, O3] = s7.useState(null), _ = useSize2(R3), b3 = useComposedRefs5(n7, (e17) => C3(e17)), z2 = function() {
    const [e17, o17] = s7.useState(void 0);
    return s7.useEffect(() => {
      let e18;
      function r18() {
        o17({ width: window.innerWidth, height: window.innerHeight });
      }
      function t18() {
        window.clearTimeout(e18), e18 = window.setTimeout(r18, 100);
      }
      return r18(), window.addEventListener("resize", t18), () => window.removeEventListener("resize", t18);
    }, []), e17;
  }(), T2 = z2 ? DOMRect.fromRect({ ...z2, x: 0, y: 0 }) : void 0, { popperStyles: k2, arrowStyles: L2, placedSide: B2, placedAlign: D2 } = getPlacementData({ anchorRect: E4, popperSize: S2, arrowSize: _, arrowOffset: A3, side: l8, sideOffset: f7, align: m5, alignOffset: w3, shouldAvoidCollisions: x4, collisionBoundariesRect: T2, collisionTolerance: h2 }), H6 = void 0 !== B2;
  return s7.createElement("div", { style: k2, "data-radix-popper-content-wrapper": "" }, /* @__PURE__ */ s7.createElement(u5, { scope: c8, arrowStyles: L2, onArrowChange: O3, onArrowOffsetChange: g3 }, /* @__PURE__ */ s7.createElement(Primitive6.div, _extends({ "data-side": B2, "data-align": D2 }, v4, { style: { ...v4.style, animation: H6 ? void 0 : "none" }, ref: b3 }))));
});
var Root7 = Popper2;
var Anchor3 = PopperAnchor2;
var Content7 = PopperContent2;

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import * as t16 from "react";
function useControllableState2({ prop: o17, defaultProp: r18, onChange: n7 = () => {
} }) {
  const [a5, u6] = function({ defaultProp: o18, onChange: r19 }) {
    const n8 = t16.useState(o18), [a6] = n8, u7 = t16.useRef(a6), c9 = useCallbackRef(r19);
    return t16.useEffect(() => {
      u7.current !== a6 && (c9(a6), u7.current = a6);
    }, [a6, u7, c9]), n8;
  }({ defaultProp: r18, onChange: n7 }), c8 = void 0 !== o17, f7 = c8 ? o17 : a5, l8 = useCallbackRef(n7);
  return [f7, t16.useCallback((e16) => {
    if (c8) {
      const t18 = e16, r19 = "function" == typeof e16 ? t18(o17) : e16;
      r19 !== o17 && l8(r19);
    } else
      u6(e16);
  }, [c8, o17, u6, l8])];
}

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-context/dist/index.module.js
import * as e15 from "react";
function createContextScope2(n7, o17 = []) {
  let r18 = [];
  const c8 = () => {
    const t18 = r18.map((t19) => /* @__PURE__ */ e15.createContext(t19));
    return function(o18) {
      const r19 = (null == o18 ? void 0 : o18[n7]) || t18;
      return e15.useMemo(() => ({ [`__scope${n7}`]: { ...o18, [n7]: r19 } }), [o18, r19]);
    };
  };
  return c8.scopeName = n7, [function(t18, o18) {
    const c9 = /* @__PURE__ */ e15.createContext(o18), u6 = r18.length;
    function s8(t19) {
      const { scope: o19, children: r19, ...s9 } = t19, i6 = (null == o19 ? void 0 : o19[n7][u6]) || c9, a5 = e15.useMemo(() => s9, Object.values(s9));
      return e15.createElement(i6.Provider, { value: a5 }, r19);
    }
    return r18 = [...r18, o18], s8.displayName = t18 + "Provider", [s8, function(r19, s9) {
      const i6 = (null == s9 ? void 0 : s9[n7][u6]) || c9, a5 = e15.useContext(i6);
      if (a5)
        return a5;
      if (void 0 !== o18)
        return o18;
      throw new Error(`\`${r19}\` must be used within \`${t18}\``);
    }];
  }, t17(c8, ...o17)];
}
function t17(...t18) {
  const n7 = t18[0];
  if (1 === t18.length)
    return n7;
  const o17 = () => {
    const o18 = t18.map((e16) => ({ useScope: e16(), scopeName: e16.scopeName }));
    return function(t19) {
      const r18 = o18.reduce((e16, { useScope: n8, scopeName: o19 }) => ({ ...e16, ...n8(t19)[`__scope${o19}`] }), {});
      return e15.useMemo(() => ({ [`__scope${n7.scopeName}`]: r18 }), [r18]);
    };
  };
  return o17.scopeName = n7.scopeName, o17;
}

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/primitive/dist/index.module.js
function composeEventHandlers3(e16, n7, { checkForDefaultPrevented: t18 = true } = {}) {
  return function(r18) {
    if (null == e16 || e16(r18), false === t18 || !r18.defaultPrevented)
      return null == n7 ? void 0 : n7(r18);
  };
}

// ../../node_modules/@radix-ui/react-popover/dist/index.module.js
import * as v3 from "react";
var [C2, g2] = createContextScope2("Popover", [l7]);
var x3 = l7();
var [h, E3] = C2("Popover");
var Popover = (e16) => {
  const { __scopePopover: o17, children: t18, open: n7, defaultOpen: c8, onOpenChange: a5, modal: s8 = false } = e16, i6 = x3(o17), u6 = v3.useRef(null), [d9, m5] = v3.useState(false), [f7 = false, P3] = useControllableState2({ prop: n7, defaultProp: c8, onChange: a5 });
  return v3.createElement(Root7, i6, /* @__PURE__ */ v3.createElement(h, { scope: o17, contentId: useId2(), triggerRef: u6, open: f7, onOpenChange: P3, onOpenToggle: v3.useCallback(() => P3((e17) => !e17), [P3]), hasCustomAnchor: d9, onCustomAnchorAdd: v3.useCallback(() => m5(true), []), onCustomAnchorRemove: v3.useCallback(() => m5(false), []), modal: s8 }, t18));
};
var PopoverTrigger = /* @__PURE__ */ v3.forwardRef((e16, o17) => {
  const { __scopePopover: r18, ...n7 } = e16, c8 = E3("PopoverTrigger", r18), a5 = x3(r18), s8 = useComposedRefs2(o17, c8.triggerRef), i6 = /* @__PURE__ */ v3.createElement(Primitive2.button, _extends({ type: "button", "aria-haspopup": "dialog", "aria-expanded": c8.open, "aria-controls": c8.contentId, "data-state": w2(c8.open) }, n7, { ref: s8, onClick: composeEventHandlers3(e16.onClick, c8.onOpenToggle) }));
  return c8.hasCustomAnchor ? i6 : /* @__PURE__ */ v3.createElement(Anchor3, _extends({ asChild: true }, a5), i6);
});
var PopoverContent = /* @__PURE__ */ v3.forwardRef((e16, o17) => {
  const { forceMount: r18, ...t18 } = e16, c8 = E3("PopoverContent", e16.__scopePopover);
  return v3.createElement(Presence2, { present: r18 || c8.open }, c8.modal ? /* @__PURE__ */ v3.createElement(A2, _extends({}, t18, { ref: o17 })) : /* @__PURE__ */ v3.createElement(O2, _extends({}, t18, { ref: o17 })));
});
var A2 = /* @__PURE__ */ v3.forwardRef((r18, t18) => {
  const { allowPinchZoom: n7, portalled: c8 = true, ...s8 } = r18, i6 = E3("PopoverContent", r18.__scopePopover), p5 = v3.useRef(null), u6 = useComposedRefs2(t18, p5), l8 = v3.useRef(false);
  v3.useEffect(() => {
    const o17 = p5.current;
    if (o17)
      return hideOthers(o17);
  }, []);
  const d9 = c8 ? Portal3 : v3.Fragment;
  return v3.createElement(d9, null, /* @__PURE__ */ v3.createElement(Combination_default, { allowPinchZoom: n7 }, /* @__PURE__ */ v3.createElement(R2, _extends({}, s8, { ref: u6, trapFocus: i6.open, disableOutsidePointerEvents: true, onCloseAutoFocus: composeEventHandlers3(r18.onCloseAutoFocus, (e16) => {
    var o17;
    e16.preventDefault(), l8.current || null === (o17 = i6.triggerRef.current) || void 0 === o17 || o17.focus();
  }), onPointerDownOutside: composeEventHandlers3(r18.onPointerDownOutside, (e16) => {
    const o17 = e16.detail.originalEvent, r19 = 0 === o17.button && true === o17.ctrlKey, t19 = 2 === o17.button || r19;
    l8.current = t19;
  }, { checkForDefaultPrevented: false }), onFocusOutside: composeEventHandlers3(r18.onFocusOutside, (e16) => e16.preventDefault(), { checkForDefaultPrevented: false }) }))));
});
var O2 = /* @__PURE__ */ v3.forwardRef((e16, o17) => {
  const { portalled: r18 = true, ...t18 } = e16, n7 = E3("PopoverContent", e16.__scopePopover), c8 = v3.useRef(false), s8 = r18 ? Portal3 : v3.Fragment;
  return v3.createElement(s8, null, /* @__PURE__ */ v3.createElement(R2, _extends({}, t18, { ref: o17, trapFocus: false, disableOutsidePointerEvents: false, onCloseAutoFocus: (o18) => {
    var r19, t19;
    (null === (r19 = e16.onCloseAutoFocus) || void 0 === r19 || r19.call(e16, o18), o18.defaultPrevented) || (c8.current || null === (t19 = n7.triggerRef.current) || void 0 === t19 || t19.focus(), o18.preventDefault());
    c8.current = false;
  }, onInteractOutside: (o18) => {
    var r19, t19;
    null === (r19 = e16.onInteractOutside) || void 0 === r19 || r19.call(e16, o18), o18.defaultPrevented || (c8.current = true);
    const a5 = o18.target;
    (null === (t19 = n7.triggerRef.current) || void 0 === t19 ? void 0 : t19.contains(a5)) && o18.preventDefault();
  } })));
});
var R2 = /* @__PURE__ */ v3.forwardRef((e16, o17) => {
  const { __scopePopover: r18, trapFocus: t18, onOpenAutoFocus: n7, onCloseAutoFocus: a5, disableOutsidePointerEvents: u6, onEscapeKeyDown: l8, onPointerDownOutside: d9, onFocusOutside: m5, onInteractOutside: f7, ...C3 } = e16, g3 = E3("PopoverContent", r18), h2 = x3(r18);
  return useFocusGuards(), /* @__PURE__ */ v3.createElement(FocusScope2, { asChild: true, loop: true, trapped: t18, onMountAutoFocus: n7, onUnmountAutoFocus: a5 }, /* @__PURE__ */ v3.createElement(DismissableLayer2, { asChild: true, disableOutsidePointerEvents: u6, onInteractOutside: f7, onEscapeKeyDown: l8, onPointerDownOutside: d9, onFocusOutside: m5, onDismiss: () => g3.onOpenChange(false) }, /* @__PURE__ */ v3.createElement(Content7, _extends({ "data-state": w2(g3.open), role: "dialog", id: g3.contentId }, h2, C3, { ref: o17, style: { ...C3.style, "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)" } }))));
});
function w2(e16) {
  return e16 ? "open" : "closed";
}
var Root8 = Popover;
var Trigger3 = PopoverTrigger;
var Content8 = PopoverContent;

// src/Popover.js
import styled52 from "styled-components";
var PopoverContent2 = styled52(Content8)`
  border-radius: 6px;
  padding: 24px;
  width: ${({ size }) => {
  switch (size) {
    case "large":
      return "508px";
    case "medium":
      return "340px";
    case "regular":
    default:
      return "304px";
  }
}};
  background-color: var(--white);
  box-shadow: var(--level-3);
  margin-top: 16px;
  outline: none;

  ${H2} {
    margin-bottom: 16px;
  }
`;
var PopoverTrigger2 = styled52(Trigger3)``;
var Popover2 = styled52(Root8)`
  border: solid 1px red;
  width: 100px;
  height: 100px;
`;
export {
  Banner_default as Banner,
  BannerGroup,
  Button_default as Button,
  ButtonGroup,
  ButtonLink,
  Caption_default as Caption,
  Card_default as Card,
  Content as CardContent,
  Carousel_default as Carousel,
  Checkbox_default as Checkbox,
  CheckboxGroup,
  CheckboxSelect_default as CheckboxSelect,
  ContentStatus,
  Creatable,
  DataList_default as DataList,
  DateInput_default as DateInput,
  DateRangeDropdown_default as DateRangeDropdown,
  DateRangeInputs_default as DateRangeInputs,
  DateRangePicker_default as DateRangePicker,
  Definition,
  Description3 as Description,
  DescriptiveList,
  Dropdown_default as Dropdown,
  EmptyState_default as EmptyState,
  ErrorMsg,
  ErrorProgress,
  ExpandableText_default as ExpandableText,
  ExternalLink,
  FULL_RANGE_OPTIONS,
  Form_default as Form,
  Fullscreen_default as Fullscreen,
  H1,
  H2,
  H3,
  H4,
  H5,
  Heading,
  HorizontalScroll_default as HorizontalScroll,
  Icon_default as Icon,
  IconButton,
  IconWithinCButton,
  ImageSkeleton,
  Input_default as Input,
  InputClickToCopy,
  Item2 as Item,
  LIMITED_RANGE_OPTIONS,
  Label_default as Label,
  Link,
  List,
  ListRow_default as ListRow,
  Content6 as ListRowContent,
  Logo_default as Logo,
  Menu3 as Menu,
  MenuCheckboxItem2 as MenuCheckboxItem,
  MenuContent2 as MenuContent,
  MenuHeading,
  MenuItem2 as MenuItem,
  MenuList,
  MenuPortalOverride,
  MenuSection,
  MenuSeparator2 as MenuSeparator,
  MenuTrigger,
  Modal_default as Modal,
  ModalFooter,
  MoreMenu_default as MoreMenu,
  NegativeBanner,
  NegativeNotice,
  Notice_default as Notice,
  OptionLabel,
  OptionWrapper,
  Overflow,
  Page_default as Page,
  PageActions,
  PageBody,
  PageDescription,
  PageHeader,
  PageReturn,
  PageSubheader,
  PageTitle,
  Panel_default as Panel,
  Actions as PanelActions,
  Body4 as PanelBody,
  Footer as PanelFooter,
  Header2 as PanelHeader,
  Section as PanelSection,
  SectionTitle as PanelSectionTitle,
  Title as PanelTitle,
  Paragraph_default as Paragraph,
  Popover2 as Popover,
  PopoverContent2 as PopoverContent,
  PopoverTrigger2 as PopoverTrigger,
  Portal_default as Portal,
  PrintButton_default as PrintButton,
  Progress_default as Progress,
  RANGE_OPTIONS,
  Radio_default as Radio,
  Control2 as RadioControl,
  Group3 as RadioGroup,
  Label6 as RadioLabel,
  SearchInput,
  Select,
  Skeleton_default as Skeleton,
  SonarDataList_default as SonarDataList,
  SortDropdown,
  Spinner_default as Spinner,
  SplitButton,
  SquareButton,
  StarCheckbox,
  StatusLabel_default as StatusLabel,
  SuccessMsg,
  SuccessNotice,
  SuccessProgress,
  Switch_default as Switch,
  TabItem,
  Table,
  TabsList,
  TabsNav,
  Tbody,
  Td,
  Term,
  Text_default as Text,
  TextArea_default as TextArea,
  TextClickToCopy,
  Th,
  Thead,
  Toast2 as Toast,
  Tooltip_default as Tooltip,
  Tr,
  TrialProgressBar,
  UILink,
  WarningMsg,
  WarningNotice,
  add,
  calculateDatesFor,
  calendar,
  diff,
  easing,
  endOf,
  format,
  fromNow,
  getEndOfToday,
  getRecommendedFrequency,
  isAfter,
  isBefore,
  normalizeDates,
  parse,
  startOf,
  subtract,
  useDateRange,
  useToggle,
  utc
};
//# sourceMappingURL=index.mjs.map